// src/themes/index.ts
var themes = [
  {
    id: "sheshdash",
    name: "SheshDash",
    nameKey: "theme.sheshdash",
    gradient: "linear-gradient(135deg, #6366f1 0%, #a855f7 100%)",
    playerColors: {
      red: "#ef4444",
      blue: "#3b82f6",
      green: "#10b981",
      orange: "#f59e0b"
    },
    primaryButton: "linear-gradient(135deg, #6366f1 0%, #a855f7 100%)",
    primaryButtonHover: "#4f46e5",
    accentColor: "#6366f1",
    secondaryButton: "#a855f7",
    cardBackground: "#ffffff",
    textPrimary: "#1e293b",
    textSecondary: "#64748b",
    successColor: "#10b981",
    warningColor: "#f59e0b",
    errorColor: "#f43f5e",
    borderColor: "#e2e8f0",
    boardBackground: "#ffffff",
    boardGridLines: "#e2e8f0",
    boardCenterHighlight: "rgba(99, 102, 241, 0.15)",
    boardLabelsColor: "#94a3b8"
  }
];
var getThemeById = (id) => {
  return themes.find((t) => t.id === id) || themes[0];
};
var THEME_STORAGE_KEY = "sheshdash-theme";
var getSavedThemeId = () => {
  return "sheshdash";
};
var saveThemeId = (id) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(THEME_STORAGE_KEY, id);
};

// src/i18n/locales/en.json
var en_default = {
  meta: {
    title: "SheshDash - Multiplayer Board Game",
    description: "A multiplayer board game for 4 players. Move your pieces around the board and be the first to fill your home diagonal!",
    fullDescription: "SheshDash - A multiplayer board game for 2-4 players. Roll dice, move pieces around the board, and be the first to fill all 4 home slots to win!"
  },
  landing: {
    playNow: "Play Now",
    learnRules: "Learn the Rules",
    termsOfService: "Terms of Service",
    supportProject: "Support the Project",
    myAccount: "My Account",
    copyright: "\xA9 2026 SheshDash. Developer: Vadim Maltsev"
  },
  versionBanner: {
    updateAvailable: "A new version is available",
    updateHint: "Current: {{current}}. Latest: {{latest}}. Refresh when you're ready.",
    incompatibleTitle: "This tab is out of date",
    incompatibleHint: "Current: {{current}}. Minimum supported: {{minimum}}. Refresh to continue safely.",
    refreshNow: "Refresh now",
    later: "Later",
    inGameWarning: "You are in an active game. Refreshing will temporarily disconnect you \u2014 you should reconnect automatically.",
    inGameProceed: "Update anyway",
    inGameCancel: "Stay in game"
  },
  game: {
    title: "SheshDash Game",
    gameId: "Game ID",
    copyId: "Copy ID",
    idCopied: "Game ID copied to clipboard!",
    createGame: "Create New Game",
    privateGame: "Private game (hide from online list)",
    joinGame: "Join Existing Game",
    joinGameButton: "Join Game",
    startGame: "Start Game",
    back: "Back",
    yourName: "Your name",
    gameIdPlaceholder: "Game ID",
    connected: "Connected",
    connecting: "Connecting...",
    waitingForPlayers: "Waiting for Players...",
    players: "players",
    shareGameId: "Share the Game ID with friends to join!",
    canStartWithPlayers: "You can start with 2-4 players. Click 'Start Game' when ready!",
    onlyCreatorCanStart: "Only the creator can start the game.",
    needMorePlayers: "Need at least 2 players to start the game.",
    botSuggestion: "Bot suggestion in",
    currentPlayers: "Current Players:",
    yourTurn: "Your Turn!",
    waiting: "Waiting...",
    rolled: "Rolled",
    gameOver: "Game Over!",
    winner: "Winner",
    results: "Final standings",
    place: "Place",
    exitGame: "Exit Game",
    turnTimer: "Time left",
    preferredColor: "Preferred color",
    autoAssignColor: "Auto",
    colorRed: "Red",
    colorBlue: "Blue",
    colorGreen: "Green",
    colorOrange: "Orange",
    pause: "Pause",
    resume: "Resume",
    paused: "Paused",
    pausedHint: "Game is paused. Resume to continue."
  },
  kickVote: {
    confirm: "Remove {{name}} from the game?",
    title: "Remove player?",
    requestsToKick: "wants to remove",
    targetBot: "Target: bot",
    targetHuman: "Target: player",
    votes: "Votes",
    approve: "Approve",
    reject: "Reject",
    waiting: "Waiting for other votes",
    readOnly: "Vote in progress",
    kickedTitle: "You were removed from the game",
    kickedNotice: "Your pieces are now transparent and no longer block play.",
    returnToLobby: "Return to lobby",
    observeGame: "Watch game"
  },
  lobby: {
    onlinePlayers: "Online Players",
    waitingGames: "Public Games",
    findMatch: "Find Online Game",
    cancelMatch: "Cancel Searching",
    searching: "Searching for players...",
    queueCount: "Players in queue: {{count}} / 4",
    onlineCount: "Players online: {{count}}",
    join: "Join",
    creator: "Creator",
    noGames: "No public games available",
    botsOfferTitle: "Start now with bots?",
    botsOfferText: "Missing {{count}} player(s). Start immediately and fill the rest with bots.",
    startWithBots: "Start with bots",
    keepWaiting: "Keep waiting"
  },
  actions: {
    yourActions: "Your Actions",
    rollDice: "Roll the dice to start your turn!",
    needSix: "You need to roll a 6 to place your first piece on the board!",
    rolledSix: "You rolled a 6! Bonus roll guaranteed!",
    rolledSixOptions: [
      "Place a new piece (if available)",
      "OR move an existing piece 6 steps"
    ],
    rolledSixNote: "Either choice gives you another roll!",
    selectPiece: "Select a piece to move {{steps}} steps.",
    selectedPiece: "Selected Piece: {{state}}",
    placePiece: "Place Piece on Board",
    moveSteps: "Move {{steps}} steps",
    deselect: "Deselect"
  },
  instructions: {
    title: "How to Play:",
    rules: [
      "Pieces start off the board; roll a 6 to place one on the starting corner.",
      "Move pieces clockwise around the board",
      "After a full lap, move diagonally through your home slots",
      "The first player to fill all 4 home slots takes 1st place; the game continues until all places are assigned."
    ]
  },
  gameMode: {
    title: "How do you want to play?",
    quickStart: "Quick Start",
    quickStartDesc: "vs 3 bots, starts immediately",
    withFriends: "With Friends",
    withFriendsDesc: "share a code, wait for friends",
    findPlayers: "Find Players",
    findPlayersDesc: "public lobby, anyone can join"
  },
  bots: {
    addTitle: "Add Bot Players",
    addDescription: "No one else has joined yet. Would you like to add bots to start playing?",
    needMore: "You need {{count}} more player(s).",
    addButton: "Add {{count}} Bot",
    addButtonPlural: "Add {{count}} Bots",
    waitForPlayers: "Wait for Players"
  },
  turn: {
    currentTurn: "Current Turn",
    you: "Yours",
    skipped: "Turn skipped",
    completed: "Turn completed"
  },
  errors: {
    error: "Error",
    pathBlocked: "Path is blocked - cannot jump over pieces",
    cannotLandOnOwnPiece: "Cannot land on your own piece",
    pieceInCorner: "Piece is off the board, must roll 6 to place it",
    pieceAlreadyInCenter: "Piece already occupies a finished home slot",
    needToRoll6: "Need to roll a 6 to place piece",
    pieceNotInCorner: "Piece is not off the board",
    pieceNotFound: "Piece not found or not owned by current player",
    notYourTurn: "Not your turn",
    gameNotInProgress: "Game not in progress",
    stepsMustMatchDice: "Steps must match dice roll",
    needExactRollForCenter: "Need exact roll to reach the next free home slot - cannot overshoot",
    onlyCreatorCanStart: "Only the game creator can start the game",
    playerNameTaken: "That player name is already taken in this game"
  },
  pieceStates: {
    in_corner: "Off Board",
    on_perimeter: "On Board",
    on_diagonal: "On Diagonal",
    in_center: "Finished"
  },
  playerInfo: {
    title: "Players",
    you: "(You)",
    turn: "Turn",
    corner: "Off Board:",
    onBoard: "On Board:",
    inCenter: "Finished:",
    waitingFor: "Waiting for {{count}} more player(s)...",
    statusRolled6: "Bonus roll!",
    statusCaptured: "Captured! Bonus!",
    statusPlacedPiece: "Placed piece, Bonus!",
    statusMovedOn6: "Moved 6, Bonus!",
    statusTurnSkipped: "Skipped",
    statusTurnComplete: "Turn done"
  },
  dice: {
    rollDice: "Roll Dice",
    rolled6Message: "You rolled a 6! You can place a new piece OR move an existing piece 6 steps.",
    rolledBy: "Rolled by",
    round: "Round",
    rolls: "Rolls",
    captureBonus: "Capture bonus"
  },
  board: {
    currentPlayer: "Current Player",
    historyStart: "First",
    historyPrev: "Previous",
    historyNext: "Next",
    historyEnd: "Last",
    historyViewingPast: "History mode: actions are disabled"
  },
  rules: {
    title: "Game Rules",
    close: "Close",
    showRules: "Rules",
    objective: {
      title: "Objective",
      description: "Move all 4 of your pieces from the starting corner, around the perimeter, along your home diagonal, and into the 4 finish slots. The first finisher gets 1st place, and play continues until every place is determined."
    },
    setup: {
      title: "Setup",
      items: [
        "Each player starts with 4 pieces off the board (in reserve)",
        "Players take turns clockwise",
        "All pieces start off the board until a 6 is rolled"
      ]
    },
    gameplay: {
      title: "Gameplay",
      items: [
        "Roll the dice to determine how many steps to move",
        "To place your first piece on the board, you must roll a 6",
        "Pieces move clockwise around the outer perimeter (28 positions)",
        "After completing a full lap, pieces enter their home diagonal (4 slots)",
        "You cannot move pieces that are off the board unless you roll a 6"
      ]
    },
    rolling6: {
      title: "Rolling a 6",
      description: "When you roll a 6, you have two options:",
      options: [
        "Place a new piece on the starting corner cell",
        "Move an existing piece 6 steps forward"
      ],
      note: "Either choice gives you a bonus roll! You can keep rolling as long as you get 6s."
    },
    capturing: {
      title: "Capturing",
      items: [
        "If your piece lands EXACTLY on an opponent's piece, you capture it",
        "The captured piece is removed from the board and returned to the opponent's reserve",
        "You cannot capture by jumping over - must land exactly on the position",
        "Capturing gives you a bonus roll (extra turn)"
      ]
    },
    blocking: {
      title: "Blocking",
      description: "You CANNOT jump over other pieces! If any piece (yours or opponent's) blocks your path, you cannot move past it. The entire path must be clear."
    },
    winning: {
      title: "Winning",
      description: "The first player to fill all 4 home slots takes 1st place. The game continues until 2nd, 3rd, and 4th places are determined."
    },
    bonusRolls: {
      title: "Bonus Rolls",
      items: [
        "You get a bonus roll when you roll a 6 (regardless of placement or movement choice)",
        "You get a bonus roll when you capture an opponent's piece",
        "Bonus rolls can chain - if you roll another 6 or capture again, you keep going!"
      ]
    },
    timer: {
      title: "Turn Timer",
      items: [
        "Each player has a limited time to complete their turn",
        "If time runs out, the turn is automatically skipped"
      ]
    }
  },
  hint: {
    button: "Hint",
    title: "Suggested Move",
    noPieces: "No pieces available to place or move",
    canPlace: "You rolled a 6! Place a piece on the starting corner",
    canMove: "Move piece from {{position}} by {{steps}} steps",
    close: "Close"
  },
  theme: {
    sheshdash: "SheshDash",
    toggle: "Toggle theme",
    system: "System",
    light: "Light",
    dark: "Dark"
  },
  tutorial: {
    button: "Tutorial",
    skip: "Skip",
    prev: "Back",
    next: "Next",
    finish: "Finish",
    welcome: {
      title: "Welcome to SheshDash!",
      description: "This quick interactive tutorial will show you how to play. Goal: move all 4 pieces from the starting corner cell to your home slots and finish as high as possible."
    },
    createGame: {
      title: "Create Game",
      description: "Click this button to create a new game. You'll get a unique ID to share with friends."
    },
    addBots: {
      title: "Add Bots",
      description: "If you don't have enough players, you can add bots. The game requires 2-4 players to start."
    },
    startGame: {
      title: "Start Game",
      description: "When all players are ready (minimum 2), click this button to start the game!"
    },
    diceButton: {
      title: "\u{1F3B2} Roll Dice",
      description: "Click this button to roll the dice. You need to roll a 6 to place your first piece on the board!"
    },
    board: {
      title: "\u{1F3AE} Game Board",
      description: "This is the 8\xD78 game board. Pieces enter at the starting corner cell and then move clockwise around the perimeter."
    },
    playerInfo: {
      title: "\u{1F4CA} Player Information",
      description: "Here you can see all players, their pieces, and current turn. Watch who's playing now!"
    },
    selectPiece: {
      title: "\u{1F3AF} Step 1: Select Piece",
      description: "RIGHT HERE is the starting corner cell! When you roll a 6 - click on a piece to bring it onto the board."
    },
    placeButton: {
      title: "\u2705 Step 2: Place Button",
      description: `HERE a "Place Piece on Board" button will appear after selecting a piece. Click it, and the piece will be placed on the starting position! You'll get a bonus roll!`
    },
    moveInstruction: {
      title: "\u{1F463} How to Move a Piece",
      description: 'After rolling the dice: \u2460 Click on your piece on the board \u2461 Press the "Move X steps" button on the right. Remember: you cannot jump over other pieces!'
    },
    goal: {
      title: "\u{1F3C6} Game Goal - HOME DIAGONAL!",
      description: "THERE THEY ARE - the golden cells (a8\u2192b7\u2192c6\u2192d5)! Fill them from the center outward: first d5, then c6, then b7, then a8. The match continues until all places are assigned. Path: perimeter (28 steps) \u2192 home diagonal (4 slots)."
    }
  },
  common: {
    cancel: "Cancel",
    back: "Back",
    confirm: "Confirm",
    close: "Close"
  },
  joinVote: {
    title: "Join Request",
    wantsToJoin: "wants to join the game",
    willReplaceBot: "Will replace a bot",
    keepPieces: "Keep bot's pieces",
    newPieces: "Start with new pieces",
    votes: "Votes",
    approve: "approve",
    reject: "reject",
    total: "total",
    approveButton: "Approve",
    rejectButton: "Reject",
    waiting: "Waiting for other players..."
  },
  joinStarted: {
    title: "Join Running Game",
    gameInProgress: "This game is already in progress.",
    chooseOption: "Choose how you want to join:",
    replaceBot: "Replace a Bot",
    replaceBotHint: "Take over a bot's position",
    newPlayer: "Join as New Player",
    newPlayerHint: "Start fresh with new pieces",
    noOptions: "Cannot join this game - no bots to replace and no empty slots.",
    note: "Note",
    voteRequired: "All players must approve your request to join.",
    replaceBotTitle: "Replace a Bot",
    selectBot: "Select bot to replace:",
    selectBotPlaceholder: "-- Select a bot --",
    keepPieces: "Keep bot's pieces (continue with current position)",
    keepPiecesHint: "You will take over the bot's current pieces and position",
    resetPiecesHint: "Bot's pieces will be reset to starting corner",
    yourName: "Your name",
    sendRequest: "Send Request",
    newPlayerTitle: "Join as New Player",
    newPlayerInfo: "You will join the game with fresh pieces in an available corner.",
    currentPlayers: "Current players",
    lateJoinWarning: "Joining late means other players have a head start!",
    waitingApproval: "Waiting for approval",
    waitingApprovalText: "Players are voting on your request to join."
  },
  userAgreement: {
    title: "User Agreement",
    close: "Close",
    acceptance: {
      title: "1. Acceptance of Terms",
      description: "By using the SheshDash game, you agree to the terms of this User Agreement. If you do not agree to these terms, please do not use the game."
    },
    gameRules: {
      title: "2. Game Rules",
      description: "Players agree to follow the rules of SheshDash. The use of bots is permitted only within the functionality provided by the game. Any attempts at cheating, using hacks, or exploiting vulnerabilities are prohibited."
    },
    intellectualProperty: {
      title: "3. Intellectual Property",
      description: "All rights to the game SheshDash, including the code, design, graphics, server logic, mechanics, and rules, belong to the author Vadim Maltsev. The game name \u201CSheshDash\u201D is reserved by the rightsholder. The project is not open source. Copying, distribution, or modification without the author\u2019s written permission is prohibited."
    },
    userConduct: {
      title: "4. User Conduct",
      items: [
        "Respect other players and do not use offensive language",
        "Do not attempt to hack or disrupt the game",
        "Do not create multiple accounts to gain unfair advantages",
        "Report any bugs and vulnerabilities to the author"
      ]
    },
    disclaimer: {
      title: "5. Disclaimer",
      description: 'The game is provided "as is" without any warranties. The author is not liable for any losses or damages arising from the use of the game.'
    },
    changes: {
      title: "6. Changes to Agreement",
      description: "The author reserves the right to modify the terms of this agreement at any time. Continued use of the game after changes are made constitutes your acceptance of the new terms."
    },
    copyright: "\xA9 2026 SheshDash. All rights reserved.",
    author: "Developer: Vadim Maltsev",
    prohibited: {
      title: "Prohibited actions",
      items: [
        "copy, reproduce, or distribute the game",
        "create clones, modifications, or derivative products",
        "use the code, design, mechanics, or rules of the game",
        "run the game or any part of it under your own name"
      ]
    },
    exclusiveRights: {
      title: "Exclusive rights",
      description: "All exclusive rights to the game belong to the rightsholder."
    },
    legalInfo: {
      title: "Legal information",
      description: "SheshDash is proprietary software. Any copying, distribution, or modification is prohibited without the rightsholder\u2019s written consent."
    }
  },
  navigation: {
    backToHome: "Back to Home"
  },
  donate: {
    title: "Support the Project",
    thankYou: "Thank you for your support!",
    description: "SheshDash is an indie project. Your support helps keep the servers running and enables new features.",
    waysToSupport: "Other Ways to Support",
    spreadWord: "Spread the Word",
    spreadWordDesc: "Share SheshDash with friends and family!",
    reportBugs: "Report Bugs",
    reportBugsDesc: "Help improve the game by reporting issues you find.",
    suggestFeatures: "Suggest Features",
    suggestFeaturesDesc: "Have an idea? Let us know what you would like to see!",
    chooseCountry: "Where are you located?",
    countryHelp: "We show legal options by region. If something isn\u2019t available in your country, the platform will tell you.",
    countryRussia: "Russia",
    countryInternational: "Other countries",
    optionsTitle: "Donate via Boosty",
    platformBoostyTitle: "Boosty",
    platformBoostyDesc: "Memberships and one-time support; payouts to Russian bank cards.",
    platformCloudtipsTitle: "CloudTips",
    platformCloudtipsDesc: "Donations and subscriptions for creators; payouts to cards in Russia.",
    platformDonationAlertsTitle: "DonationAlerts",
    platformDonationAlertsDesc: "Donations for streams; use if you stream SheshDash.",
    platformPatreonTitle: "Patreon",
    platformPatreonDesc: "Memberships for creators. Payouts are unavailable in some countries (including Russia).",
    platformBmacTitle: "Buy Me a Coffee",
    platformBmacDesc: "One-time and recurring support via Stripe; availability depends on country.",
    platformKofiTitle: "Ko-fi",
    platformKofiDesc: "Support via Stripe/PayPal; availability depends on country.",
    platformGithubTitle: "GitHub Sponsors",
    platformGithubDesc: "If the project is open-source and you are in a supported region.",
    statusSetup: "In setup",
    statusCheckCountry: "Check availability",
    statusStreaming: "Only for streams",
    availabilityNote: "If a platform is unavailable in your country, it will not allow payouts or donations.",
    boostyTitle: "Boosty",
    boostyDesc: "One-time or recurring support. Payments are processed by Boosty.",
    boostyButton: "Open Boosty",
    boostyQrAlt: "Boosty donation QR code",
    boostyQrHint: "Scan the QR code to open Boosty."
  },
  account: {
    title: "Account",
    loginTitle: "Sign In",
    loginDesc: "Sign in to track your statistics and game history.",
    loginGoogle: "Sign in with Google",
    loginTelegram: "Sign in with Telegram",
    playAsGuest: "Play as Guest",
    settings: "Account Settings",
    displayName: "Display Name",
    save: "Save",
    saved: "Saved!",
    logout: "Sign Out",
    logoutConfirm: "Are you sure you want to sign out?",
    linkedAccounts: "Linked Accounts",
    memberSince: "Member since",
    dangerZone: "Danger Zone",
    deleteAccount: "Delete Account",
    preferredColor: "Preferred color"
  },
  profile: {
    title: "Player Profile",
    player: "Player",
    gamesPlayed: "Games Played",
    wins: "Wins",
    winRate: "Win Rate",
    secondPlace: "2nd Place",
    thirdPlace: "3rd Place",
    fourthPlace: "4th Place",
    matchHistory: "Match History",
    noMatches: "No matches yet.",
    placement: "Place",
    date: "Date",
    players: "Players",
    loadMore: "Load More"
  },
  leaderboard: {
    title: "Top Players",
    rank: "#",
    player: "Player",
    wins: "Wins",
    games: "Games",
    winRate: "Win %",
    noData: "No games played yet."
  },
  skin: {
    human: "Human",
    guest: "Guest",
    gameStatus: "Game Status",
    gameInProgress: "Game in progress...",
    gameLog: "Game Log",
    noEvents: "No events yet",
    waitingForEvents: "Waiting for game events...",
    gamePaused: "Game paused..."
  },
  admin: {
    title: "Admin Panel",
    accessDenied: "Access only for administrators.",
    goToAccount: "Go to account",
    loadError: "Failed to load admin data",
    announcement: {
      title: "System Announcement",
      placeholder: 'e.g., "Game update in 5 minutes"',
      preview: "Preview",
      publishNow: "Publish now",
      startTime: "Start time",
      endTime: "End time (optional)",
      publish: "Publish",
      publishing: "Publishing...",
      deactivate: "Deactivate",
      deactivateConfirm: "Deactivate the current announcement?",
      message: "Message",
      status: "Status",
      timeWindow: "Window",
      noEndTime: "no end time",
      active: "active",
      inactive: "inactive"
    },
    users: {
      title: "Players",
      player: "Player",
      email: "Email",
      role: "Role",
      ban: "Ban",
      banned: "Banned",
      active: "Active"
    },
    markdown: {
      bold: "bold text",
      italic: "italic",
      code: "code",
      link: "link",
      listItem: "item"
    },
    news: {
      title: "Homepage News",
      versionLabel: "Version",
      versionPlaceholder: "For example: 0.0.26",
      contentLabel: "Implemented in this release",
      contentPlaceholder: "Describe what shipped in this version.",
      publishLabel: "Show on homepage",
      preview: "Preview",
      create: "Create news item",
      update: "Save changes",
      saving: "Saving...",
      cancelEdit: "Cancel",
      edit: "Edit",
      delete: "Delete",
      deleteConfirm: "Delete this news item?",
      published: "published",
      draft: "draft",
      empty: "No news yet.",
      hideBlockLabel: "Hide the entire news block",
      hideItemLabel: "Hide this news item",
      hidden: "hidden",
      subtitle: "The content itself now comes from versioned files in the repository.",
      fileBasedHint: "Edit the language-specific news files in the repository to change homepage news content."
    }
  },
  news: {
    title: "Game News",
    subtitle: "Versions and what is included in them.",
    empty: "No news yet."
  },
  settings: {
    soundOn: "Sound On",
    soundOff: "Sound Off"
  }
};

// src/i18n/locales/ru.json
var ru_default = {
  meta: {
    title: "SheshDash - \u041C\u043D\u043E\u0433\u043E\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0430\u044F \u043D\u0430\u0441\u0442\u043E\u043B\u044C\u043D\u0430\u044F \u0438\u0433\u0440\u0430",
    description: "\u041C\u043D\u043E\u0433\u043E\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0430\u044F \u043D\u0430\u0441\u0442\u043E\u043B\u044C\u043D\u0430\u044F \u0438\u0433\u0440\u0430 \u0434\u043B\u044F 4 \u0438\u0433\u0440\u043E\u043A\u043E\u0432. \u0414\u0432\u0438\u0433\u0430\u0439\u0442\u0435 \u0444\u0438\u0448\u043A\u0438 \u043F\u043E \u0434\u043E\u0441\u043A\u0435 \u0438 \u043F\u0435\u0440\u0432\u044B\u043C \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0441\u0432\u043E\u044E \u0444\u0438\u043D\u0438\u0448\u043D\u0443\u044E \u0434\u0438\u0430\u0433\u043E\u043D\u0430\u043B\u044C!",
    fullDescription: "SheshDash - \u043D\u0430\u0441\u0442\u043E\u043B\u044C\u043D\u0430\u044F \u0438\u0433\u0440\u0430 \u0434\u043B\u044F 2-4 \u0438\u0433\u0440\u043E\u043A\u043E\u0432. \u0411\u0440\u043E\u0441\u0430\u0439\u0442\u0435 \u043A\u0443\u0431\u0438\u043A, \u0434\u0432\u0438\u0433\u0430\u0439\u0442\u0435 \u0444\u0438\u0448\u043A\u0438 \u043F\u043E \u0434\u043E\u0441\u043A\u0435 \u0438 \u043F\u0435\u0440\u0432\u044B\u043C \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0432\u0441\u0435 4 \u0444\u0438\u043D\u0438\u0448\u043D\u044B\u0435 \u043A\u043B\u0435\u0442\u043A\u0438, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0431\u0435\u0434\u0438\u0442\u044C!"
  },
  landing: {
    playNow: "\u0418\u0433\u0440\u0430\u0442\u044C",
    learnRules: "\u0423\u0437\u043D\u0430\u0442\u044C \u043F\u0440\u0430\u0432\u0438\u043B\u0430",
    termsOfService: "\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F",
    supportProject: "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442",
    myAccount: "\u041C\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    copyright: '\xA9 2026 \u0418\u0433\u0440\u0430 "SheshDash". \u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A: Vadim Maltsev'
  },
  versionBanner: {
    updateAvailable: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u043D\u043E\u0432\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F",
    updateHint: "\u0421\u0435\u0439\u0447\u0430\u0441: {{current}}. \u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0430: {{latest}}. \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443, \u043A\u043E\u0433\u0434\u0430 \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u043E\u0431\u043D\u043E.",
    incompatibleTitle: "\u042D\u0442\u0430 \u0432\u043A\u043B\u0430\u0434\u043A\u0430 \u0443\u0441\u0442\u0430\u0440\u0435\u043B\u0430",
    incompatibleHint: "\u0421\u0435\u0439\u0447\u0430\u0441: {{current}}. \u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F: {{minimum}}. \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E.",
    refreshNow: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C",
    later: "\u041F\u043E\u0437\u0436\u0435",
    inGameWarning: "\u0412\u044B \u0432 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0439 \u0438\u0433\u0440\u0435. \u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u0440\u0430\u0437\u043E\u0440\u0432\u0451\u0442 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u2014 \u043F\u0435\u0440\u0435\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0442\u0438 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438.",
    inGameProceed: "\u0412\u0441\u0451 \u0440\u0430\u0432\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C",
    inGameCancel: "\u041E\u0441\u0442\u0430\u0442\u044C\u0441\u044F \u0432 \u0438\u0433\u0440\u0435"
  },
  game: {
    title: "\u0418\u0433\u0440\u0430 SheshDash",
    gameId: "ID \u0418\u0433\u0440\u044B",
    copyId: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C ID",
    idCopied: "ID \u0438\u0433\u0440\u044B \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430!",
    createGame: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0438\u0433\u0440\u0443",
    privateGame: "\u041F\u0440\u0438\u0432\u0430\u0442\u043D\u0430\u044F \u0438\u0433\u0440\u0430 (\u0441\u043A\u0440\u044B\u0442\u044C \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430 \u043E\u043D\u043B\u0430\u0439\u043D-\u0438\u0433\u0440)",
    joinGame: "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u0438\u0433\u0440\u0435",
    joinGameButton: "\u0412\u043E\u0439\u0442\u0438 \u0432 \u0438\u0433\u0440\u0443",
    startGame: "\u041D\u0430\u0447\u0430\u0442\u044C \u0438\u0433\u0440\u0443",
    back: "\u041D\u0430\u0437\u0430\u0434",
    yourName: "\u0412\u0430\u0448\u0435 \u0438\u043C\u044F",
    gameIdPlaceholder: "ID \u0438\u0433\u0440\u044B",
    connected: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
    connecting: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435...",
    waitingForPlayers: "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0438\u0433\u0440\u043E\u043A\u043E\u0432...",
    players: "\u0438\u0433\u0440\u043E\u043A\u043E\u0432",
    shareGameId: "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C ID \u0438\u0433\u0440\u044B \u0441 \u0434\u0440\u0443\u0437\u044C\u044F\u043C\u0438!",
    canStartWithPlayers: "\u041C\u043E\u0436\u043D\u043E \u043D\u0430\u0447\u0430\u0442\u044C \u0438\u0433\u0440\u0443 \u0441 2-4 \u0438\u0433\u0440\u043E\u043A\u0430\u043C\u0438. \u041D\u0430\u0436\u043C\u0438\u0442\u0435 '\u041D\u0430\u0447\u0430\u0442\u044C \u0438\u0433\u0440\u0443' \u043A\u043E\u0433\u0434\u0430 \u0433\u043E\u0442\u043E\u0432\u044B!",
    onlyCreatorCanStart: "\u0422\u043E\u043B\u044C\u043A\u043E \u0441\u043E\u0437\u0434\u0430\u0442\u0435\u043B\u044C \u043C\u043E\u0436\u0435\u0442 \u043D\u0430\u0447\u0430\u0442\u044C \u0438\u0433\u0440\u0443.",
    needMorePlayers: "\u041D\u0443\u0436\u043D\u043E \u043C\u0438\u043D\u0438\u043C\u0443\u043C 2 \u0438\u0433\u0440\u043E\u043A\u0430 \u0434\u043B\u044F \u0441\u0442\u0430\u0440\u0442\u0430 \u0438\u0433\u0440\u044B.",
    botSuggestion: "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0431\u043E\u0442\u043E\u0432 \u0447\u0435\u0440\u0435\u0437",
    currentPlayers: "\u0422\u0435\u043A\u0443\u0449\u0438\u0435 \u0438\u0433\u0440\u043E\u043A\u0438:",
    yourTurn: "\u0412\u0430\u0448 \u0445\u043E\u0434!",
    waiting: "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435...",
    rolled: "\u0412\u044B\u043F\u0430\u043B\u043E",
    gameOver: "\u0418\u0433\u0440\u0430 \u043E\u043A\u043E\u043D\u0447\u0435\u043D\u0430!",
    winner: "\u041F\u043E\u0431\u0435\u0434\u0438\u0442\u0435\u043B\u044C",
    results: "\u0418\u0442\u043E\u0433\u043E\u0432\u044B\u0435 \u043C\u0435\u0441\u0442\u0430",
    place: "\u041C\u0435\u0441\u0442\u043E",
    exitGame: "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 \u0438\u0433\u0440\u044B",
    turnTimer: "\u041E\u0441\u0442\u0430\u043B\u043E\u0441\u044C",
    preferredColor: "\u041F\u0440\u0435\u0434\u043F\u043E\u0447\u0438\u0442\u0430\u0435\u043C\u044B\u0439 \u0446\u0432\u0435\u0442",
    autoAssignColor: "\u0410\u0432\u0442\u043E\u0432\u044B\u0431\u043E\u0440",
    colorRed: "\u041A\u0440\u0430\u0441\u043D\u044B\u0439",
    colorBlue: "\u0421\u0438\u043D\u0438\u0439",
    colorGreen: "\u0417\u0435\u043B\u0435\u043D\u044B\u0439",
    colorOrange: "\u041E\u0440\u0430\u043D\u0436\u0435\u0432\u044B\u0439",
    pause: "\u041F\u0430\u0443\u0437\u0430",
    resume: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C",
    paused: "\u041F\u0430\u0443\u0437\u0430",
    pausedHint: "\u0418\u0433\u0440\u0430 \u043D\u0430 \u043F\u0430\u0443\u0437\u0435. \u041D\u0430\u0436\u043C\u0438 \xAB\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C\xBB, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C."
  },
  kickVote: {
    confirm: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C {{name}} \u0438\u0437 \u0438\u0433\u0440\u044B?",
    title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u0430?",
    requestsToKick: "\u0445\u043E\u0447\u0435\u0442 \u0443\u0434\u0430\u043B\u0438\u0442\u044C",
    targetBot: "\u0426\u0435\u043B\u044C: \u0431\u043E\u0442",
    targetHuman: "\u0426\u0435\u043B\u044C: \u0438\u0433\u0440\u043E\u043A",
    votes: "\u0413\u043E\u043B\u043E\u0441\u0430",
    approve: "\u0417\u0430",
    reject: "\u041F\u0440\u043E\u0442\u0438\u0432",
    waiting: "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0433\u043E\u043B\u043E\u0441\u043E\u0432 \u0434\u0440\u0443\u0433\u0438\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432",
    readOnly: "\u0418\u0434\u0435\u0442 \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u043D\u0438\u0435",
    kickedTitle: "\u0412\u0430\u0441 \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u043B\u0438 \u0438\u0437 \u0438\u0433\u0440\u044B",
    kickedNotice: "\u0412\u0430\u0448\u0438 \u0448\u0430\u0448\u043A\u0438 \u0442\u0435\u043F\u0435\u0440\u044C \u043F\u043E\u043B\u0443\u043F\u0440\u043E\u0437\u0440\u0430\u0447\u043D\u044B\u0435 \u0438 \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u043C\u0435\u0448\u0430\u044E\u0442 \u0438\u0433\u0440\u0435.",
    returnToLobby: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u0432 \u043B\u043E\u0431\u0431\u0438",
    observeGame: "\u041D\u0430\u0431\u043B\u044E\u0434\u0430\u0442\u044C \u0437\u0430 \u0438\u0433\u0440\u043E\u0439"
  },
  lobby: {
    onlinePlayers: "\u0418\u0433\u0440\u043E\u043A\u0438 \u043E\u043D\u043B\u0430\u0439\u043D",
    waitingGames: "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0435 \u0438\u0433\u0440\u044B",
    findMatch: "\u041D\u0430\u0439\u0442\u0438 \u043E\u043D\u043B\u0430\u0439\u043D \u0438\u0433\u0440\u0443",
    cancelMatch: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u0438\u0441\u043A",
    searching: "\u0418\u0449\u0435\u043C \u0438\u0433\u0440\u043E\u043A\u043E\u0432...",
    queueCount: "\u0418\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u043E\u0447\u0435\u0440\u0435\u0434\u0438: {{count}} / 4",
    onlineCount: "\u0418\u0433\u0440\u043E\u043A\u043E\u0432 \u043E\u043D\u043B\u0430\u0439\u043D: {{count}}",
    join: "\u0412\u043E\u0439\u0442\u0438",
    creator: "\u0421\u043E\u0437\u0434\u0430\u0442\u0435\u043B\u044C",
    noGames: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0445 \u0438\u0433\u0440",
    botsOfferTitle: "\u041D\u0430\u0447\u0430\u0442\u044C \u0441\u0435\u0439\u0447\u0430\u0441 \u0441 \u0431\u043E\u0442\u0430\u043C\u0438?",
    botsOfferText: "\u041D\u0435 \u0445\u0432\u0430\u0442\u0430\u0435\u0442 {{count}} \u0438\u0433\u0440\u043E\u043A(\u043E\u0432). \u041C\u043E\u0436\u043D\u043E \u043D\u0430\u0447\u0430\u0442\u044C \u0441\u0440\u0430\u0437\u0443 \u0438 \u0434\u043E\u0431\u0440\u0430\u0442\u044C \u043E\u0441\u0442\u0430\u0432\u0448\u0438\u0445\u0441\u044F \u0431\u043E\u0442\u0430\u043C\u0438.",
    startWithBots: "\u041D\u0430\u0447\u0430\u0442\u044C \u0441 \u0431\u043E\u0442\u0430\u043C\u0438",
    keepWaiting: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0435"
  },
  actions: {
    yourActions: "\u0412\u0430\u0448\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
    rollDice: "\u0411\u0440\u043E\u0441\u044C\u0442\u0435 \u043A\u0443\u0431\u0438\u043A, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0441\u0432\u043E\u0439 \u0445\u043E\u0434!",
    needSix: "\u0412\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u0432\u044B\u0431\u0440\u043E\u0441\u0438\u0442\u044C 6, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043F\u0435\u0440\u0432\u0443\u044E \u0444\u0438\u0448\u043A\u0443 \u043D\u0430 \u0434\u043E\u0441\u043A\u0443!",
    rolledSix: "\u0412\u044B \u0432\u044B\u0431\u0440\u043E\u0441\u0438\u043B\u0438 6! \u0413\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D \u0431\u043E\u043D\u0443\u0441\u043D\u044B\u0439 \u0431\u0440\u043E\u0441\u043E\u043A!",
    rolledSixOptions: [
      "\u041F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0444\u0438\u0448\u043A\u0443 (\u0435\u0441\u043B\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430)",
      "\u0418\u041B\u0418 \u043F\u0435\u0440\u0435\u0434\u0432\u0438\u043D\u0443\u0442\u044C \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0443\u044E \u0444\u0438\u0448\u043A\u0443 \u043D\u0430 6 \u0448\u0430\u0433\u043E\u0432"
    ],
    rolledSixNote: "\u041B\u044E\u0431\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u0434\u0430\u0435\u0442 \u0432\u0430\u043C \u0435\u0449\u0435 \u043E\u0434\u0438\u043D \u0431\u0440\u043E\u0441\u043E\u043A!",
    selectPiece: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u0438\u0448\u043A\u0443 \u0434\u043B\u044F \u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 {{steps}} \u0448\u0430\u0433\u043E\u0432.",
    selectedPiece: "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0444\u0438\u0448\u043A\u0430: {{state}}",
    placePiece: "\u041F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0444\u0438\u0448\u043A\u0443 \u043D\u0430 \u0434\u043E\u0441\u043A\u0443",
    moveSteps: "\u041F\u0435\u0440\u0435\u0434\u0432\u0438\u043D\u0443\u0442\u044C \u043D\u0430 {{steps}} \u0448\u0430\u0433\u043E\u0432",
    deselect: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u044B\u0431\u043E\u0440"
  },
  instructions: {
    title: "\u041A\u0430\u043A \u0438\u0433\u0440\u0430\u0442\u044C:",
    rules: [
      "\u0424\u0438\u0448\u043A\u0438 \u0441\u043D\u0430\u0447\u0430\u043B\u0430 \u0432\u043D\u0435 \u0434\u043E\u0441\u043A\u0438; \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0444\u0438\u0448\u043A\u0443 \u043D\u0430 \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u0443\u044E \u043A\u043B\u0435\u0442\u043A\u0443 (\u0443\u0433\u043E\u043B), \u043D\u0443\u0436\u043D\u043E \u0432\u044B\u0431\u0440\u043E\u0441\u0438\u0442\u044C 6.",
      "\u0414\u0432\u0438\u0433\u0430\u0439\u0442\u0435 \u0444\u0438\u0448\u043A\u0438 \u043F\u043E \u0447\u0430\u0441\u043E\u0432\u043E\u0439 \u0441\u0442\u0440\u0435\u043B\u043A\u0435 \u0432\u043E\u043A\u0440\u0443\u0433 \u0434\u043E\u0441\u043A\u0438",
      "\u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u043D\u043E\u0433\u043E \u043A\u0440\u0443\u0433\u0430 \u0434\u0432\u0438\u0433\u0430\u0439\u0442\u0435\u0441\u044C \u043F\u043E \u0444\u0438\u043D\u0438\u0448\u043D\u043E\u0439 \u0434\u0438\u0430\u0433\u043E\u043D\u0430\u043B\u0438",
      "\u0418\u0433\u0440\u043E\u043A, \u043F\u0435\u0440\u0432\u044B\u043C \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0432\u0448\u0438\u0439 \u0432\u0441\u0435 4 \u0444\u0438\u043D\u0438\u0448\u043D\u044B\u0435 \u043A\u043B\u0435\u0442\u043A\u0438, \u0437\u0430\u043D\u0438\u043C\u0430\u0435\u0442 1-\u0435 \u043C\u0435\u0441\u0442\u043E; \u0438\u0433\u0440\u0430 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u0435\u0442\u0441\u044F \u0434\u043E \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u043C\u0435\u0441\u0442 \u0443 \u0432\u0441\u0435\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432."
    ]
  },
  gameMode: {
    title: "\u041A\u0430\u043A \u0445\u043E\u0447\u0435\u0448\u044C \u0438\u0433\u0440\u0430\u0442\u044C?",
    quickStart: "\u0411\u044B\u0441\u0442\u0440\u044B\u0439 \u0441\u0442\u0430\u0440\u0442",
    quickStartDesc: "\u043F\u0440\u043E\u0442\u0438\u0432 3 \u0431\u043E\u0442\u043E\u0432, \u0441\u0440\u0430\u0437\u0443 \u0437\u0430\u043F\u0443\u0441\u043A\u0430\u0435\u0442\u0441\u044F",
    withFriends: "\u0421 \u0434\u0440\u0443\u0437\u044C\u044F\u043C\u0438",
    withFriendsDesc: "\u043F\u043E\u0434\u0435\u043B\u0438\u0441\u044C \u043A\u043E\u0434\u043E\u043C, \u0436\u0434\u0438 \u0434\u0440\u0443\u0437\u0435\u0439",
    findPlayers: "\u041D\u0430\u0439\u0442\u0438 \u0438\u0433\u0440\u043E\u043A\u043E\u0432",
    findPlayersDesc: "\u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0435 \u043B\u043E\u0431\u0431\u0438, \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u0441\u044F \u043B\u044E\u0431\u043E\u0439"
  },
  bots: {
    addTitle: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0431\u043E\u0442\u043E\u0432?",
    addDescription: "\u041D\u0438\u043A\u0442\u043E \u0435\u0449\u0435 \u043D\u0435 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u043B\u0441\u044F. \u0425\u043E\u0442\u0438\u0442\u0435 \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0431\u043E\u0442\u043E\u0432, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0438\u0433\u0440\u0430\u0442\u044C?",
    needMore: "\u0412\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u0435\u0449\u0435 {{count}} \u0438\u0433\u0440\u043E\u043A(\u043E\u0432).",
    addButton: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C {{count}} \u0431\u043E\u0442\u0430",
    addButtonPlural: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C {{count}} \u0431\u043E\u0442\u043E\u0432",
    waitForPlayers: "\u0416\u0434\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432"
  },
  turn: {
    currentTurn: "\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u0445\u043E\u0434",
    you: "\u0412\u0430\u0448",
    skipped: "\u0425\u043E\u0434 \u043F\u0440\u043E\u043F\u0443\u0449\u0435\u043D",
    completed: "\u0425\u043E\u0434 \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D"
  },
  errors: {
    error: "\u041E\u0448\u0438\u0431\u043A\u0430",
    pathBlocked: "\u041F\u0443\u0442\u044C \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D - \u043D\u0435\u043B\u044C\u0437\u044F \u043F\u0435\u0440\u0435\u043F\u0440\u044B\u0433\u0438\u0432\u0430\u0442\u044C \u0447\u0435\u0440\u0435\u0437 \u0444\u0438\u0448\u043A\u0438",
    cannotLandOnOwnPiece: "\u041D\u0435\u043B\u044C\u0437\u044F \u0432\u0441\u0442\u0430\u0442\u044C \u043D\u0430 \u0441\u0432\u043E\u044E \u0444\u0438\u0448\u043A\u0443",
    pieceInCorner: "\u0424\u0438\u0448\u043A\u0430 \u0432 \u0440\u0435\u0437\u0435\u0440\u0432\u0435, \u043D\u0443\u0436\u043D\u043E \u0432\u044B\u0431\u0440\u043E\u0441\u0438\u0442\u044C 6 \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0435\u0451",
    pieceAlreadyInCenter: "\u0424\u0438\u0448\u043A\u0430 \u0443\u0436\u0435 \u0437\u0430\u043D\u0438\u043C\u0430\u0435\u0442 \u0444\u0438\u043D\u0438\u0448\u043D\u0443\u044E \u043A\u043B\u0435\u0442\u043A\u0443",
    needToRoll6: "\u041D\u0443\u0436\u043D\u043E \u0432\u044B\u0431\u0440\u043E\u0441\u0438\u0442\u044C 6 \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0444\u0438\u0448\u043A\u0443",
    pieceNotInCorner: "\u0424\u0438\u0448\u043A\u0430 \u043D\u0435 \u0432 \u0440\u0435\u0437\u0435\u0440\u0432\u0435",
    pieceNotFound: "\u0424\u0438\u0448\u043A\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 \u0438\u043B\u0438 \u043D\u0435 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0438\u0442 \u0442\u0435\u043A\u0443\u0449\u0435\u043C\u0443 \u0438\u0433\u0440\u043E\u043A\u0443",
    notYourTurn: "\u041D\u0435 \u0432\u0430\u0448 \u0445\u043E\u0434",
    gameNotInProgress: "\u0418\u0433\u0440\u0430 \u043D\u0435 \u0438\u0434\u0451\u0442",
    stepsMustMatchDice: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0448\u0430\u0433\u043E\u0432 \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u0431\u0440\u043E\u0441\u043A\u0443 \u043A\u0443\u0431\u0438\u043A\u0430",
    needExactRollForCenter: "\u041D\u0443\u0436\u0435\u043D \u0442\u043E\u0447\u043D\u044B\u0439 \u0431\u0440\u043E\u0441\u043E\u043A \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u0443\u044E \u0444\u0438\u043D\u0438\u0448\u043D\u0443\u044E \u043A\u043B\u0435\u0442\u043A\u0443 - \u043D\u0435\u043B\u044C\u0437\u044F \u043F\u0435\u0440\u0435\u043F\u0440\u044B\u0433\u043D\u0443\u0442\u044C",
    onlyCreatorCanStart: "\u0422\u043E\u043B\u044C\u043A\u043E \u0441\u043E\u0437\u0434\u0430\u0442\u0435\u043B\u044C \u0438\u0433\u0440\u044B \u043C\u043E\u0436\u0435\u0442 \u0435\u0451 \u043D\u0430\u0447\u0430\u0442\u044C",
    playerNameTaken: "\u042D\u0442\u043E \u0438\u043C\u044F \u0438\u0433\u0440\u043E\u043A\u0430 \u0443\u0436\u0435 \u0437\u0430\u043D\u044F\u0442\u043E \u0432 \u044D\u0442\u043E\u0439 \u0438\u0433\u0440\u0435"
  },
  pieceStates: {
    in_corner: "\u0412 \u0440\u0435\u0437\u0435\u0440\u0432\u0435",
    on_perimeter: "\u041D\u0430 \u0434\u043E\u0441\u043A\u0435",
    on_diagonal: "\u041D\u0430 \u0434\u0438\u0430\u0433\u043E\u043D\u0430\u043B\u0438",
    in_center: "\u0424\u0438\u043D\u0438\u0448"
  },
  playerInfo: {
    title: "\u0418\u0433\u0440\u043E\u043A\u0438",
    you: "(\u0412\u044B)",
    turn: "\u0425\u043E\u0434",
    corner: "\u0412 \u0440\u0435\u0437\u0435\u0440\u0432\u0435:",
    onBoard: "\u041D\u0430 \u0434\u043E\u0441\u043A\u0435:",
    inCenter: "\u041D\u0430 \u0444\u0438\u043D\u0438\u0448\u0435:",
    waitingFor: "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0435\u0449\u0435 {{count}} \u0438\u0433\u0440\u043E\u043A(\u043E\u0432)...",
    statusRolled6: "\u0411\u043E\u043D\u0443\u0441!",
    statusCaptured: "\u0417\u0430\u0445\u0432\u0430\u0442! \u0411\u043E\u043D\u0443\u0441!",
    statusPlacedPiece: "\u0424\u0438\u0448\u043A\u0430 \u043F\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0430, \u0411\u043E\u043D\u0443\u0441!",
    statusMovedOn6: "\u0425\u043E\u0434 \u043D\u0430 6, \u0411\u043E\u043D\u0443\u0441!",
    statusTurnSkipped: "\u041F\u0440\u043E\u043F\u0443\u0449\u0435\u043D",
    statusTurnComplete: "\u0425\u043E\u0434 \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D"
  },
  dice: {
    rollDice: "\u0411\u0440\u043E\u0441\u0438\u0442\u044C \u043A\u0443\u0431\u0438\u043A",
    rolled6Message: "\u0412\u044B \u0432\u044B\u0431\u0440\u043E\u0441\u0438\u043B\u0438 6! \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0444\u0438\u0448\u043A\u0443 \u0418\u041B\u0418 \u043F\u0435\u0440\u0435\u0434\u0432\u0438\u043D\u0443\u0442\u044C \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0443\u044E \u043D\u0430 6 \u0448\u0430\u0433\u043E\u0432.",
    rolledBy: "\u0411\u0440\u043E\u0441\u0438\u043B",
    round: "\u0420\u0430\u0443\u043D\u0434",
    rolls: "\u0411\u0440\u043E\u0441\u043A\u0438",
    captureBonus: "\u0411\u043E\u043D\u0443\u0441 \u0437\u0430 \u0437\u0430\u0445\u0432\u0430\u0442"
  },
  board: {
    currentPlayer: "\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u0438\u0433\u0440\u043E\u043A",
    historyStart: "\u0412 \u043D\u0430\u0447\u0430\u043B\u043E",
    historyPrev: "\u041D\u0430\u0437\u0430\u0434",
    historyNext: "\u0412\u043F\u0435\u0440\u0435\u0434",
    historyEnd: "\u0412 \u043A\u043E\u043D\u0435\u0446",
    historyViewingPast: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0438\u0441\u0442\u043E\u0440\u0438\u0438: \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u044B"
  },
  rules: {
    title: "\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438\u0433\u0440\u044B",
    close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    showRules: "\u041F\u0440\u0430\u0432\u0438\u043B\u0430",
    objective: {
      title: "\u0426\u0435\u043B\u044C \u0438\u0433\u0440\u044B",
      description: "\u041F\u0435\u0440\u0435\u043C\u0435\u0449\u0430\u0439\u0442\u0435 4 \u0441\u0432\u043E\u0438 \u0444\u0438\u0448\u043A\u0438 \u0441\u043E \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u043E\u0439 \u043A\u043B\u0435\u0442\u043A\u0438 (\u0443\u0433\u043B\u0430), \u043F\u043E \u043F\u0435\u0440\u0438\u043C\u0435\u0442\u0440\u0443 \u0434\u043E\u0441\u043A\u0438, \u043F\u043E \u0441\u0432\u043E\u0435\u0439 \u0444\u0438\u043D\u0438\u0448\u043D\u043E\u0439 \u0434\u0438\u0430\u0433\u043E\u043D\u0430\u043B\u0438 \u0438 \u0432 4 \u0444\u0438\u043D\u0438\u0448\u043D\u044B\u0435 \u043A\u043B\u0435\u0442\u043A\u0438. \u041F\u0435\u0440\u0432\u044B\u0439 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0432\u0448\u0438\u0439 \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442 1-\u0435 \u043C\u0435\u0441\u0442\u043E, \u043D\u043E \u043F\u0430\u0440\u0442\u0438\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u0435\u0442\u0441\u044F \u0434\u043E \u043F\u043E\u043B\u043D\u043E\u0433\u043E \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u043C\u0435\u0441\u0442."
    },
    setup: {
      title: "\u041D\u0430\u0447\u0430\u043B\u043E \u0438\u0433\u0440\u044B",
      items: [
        "\u041A\u0430\u0436\u0434\u044B\u0439 \u0438\u0433\u0440\u043E\u043A \u043D\u0430\u0447\u0438\u043D\u0430\u0435\u0442 \u0441 4 \u0444\u0438\u0448\u043A\u0430\u043C\u0438 \u0432\u043D\u0435 \u0434\u043E\u0441\u043A\u0438 (\u0432 \u0440\u0435\u0437\u0435\u0440\u0432\u0435)",
        "\u0418\u0433\u0440\u043E\u043A\u0438 \u0445\u043E\u0434\u044F\u0442 \u043F\u043E \u0447\u0430\u0441\u043E\u0432\u043E\u0439 \u0441\u0442\u0440\u0435\u043B\u043A\u0435",
        "\u0412\u0441\u0435 \u0444\u0438\u0448\u043A\u0438 \u043D\u0430\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u0432\u043D\u0435 \u0434\u043E\u0441\u043A\u0438, \u043F\u043E\u043A\u0430 \u043D\u0435 \u0432\u044B\u043F\u0430\u0434\u0435\u0442 6"
      ]
    },
    gameplay: {
      title: "\u0418\u0433\u0440\u043E\u0432\u043E\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441",
      items: [
        "\u0411\u0440\u043E\u0441\u044C\u0442\u0435 \u043A\u0443\u0431\u0438\u043A, \u0447\u0442\u043E\u0431\u044B \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0438\u0442\u044C \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0448\u0430\u0433\u043E\u0432",
        "\u0427\u0442\u043E\u0431\u044B \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043F\u0435\u0440\u0432\u0443\u044E \u0444\u0438\u0448\u043A\u0443 \u043D\u0430 \u0434\u043E\u0441\u043A\u0443, \u043D\u0443\u0436\u043D\u043E \u0432\u044B\u0431\u0440\u043E\u0441\u0438\u0442\u044C 6",
        "\u0424\u0438\u0448\u043A\u0438 \u0434\u0432\u0438\u0433\u0430\u044E\u0442\u0441\u044F \u043F\u043E \u0447\u0430\u0441\u043E\u0432\u043E\u0439 \u0441\u0442\u0440\u0435\u043B\u043A\u0435 \u043F\u043E \u0432\u043D\u0435\u0448\u043D\u0435\u043C\u0443 \u043F\u0435\u0440\u0438\u043C\u0435\u0442\u0440\u0443 (28 \u043F\u043E\u0437\u0438\u0446\u0438\u0439)",
        "\u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u043D\u043E\u0433\u043E \u043A\u0440\u0443\u0433\u0430 \u0444\u0438\u0448\u043A\u0438 \u0438\u0434\u0443\u0442 \u043F\u043E \u0441\u0432\u043E\u0435\u0439 \u0444\u0438\u043D\u0438\u0448\u043D\u043E\u0439 \u0434\u0438\u0430\u0433\u043E\u043D\u0430\u043B\u0438 (4 \u043A\u043B\u0435\u0442\u043A\u0438)",
        "\u041D\u0435\u043B\u044C\u0437\u044F \u0434\u0432\u0438\u0433\u0430\u0442\u044C \u0444\u0438\u0448\u043A\u0438 \u0432 \u0440\u0435\u0437\u0435\u0440\u0432\u0435, \u043F\u043E\u043A\u0430 \u043D\u0435 \u0432\u044B\u0431\u0440\u043E\u0441\u0438\u0442\u0435 6"
      ]
    },
    rolling6: {
      title: "\u0411\u0440\u043E\u0441\u043E\u043A 6",
      description: "\u041A\u043E\u0433\u0434\u0430 \u0432\u044B\u043F\u0430\u0434\u0430\u0435\u0442 6, \u0435\u0441\u0442\u044C \u0434\u0432\u0430 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430:",
      options: [
        "\u041F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0444\u0438\u0448\u043A\u0443 \u043D\u0430 \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u0443\u044E \u043A\u043B\u0435\u0442\u043A\u0443 (\u0443\u0433\u043E\u043B)",
        "\u041F\u0435\u0440\u0435\u0434\u0432\u0438\u043D\u0443\u0442\u044C \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0443\u044E \u0444\u0438\u0448\u043A\u0443 \u043D\u0430 6 \u0448\u0430\u0433\u043E\u0432 \u0432\u043F\u0435\u0440\u0451\u0434"
      ],
      note: "\u041B\u044E\u0431\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u0434\u0430\u0451\u0442 \u0431\u043E\u043D\u0443\u0441\u043D\u044B\u0439 \u0431\u0440\u043E\u0441\u043E\u043A! \u041C\u043E\u0436\u043D\u043E \u0431\u0440\u043E\u0441\u0430\u0442\u044C, \u043F\u043E\u043A\u0430 \u0432\u044B\u043F\u0430\u0434\u0430\u044E\u0442 6."
    },
    capturing: {
      title: "\u0417\u0430\u0445\u0432\u0430\u0442 \u0444\u0438\u0448\u0435\u043A",
      items: [
        "\u0415\u0441\u043B\u0438 \u0444\u0438\u0448\u043A\u0430 \u0432\u0441\u0442\u0430\u0451\u0442 \u0422\u041E\u0427\u041D\u041E \u043D\u0430 \u0444\u0438\u0448\u043A\u0443 \u0441\u043E\u043F\u0435\u0440\u043D\u0438\u043A\u0430, \u043E\u043D\u0430 \u0437\u0430\u0445\u0432\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u0435\u0451",
        "\u0417\u0430\u0445\u0432\u0430\u0447\u0435\u043D\u043D\u0430\u044F \u0444\u0438\u0448\u043A\u0430 \u0441\u043D\u0438\u043C\u0430\u0435\u0442\u0441\u044F \u0441 \u0434\u043E\u0441\u043A\u0438 \u0438 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442\u0441\u044F \u0432 \u0440\u0435\u0437\u0435\u0440\u0432 \u0441\u043E\u043F\u0435\u0440\u043D\u0438\u043A\u0430",
        "\u041D\u0435\u043B\u044C\u0437\u044F \u0437\u0430\u0445\u0432\u0430\u0442\u0438\u0442\u044C \u043F\u0435\u0440\u0435\u043F\u0440\u044B\u0433\u043D\u0443\u0432 - \u043D\u0443\u0436\u043D\u043E \u0432\u0441\u0442\u0430\u0442\u044C \u0442\u043E\u0447\u043D\u043E \u043D\u0430 \u043F\u043E\u0437\u0438\u0446\u0438\u044E",
        "\u0417\u0430\u0445\u0432\u0430\u0442 \u0434\u0430\u0451\u0442 \u0431\u043E\u043D\u0443\u0441\u043D\u044B\u0439 \u0431\u0440\u043E\u0441\u043E\u043A (\u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0445\u043E\u0434)"
      ]
    },
    blocking: {
      title: "\u0411\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0430",
      description: "\u041D\u0435\u043B\u044C\u0437\u044F \u043F\u0435\u0440\u0435\u043F\u0440\u044B\u0433\u0438\u0432\u0430\u0442\u044C \u0447\u0435\u0440\u0435\u0437 \u0434\u0440\u0443\u0433\u0438\u0435 \u0444\u0438\u0448\u043A\u0438! \u0415\u0441\u043B\u0438 \u043B\u044E\u0431\u0430\u044F \u0444\u0438\u0448\u043A\u0430 (\u0432\u0430\u0448\u0430 \u0438\u043B\u0438 \u0441\u043E\u043F\u0435\u0440\u043D\u0438\u043A\u0430) \u0431\u043B\u043E\u043A\u0438\u0440\u0443\u0435\u0442 \u043F\u0443\u0442\u044C, \u043D\u0435\u043B\u044C\u0437\u044F \u043F\u0440\u043E\u0439\u0442\u0438. \u0412\u0435\u0441\u044C \u043F\u0443\u0442\u044C \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0441\u0432\u043E\u0431\u043E\u0434\u0435\u043D."
    },
    winning: {
      title: "\u041F\u043E\u0431\u0435\u0434\u0430",
      description: "\u041F\u0435\u0440\u0432\u044B\u0439 \u0438\u0433\u0440\u043E\u043A, \u0437\u0430\u043D\u044F\u0432\u0448\u0438\u0439 \u0432\u0441\u0435 4 \u0444\u0438\u043D\u0438\u0448\u043D\u044B\u0435 \u043A\u043B\u0435\u0442\u043A\u0438, \u0437\u0430\u043D\u0438\u043C\u0430\u0435\u0442 1-\u0435 \u043C\u0435\u0441\u0442\u043E. \u0418\u0433\u0440\u0430 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u0435\u0442\u0441\u044F, \u043F\u043E\u043A\u0430 \u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0442\u0441\u044F 2-\u0435, 3-\u0435 \u0438 4-\u0435 \u043C\u0435\u0441\u0442\u0430."
    },
    bonusRolls: {
      title: "\u0411\u043E\u043D\u0443\u0441\u043D\u044B\u0435 \u0431\u0440\u043E\u0441\u043A\u0438",
      items: [
        "\u0411\u043E\u043D\u0443\u0441\u043D\u044B\u0439 \u0431\u0440\u043E\u0441\u043E\u043A \u0437\u0430 \u0432\u044B\u043F\u0430\u0432\u0448\u0443\u044E 6 (\u043D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E \u043E\u0442 \u0432\u044B\u0431\u043E\u0440\u0430: \u043F\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430 \u0438\u043B\u0438 \u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0435)",
        "\u0411\u043E\u043D\u0443\u0441\u043D\u044B\u0439 \u0431\u0440\u043E\u0441\u043E\u043A \u0437\u0430 \u0437\u0430\u0445\u0432\u0430\u0442 \u0444\u0438\u0448\u043A\u0438 \u0441\u043E\u043F\u0435\u0440\u043D\u0438\u043A\u0430",
        "\u0411\u043E\u043D\u0443\u0441\u044B \u0441\u043A\u043B\u0430\u0434\u044B\u0432\u0430\u044E\u0442\u0441\u044F - \u043F\u0440\u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0439 6 \u0438\u043B\u0438 \u0437\u0430\u0445\u0432\u0430\u0442\u0435 \u043C\u043E\u0436\u043D\u043E \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u0442\u044C!"
      ]
    },
    timer: {
      title: "\u0422\u0430\u0439\u043C\u0435\u0440 \u0445\u043E\u0434\u0430",
      items: [
        "\u0423 \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0438\u0433\u0440\u043E\u043A\u0430 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u043D\u0430 \u0445\u043E\u0434",
        "\u0415\u0441\u043B\u0438 \u0432\u0440\u0435\u043C\u044F \u0438\u0441\u0442\u0435\u043A\u043B\u043E, \u0445\u043E\u0434 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u0440\u043E\u043F\u0443\u0441\u043A\u0430\u0435\u0442\u0441\u044F"
      ]
    }
  },
  hint: {
    button: "\u041F\u043E\u0434\u0441\u043A\u0430\u0437\u043A\u0430",
    title: "\u041F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C\u044B\u0439 \u0445\u043E\u0434",
    noPieces: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0444\u0438\u0448\u0435\u043A \u0434\u043B\u044F \u0445\u043E\u0434\u0430",
    canPlace: "\u0412\u044B\u043F\u0430\u043B\u0430 6! \u041F\u043E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0444\u0438\u0448\u043A\u0443 \u043D\u0430 \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u0443\u044E \u043A\u043B\u0435\u0442\u043A\u0443 (\u0443\u0433\u043E\u043B)",
    canMove: "\u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u0435 \u0444\u0438\u0448\u043A\u0443 \u0441 {{position}} \u043D\u0430 {{steps}} \u0448\u0430\u0433\u043E\u0432",
    close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
  },
  theme: {
    sheshdash: "\u0428\u0435\u0448\u0414\u0430\u0448",
    toggle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0442\u0435\u043C\u0443",
    system: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0430\u044F",
    light: "\u0421\u0432\u0435\u0442\u043B\u0430\u044F",
    dark: "\u0422\u0451\u043C\u043D\u0430\u044F"
  },
  tutorial: {
    button: "\u041E\u0431\u0443\u0447\u0435\u043D\u0438\u0435",
    skip: "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C",
    prev: "\u041D\u0430\u0437\u0430\u0434",
    next: "\u0414\u0430\u043B\u0435\u0435",
    finish: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C",
    welcome: {
      title: "\u0414\u043E\u0431\u0440\u043E \u043F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C \u0432 SheshDash!",
      description: "\u042D\u0442\u043E \u0431\u044B\u0441\u0442\u0440\u043E\u0435 \u0438\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0435 \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u0435 \u043F\u043E\u043A\u0430\u0436\u0435\u0442 \u0432\u0430\u043C, \u043A\u0430\u043A \u0438\u0433\u0440\u0430\u0442\u044C. \u0426\u0435\u043B\u044C \u0438\u0433\u0440\u044B: \u043F\u0435\u0440\u0435\u0432\u0435\u0441\u0442\u0438 \u0432\u0441\u0435 4 \u0444\u0438\u0448\u043A\u0438 \u0441\u043E \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u043E\u0439 \u043A\u043B\u0435\u0442\u043A\u0438 (\u0443\u0433\u043B\u0430) \u0432 \u0441\u0432\u043E\u0438 \u0444\u0438\u043D\u0438\u0448\u043D\u044B\u0435 \u043A\u043B\u0435\u0442\u043A\u0438 \u0438 \u0437\u0430\u043D\u044F\u0442\u044C \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E \u0432\u044B\u0441\u043E\u043A\u043E\u0435 \u043C\u0435\u0441\u0442\u043E!"
    },
    createGame: {
      title: "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0438\u0433\u0440\u044B",
      description: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u044D\u0442\u0443 \u043A\u043D\u043E\u043F\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0438\u0433\u0440\u0443. \u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 ID, \u043A\u043E\u0442\u043E\u0440\u044B\u043C \u043C\u043E\u0436\u043D\u043E \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441 \u0434\u0440\u0443\u0437\u044C\u044F\u043C\u0438."
    },
    addBots: {
      title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0431\u043E\u0442\u043E\u0432",
      description: "\u0415\u0441\u043B\u0438 \u043D\u0435 \u0445\u0432\u0430\u0442\u0430\u0435\u0442 \u0438\u0433\u0440\u043E\u043A\u043E\u0432, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0431\u043E\u0442\u043E\u0432. \u0418\u0433\u0440\u0430 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 2-4 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0434\u043B\u044F \u0441\u0442\u0430\u0440\u0442\u0430."
    },
    startGame: {
      title: "\u041D\u0430\u0447\u0430\u0442\u044C \u0438\u0433\u0440\u0443",
      description: "\u041A\u043E\u0433\u0434\u0430 \u0432\u0441\u0435 \u0438\u0433\u0440\u043E\u043A\u0438 \u0433\u043E\u0442\u043E\u0432\u044B (\u043C\u0438\u043D\u0438\u043C\u0443\u043C 2), \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u044D\u0442\u0443 \u043A\u043D\u043E\u043F\u043A\u0443 \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0438\u0433\u0440\u0443!"
    },
    diceButton: {
      title: "\u{1F3B2} \u0411\u0440\u043E\u0441\u043E\u043A \u043A\u0443\u0431\u0438\u043A\u0430",
      description: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u044D\u0442\u0443 \u043A\u043D\u043E\u043F\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043A\u0443\u0431\u0438\u043A. \u0412\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u0432\u044B\u0431\u0440\u043E\u0441\u0438\u0442\u044C 6, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043F\u0435\u0440\u0432\u0443\u044E \u0444\u0438\u0448\u043A\u0443 \u043D\u0430 \u0434\u043E\u0441\u043A\u0443!"
    },
    board: {
      title: "\u{1F3AE} \u0418\u0433\u0440\u043E\u0432\u0430\u044F \u0434\u043E\u0441\u043A\u0430",
      description: "\u042D\u0442\u043E \u0438\u0433\u0440\u043E\u0432\u0430\u044F \u0434\u043E\u0441\u043A\u0430 8\xD78. \u0424\u0438\u0448\u043A\u0438 \u0432\u044B\u0432\u043E\u0434\u044F\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u0443\u044E \u043A\u043B\u0435\u0442\u043A\u0443 (\u0443\u0433\u043E\u043B) \u0438 \u0434\u0430\u043B\u0435\u0435 \u0438\u0434\u0443\u0442 \u043F\u043E \u0447\u0430\u0441\u043E\u0432\u043E\u0439 \u0441\u0442\u0440\u0435\u043B\u043A\u0435 \u043F\u043E \u043F\u0435\u0440\u0438\u043C\u0435\u0442\u0440\u0443."
    },
    playerInfo: {
      title: "\u{1F4CA} \u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E\u0431 \u0438\u0433\u0440\u043E\u043A\u0430\u0445",
      description: "\u0417\u0434\u0435\u0441\u044C \u0432\u044B \u0432\u0438\u0434\u0438\u0442\u0435 \u0432\u0441\u0435\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432, \u0438\u0445 \u0444\u0438\u0448\u043A\u0438 \u0438 \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u0445\u043E\u0434. \u0421\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u043A\u0442\u043E \u0441\u0435\u0439\u0447\u0430\u0441 \u0445\u043E\u0434\u0438\u0442!"
    },
    selectPiece: {
      title: "\u{1F3AF} \u0428\u0430\u0433 1: \u0412\u044B\u0431\u043E\u0440 \u0444\u0438\u0448\u043A\u0438",
      description: "\u0412\u041E\u0422 \u0417\u0414\u0415\u0421\u042C \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u0430\u044F \u043A\u043B\u0435\u0442\u043A\u0430 (\u0443\u0433\u043E\u043B). \u041A\u043E\u0433\u0434\u0430 \u0432\u044B\u0431\u0440\u043E\u0441\u0438\u0442\u0435 6 \u2014 \u043A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u043D\u0430 \u0444\u0438\u0448\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u0432\u044B\u0432\u0435\u0441\u0442\u0438 \u0435\u0451 \u043D\u0430 \u0434\u043E\u0441\u043A\u0443."
    },
    placeButton: {
      title: "\u2705 \u0428\u0430\u0433 2: \u041A\u043D\u043E\u043F\u043A\u0430 \u043F\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438",
      description: '\u0417\u0414\u0415\u0421\u042C \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u043A\u043D\u043E\u043F\u043A\u0430 "\u041F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0444\u0438\u0448\u043A\u0443 \u043D\u0430 \u0434\u043E\u0441\u043A\u0443" \u043F\u043E\u0441\u043B\u0435 \u0432\u044B\u0431\u043E\u0440\u0430 \u0444\u0438\u0448\u043A\u0438. \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0435\u0451, \u0438 \u0444\u0438\u0448\u043A\u0430 \u0432\u0441\u0442\u0430\u043D\u0435\u0442 \u043D\u0430 \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u0443\u044E \u043F\u043E\u0437\u0438\u0446\u0438\u044E! \u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0431\u043E\u043D\u0443\u0441\u043D\u044B\u0439 \u0431\u0440\u043E\u0441\u043E\u043A!'
    },
    moveInstruction: {
      title: "\u{1F463} \u041A\u0430\u043A \u043F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0444\u0438\u0448\u043A\u0443",
      description: '\u041F\u043E\u0441\u043B\u0435 \u0431\u0440\u043E\u0441\u043A\u0430 \u043A\u0443\u0431\u0438\u043A\u0430: \u2460 \u041A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u043D\u0430 \u0441\u0432\u043E\u044E \u0444\u0438\u0448\u043A\u0443 \u043D\u0430 \u0434\u043E\u0441\u043A\u0435 \u2461 \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 "\u041F\u0435\u0440\u0435\u0434\u0432\u0438\u043D\u0443\u0442\u044C \u043D\u0430 X \u0448\u0430\u0433\u043E\u0432" \u0441\u043F\u0440\u0430\u0432\u0430. \u041F\u043E\u043C\u043D\u0438\u0442\u0435: \u043D\u0435\u043B\u044C\u0437\u044F \u043F\u0435\u0440\u0435\u043F\u0440\u044B\u0433\u0438\u0432\u0430\u0442\u044C \u0447\u0435\u0440\u0435\u0437 \u0434\u0440\u0443\u0433\u0438\u0435 \u0444\u0438\u0448\u043A\u0438!'
    },
    goal: {
      title: "\u{1F3C6} \u0426\u0435\u043B\u044C \u0438\u0433\u0440\u044B - \u0424\u0418\u041D\u0418\u0428\u041D\u0410\u042F \u0414\u0418\u0410\u0413\u041E\u041D\u0410\u041B\u042C!",
      description: "\u0412\u041E\u0422 \u041E\u041D\u0418 - \u0437\u043E\u043B\u043E\u0442\u044B\u0435 \u043A\u043B\u0435\u0442\u043A\u0438 (a8\u2192b7\u2192c6\u2192d5)! \u0417\u0430\u043F\u043E\u043B\u043D\u044F\u0439\u0442\u0435 \u0438\u0445 \u043E\u0442 \u0446\u0435\u043D\u0442\u0440\u0430 \u043D\u0430\u0440\u0443\u0436\u0443: \u0441\u043D\u0430\u0447\u0430\u043B\u0430 d5, \u0437\u0430\u0442\u0435\u043C c6, \u043F\u043E\u0442\u043E\u043C b7 \u0438 \u0432 \u043A\u043E\u043D\u0446\u0435 a8. \u041F\u0430\u0440\u0442\u0438\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u0435\u0442\u0441\u044F \u0434\u043E \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u0432\u0441\u0435\u0445 \u043C\u0435\u0441\u0442. \u041F\u0443\u0442\u044C: \u043F\u0435\u0440\u0438\u043C\u0435\u0442\u0440 (28 \u0448\u0430\u0433\u043E\u0432) \u2192 \u0444\u0438\u043D\u0438\u0448\u043D\u0430\u044F \u0434\u0438\u0430\u0433\u043E\u043D\u0430\u043B\u044C (4 \u043A\u043B\u0435\u0442\u043A\u0438)."
    }
  },
  common: {
    cancel: "\u041E\u0442\u043C\u0435\u043D\u0430",
    back: "\u041D\u0430\u0437\u0430\u0434",
    confirm: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
    close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
  },
  joinVote: {
    title: "\u0417\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435",
    wantsToJoin: "\u0445\u043E\u0447\u0435\u0442 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u0438\u0433\u0440\u0435",
    willReplaceBot: "\u0417\u0430\u043C\u0435\u043D\u0438\u0442 \u0431\u043E\u0442\u0430",
    keepPieces: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442 \u0444\u0438\u0448\u043A\u0438 \u0431\u043E\u0442\u0430",
    newPieces: "\u041D\u0430\u0447\u043D\u0451\u0442 \u0441 \u043D\u043E\u0432\u044B\u043C\u0438 \u0444\u0438\u0448\u043A\u0430\u043C\u0438",
    votes: "\u0413\u043E\u043B\u043E\u0441\u0430",
    approve: "\u0437\u0430",
    reject: "\u043F\u0440\u043E\u0442\u0438\u0432",
    total: "\u0432\u0441\u0435\u0433\u043E",
    approveButton: "\u041E\u0434\u043E\u0431\u0440\u0438\u0442\u044C",
    rejectButton: "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C",
    waiting: "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0433\u043E\u043B\u043E\u0441\u043E\u0432 \u0434\u0440\u0443\u0433\u0438\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432..."
  },
  joinStarted: {
    title: "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u043D\u0430\u0447\u0430\u0442\u043E\u0439 \u0438\u0433\u0440\u0435",
    gameInProgress: "\u042D\u0442\u0430 \u0438\u0433\u0440\u0430 \u0443\u0436\u0435 \u0438\u0434\u0435\u0442.",
    chooseOption: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043F\u043E\u0441\u043E\u0431 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F:",
    replaceBot: "\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u0431\u043E\u0442\u0430",
    replaceBotHint: "\u0417\u0430\u043D\u044F\u0442\u044C \u043C\u0435\u0441\u0442\u043E \u0431\u043E\u0442\u0430",
    newPlayer: "\u0412\u043E\u0439\u0442\u0438 \u043D\u043E\u0432\u044B\u043C \u0438\u0433\u0440\u043E\u043A\u043E\u043C",
    newPlayerHint: "\u041D\u0430\u0447\u0430\u0442\u044C \u0441 \u043D\u043E\u0432\u044B\u043C\u0438 \u0448\u0430\u0448\u043A\u0430\u043C\u0438",
    noOptions: "\u041D\u0435\u043B\u044C\u0437\u044F \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F: \u043D\u0435\u0442 \u0431\u043E\u0442\u043E\u0432 \u0434\u043B\u044F \u0437\u0430\u043C\u0435\u043D\u044B \u0438 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0445 \u043C\u0435\u0441\u0442.",
    note: "\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435",
    voteRequired: "\u0412\u0441\u0435 \u0438\u0433\u0440\u043E\u043A\u0438 \u0434\u043E\u043B\u0436\u043D\u044B \u043E\u0434\u043E\u0431\u0440\u0438\u0442\u044C \u0432\u0430\u0448 \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u0432\u0445\u043E\u0434.",
    replaceBotTitle: "\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u0431\u043E\u0442\u0430",
    selectBot: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u043E\u0442\u0430 \u0434\u043B\u044F \u0437\u0430\u043C\u0435\u043D\u044B:",
    selectBotPlaceholder: "-- \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u043E\u0442\u0430 --",
    keepPieces: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0448\u0430\u0448\u043A\u0438 \u0431\u043E\u0442\u0430 \u0438 \u0442\u0435\u043A\u0443\u0449\u0443\u044E \u043F\u043E\u0437\u0438\u0446\u0438\u044E",
    keepPiecesHint: "\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0442\u0435\u043A\u0443\u0449\u0438\u0435 \u0448\u0430\u0448\u043A\u0438 \u0438 \u043F\u043E\u0437\u0438\u0446\u0438\u044E \u0431\u043E\u0442\u0430",
    resetPiecesHint: "\u0428\u0430\u0448\u043A\u0438 \u0431\u043E\u0442\u0430 \u0431\u0443\u0434\u0443\u0442 \u0441\u0431\u0440\u043E\u0448\u0435\u043D\u044B \u0432 \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u0443\u0433\u043E\u043B",
    yourName: "\u0412\u0430\u0448\u0435 \u0438\u043C\u044F",
    sendRequest: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u043F\u0440\u043E\u0441",
    newPlayerTitle: "\u0412\u043E\u0439\u0442\u0438 \u043D\u043E\u0432\u044B\u043C \u0438\u0433\u0440\u043E\u043A\u043E\u043C",
    newPlayerInfo: "\u0412\u044B \u0432\u043E\u0439\u0434\u0435\u0442\u0435 \u0432 \u0438\u0433\u0440\u0443 \u0441 \u043D\u043E\u0432\u044B\u043C\u0438 \u0448\u0430\u0448\u043A\u0430\u043C\u0438 \u0432 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E\u043C \u0443\u0433\u043B\u0443.",
    currentPlayers: "\u0422\u0435\u043A\u0443\u0449\u0438\u0435 \u0438\u0433\u0440\u043E\u043A\u0438",
    lateJoinWarning: "\u0412\u044B \u0432\u0445\u043E\u0434\u0438\u0442\u0435 \u043F\u043E\u0437\u0436\u0435, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u0443 \u0434\u0440\u0443\u0433\u0438\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0443\u0436\u0435 \u0435\u0441\u0442\u044C \u043F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u043E!",
    waitingApproval: "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F",
    waitingApprovalText: "\u0418\u0433\u0440\u043E\u043A\u0438 \u0433\u043E\u043B\u043E\u0441\u0443\u044E\u0442 \u0437\u0430 \u0432\u0430\u0448 \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u0432\u0445\u043E\u0434."
  },
  userAgreement: {
    title: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435",
    close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    acceptance: {
      title: "1. \u041F\u0440\u0438\u043D\u044F\u0442\u0438\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u0439",
      description: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0438\u0433\u0440\u0443 SheshDash, \u0432\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F. \u0415\u0441\u043B\u0438 \u0432\u044B \u043D\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u044B \u0441 \u044D\u0442\u0438\u043C\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043D\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0438\u0433\u0440\u0443."
    },
    gameRules: {
      title: "2. \u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438\u0433\u0440\u044B",
      description: "\u0418\u0433\u0440\u043E\u043A\u0438 \u043E\u0431\u044F\u0437\u0443\u044E\u0442\u0441\u044F \u0441\u043E\u0431\u043B\u044E\u0434\u0430\u0442\u044C \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438\u0433\u0440\u044B SheshDash. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0431\u043E\u0442\u043E\u0432 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u0430, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u0438\u0433\u0440\u043E\u0439. \u041B\u044E\u0431\u044B\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0438 \u043E\u0431\u043C\u0430\u043D\u0430, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0447\u0438\u0442\u043E\u0432 \u0438\u043B\u0438 \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u0438 \u0443\u044F\u0437\u0432\u0438\u043C\u043E\u0441\u0442\u0435\u0439 \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u044B."
    },
    intellectualProperty: {
      title: "3. \u0418\u043D\u0442\u0435\u043B\u043B\u0435\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C",
      description: "\u0412\u0441\u0435 \u043F\u0440\u0430\u0432\u0430 \u043D\u0430 \u0438\u0433\u0440\u0443 SheshDash, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043A\u043E\u0434, \u0434\u0438\u0437\u0430\u0439\u043D, \u0433\u0440\u0430\u0444\u0438\u043A\u0443, \u0441\u0435\u0440\u0432\u0435\u0440\u043D\u0443\u044E \u043B\u043E\u0433\u0438\u043A\u0443, \u043C\u0435\u0445\u0430\u043D\u0438\u043A\u0443 \u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438\u0433\u0440\u044B, \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0442 \u0430\u0432\u0442\u043E\u0440\u0443 Vadim Maltsev. \u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0438\u0433\u0440\u044B \xABSheshDash\xBB \u0437\u0430\u043A\u0440\u0435\u043F\u043B\u0435\u043D\u043E \u0437\u0430 \u043F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C. \u041F\u0440\u043E\u0435\u043A\u0442 \u043D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u043C (open source). \u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435, \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0438\u043B\u0438 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0438\u0433\u0440\u044B \u0431\u0435\u0437 \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0430\u0432\u0442\u043E\u0440\u0430 \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u044B."
    },
    userConduct: {
      title: "4. \u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043F\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F",
      items: [
        "\u0423\u0432\u0430\u0436\u0430\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u0438\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0438 \u043D\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043E\u0441\u043A\u043E\u0440\u0431\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
        "\u041D\u0435 \u043F\u044B\u0442\u0430\u0439\u0442\u0435\u0441\u044C \u0432\u0437\u043B\u043E\u043C\u0430\u0442\u044C \u0438\u043B\u0438 \u043D\u0430\u0440\u0443\u0448\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0438\u0433\u0440\u044B",
        "\u041D\u0435 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u043C\u043D\u043E\u0436\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u044B \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043D\u0435\u0441\u043F\u0440\u0430\u0432\u0435\u0434\u043B\u0438\u0432\u043E\u0433\u043E \u043F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0430",
        "\u0421\u043E\u043E\u0431\u0449\u0430\u0439\u0442\u0435 \u043E \u043D\u0430\u0439\u0434\u0435\u043D\u043D\u044B\u0445 \u043E\u0448\u0438\u0431\u043A\u0430\u0445 \u0438 \u0443\u044F\u0437\u0432\u0438\u043C\u043E\u0441\u0442\u044F\u0445 \u0430\u0432\u0442\u043E\u0440\u0443"
      ]
    },
    disclaimer: {
      title: "5. \u041E\u0442\u043A\u0430\u0437 \u043E\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438",
      description: '\u0418\u0433\u0440\u0430 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F "\u043A\u0430\u043A \u0435\u0441\u0442\u044C" \u0431\u0435\u0437 \u043A\u0430\u043A\u0438\u0445-\u043B\u0438\u0431\u043E \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0439. \u0410\u0432\u0442\u043E\u0440 \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u043B\u044E\u0431\u044B\u0435 \u0443\u0431\u044B\u0442\u043A\u0438 \u0438\u043B\u0438 \u0443\u0449\u0435\u0440\u0431, \u0432\u043E\u0437\u043D\u0438\u043A\u0448\u0438\u0435 \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0438\u0433\u0440\u044B.'
    },
    changes: {
      title: "6. \u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F",
      description: "\u0410\u0432\u0442\u043E\u0440 \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u0430\u0432\u043E \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F. \u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0438\u0433\u0440\u044B \u043F\u043E\u0441\u043B\u0435 \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442 \u0432\u0430\u0448\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0441 \u043D\u043E\u0432\u044B\u043C\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438."
    },
    copyright: '\xA9 2026 \u0418\u0433\u0440\u0430 "SheshDash". \u0412\u0441\u0435 \u043F\u0440\u0430\u0432\u0430 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u044B.',
    author: "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A: Vadim Maltsev",
    prohibited: {
      title: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0437\u0430\u043F\u0440\u0435\u0449\u0430\u0435\u0442\u0441\u044F",
      items: [
        "\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C, \u0432\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u044C \u0438\u043B\u0438 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u0442\u044C \u0438\u0433\u0440\u0443",
        "\u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043A\u043B\u043E\u043D\u044B, \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0438 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u044B",
        "\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0434, \u0434\u0438\u0437\u0430\u0439\u043D, \u043C\u0435\u0445\u0430\u043D\u0438\u043A\u0443 \u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438\u0433\u0440\u044B",
        "\u0437\u0430\u043F\u0443\u0441\u043A\u0430\u0442\u044C \u0438\u0433\u0440\u0443 \u0438\u043B\u0438 \u0435\u0451 \u0447\u0430\u0441\u0442\u0438 \u043F\u043E\u0434 \u0441\u0432\u043E\u0438\u043C \u0438\u043C\u0435\u043D\u0435\u043C"
      ]
    },
    exclusiveRights: {
      title: "\u0418\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0430",
      description: "\u0412\u0441\u0435 \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0430 \u043D\u0430 \u0438\u0433\u0440\u0443 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0442 \u043F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E."
    },
    legalInfo: {
      title: "\u041F\u0440\u0430\u0432\u043E\u0432\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F",
      description: "\u0418\u0433\u0440\u0430 SheshDash \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0440\u043E\u043F\u0440\u0438\u0435\u0442\u0430\u0440\u043D\u044B\u043C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u044B\u043C \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0435\u043C. \u041B\u044E\u0431\u043E\u0435 \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435, \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0438 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u044B \u0431\u0435\u0437 \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u043F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F."
    }
  },
  navigation: {
    backToHome: "\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E"
  },
  donate: {
    title: "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442",
    thankYou: "\u0421\u043F\u0430\u0441\u0438\u0431\u043E \u0437\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443!",
    description: "SheshDash \u2014 \u043D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442. \u0412\u0430\u0448\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430 \u043F\u043E\u043C\u043E\u0433\u0430\u0435\u0442 \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0442\u044C \u0441\u0435\u0440\u0432\u0435\u0440\u044B \u0438 \u0440\u0430\u0437\u0432\u0438\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u0443.",
    waysToSupport: "\u0414\u0440\u0443\u0433\u0438\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u044B \u043F\u043E\u043C\u043E\u0447\u044C",
    spreadWord: "\u0420\u0430\u0441\u0441\u043A\u0430\u0436\u0438\u0442\u0435 \u043E \u043D\u0430\u0441",
    spreadWordDesc: "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C SheshDash \u0441 \u0434\u0440\u0443\u0437\u044C\u044F\u043C\u0438 \u0438 \u0437\u043D\u0430\u043A\u043E\u043C\u044B\u043C\u0438.",
    reportBugs: "\u0421\u043E\u043E\u0431\u0449\u0430\u0439\u0442\u0435 \u043E\u0431 \u043E\u0448\u0438\u0431\u043A\u0430\u0445",
    reportBugsDesc: "\u041F\u043E\u043C\u043E\u0433\u0430\u0439\u0442\u0435 \u0443\u043B\u0443\u0447\u0448\u0430\u0442\u044C \u0438\u0433\u0440\u0443, \u0441\u043E\u043E\u0431\u0449\u0430\u044F \u043E \u0431\u0430\u0433\u0430\u0445.",
    suggestFeatures: "\u041F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0439\u0442\u0435 \u0438\u0434\u0435\u0438",
    suggestFeaturesDesc: "\u0415\u0441\u0442\u044C \u0438\u0434\u0435\u044F? \u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435, \u0447\u0442\u043E \u0431\u044B \u0432\u044B \u0445\u043E\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u0435\u0442\u044C.",
    chooseCountry: "\u0413\u0434\u0435 \u0432\u044B \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0435\u0441\u044C?",
    countryHelp: "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u043C \u043B\u0435\u0433\u0430\u043B\u044C\u043D\u044B\u0435 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u043F\u043E \u0440\u0435\u0433\u0438\u043E\u043D\u0430\u043C. \u0415\u0441\u043B\u0438 \u0447\u0442\u043E-\u0442\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0432 \u0432\u0430\u0448\u0435\u0439 \u0441\u0442\u0440\u0430\u043D\u0435, \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0441\u043A\u0430\u0436\u0435\u0442 \u043E\u0431 \u044D\u0442\u043E\u043C.",
    countryRussia: "\u0420\u043E\u0441\u0441\u0438\u044F",
    countryInternational: "\u0414\u0440\u0443\u0433\u0438\u0435 \u0441\u0442\u0440\u0430\u043D\u044B",
    optionsTitle: "\u0414\u043E\u043D\u0430\u0442 \u0447\u0435\u0440\u0435\u0437 Boosty",
    platformBoostyTitle: "Boosty",
    platformBoostyDesc: "\u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0438 \u0438 \u0440\u0430\u0437\u043E\u0432\u0430\u044F \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430; \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u043D\u0430 \u043A\u0430\u0440\u0442\u044B \u0432 \u0420\u0424.",
    platformCloudtipsTitle: "CloudTips",
    platformCloudtipsDesc: "\u0414\u043E\u043D\u0430\u0442\u044B \u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u0440\u043E\u0432; \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u043D\u0430 \u043A\u0430\u0440\u0442\u044B \u0432 \u0420\u0424.",
    platformDonationAlertsTitle: "DonationAlerts",
    platformDonationAlertsDesc: "\u0414\u043E\u043D\u0430\u0442\u044B \u0434\u043B\u044F \u0441\u0442\u0440\u0438\u043C\u043E\u0432; \u043F\u043E\u0434\u0445\u043E\u0434\u0438\u0442, \u0435\u0441\u043B\u0438 \u0432\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0435 \u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u0438.",
    platformPatreonTitle: "Patreon",
    platformPatreonDesc: "\u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u0440\u043E\u0432. \u0412 \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0441\u0442\u0440\u0430\u043D\u0430\u0445 \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B (\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0420\u0424).",
    platformBmacTitle: "Buy Me a Coffee",
    platformBmacDesc: "\u0420\u0430\u0437\u043E\u0432\u044B\u0435 \u0438 \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u044B\u0435 \u0434\u043E\u043D\u0430\u0442\u044B \u0447\u0435\u0440\u0435\u0437 Stripe; \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442\u044C \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0441\u0442\u0440\u0430\u043D\u044B.",
    platformKofiTitle: "Ko-fi",
    platformKofiDesc: "\u0414\u043E\u043D\u0430\u0442\u044B \u0447\u0435\u0440\u0435\u0437 Stripe/PayPal; \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442\u044C \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0441\u0442\u0440\u0430\u043D\u044B.",
    platformGithubTitle: "GitHub Sponsors",
    platformGithubDesc: "\u0415\u0441\u043B\u0438 \u043F\u0440\u043E\u0435\u043A\u0442 \u043E\u0442\u043A\u0440\u044B\u0442 \u0438 \u0432\u044B \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C\u043E\u043C \u0440\u0435\u0433\u0438\u043E\u043D\u0435.",
    statusSetup: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0430\u0435\u043C",
    statusCheckCountry: "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442\u044C",
    statusStreaming: "\u0422\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u0441\u0442\u0440\u0438\u043C\u043E\u0432",
    availabilityNote: "\u0415\u0441\u043B\u0438 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u043D\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0432 \u0432\u0430\u0448\u0435\u0439 \u0441\u0442\u0440\u0430\u043D\u0435, \u043E\u043D\u0430 \u043D\u0435 \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u043F\u0440\u0438\u043D\u044F\u0442\u044C \u0434\u043E\u043D\u0430\u0442.",
    boostyTitle: "Boosty",
    boostyDesc: "\u0420\u0430\u0437\u043E\u0432\u0430\u044F \u0438\u043B\u0438 \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u0430\u044F \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430. \u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 Boosty.",
    boostyButton: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C Boosty",
    boostyQrAlt: "QR-\u043A\u043E\u0434 \u0434\u043B\u044F \u0434\u043E\u043D\u0430\u0442\u0430 \u043D\u0430 Boosty",
    boostyQrHint: "\u041E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043A\u0440\u044B\u0442\u044C Boosty."
  },
  account: {
    title: "\u0410\u043A\u043A\u0430\u0443\u043D\u0442",
    loginTitle: "\u0412\u0445\u043E\u0434",
    loginDesc: "\u0412\u043E\u0439\u0434\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0442\u044C \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443 \u0438 \u0438\u0441\u0442\u043E\u0440\u0438\u044E \u0438\u0433\u0440.",
    loginGoogle: "\u0412\u043E\u0439\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 Google",
    loginTelegram: "\u0412\u043E\u0439\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 Telegram",
    playAsGuest: "\u0418\u0433\u0440\u0430\u0442\u044C \u043A\u0430\u043A \u0433\u043E\u0441\u0442\u044C",
    settings: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430",
    displayName: "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u043C\u043E\u0435 \u0438\u043C\u044F",
    save: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
    saved: "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E!",
    logout: "\u0412\u044B\u0439\u0442\u0438",
    logoutConfirm: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0432\u044B\u0439\u0442\u0438?",
    linkedAccounts: "\u041F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u044B",
    memberSince: "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A \u0441",
    dangerZone: "\u041E\u043F\u0430\u0441\u043D\u0430\u044F \u0437\u043E\u043D\u0430",
    deleteAccount: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    preferredColor: "\u041F\u0440\u0435\u0434\u043F\u043E\u0447\u0438\u0442\u0430\u0435\u043C\u044B\u0439 \u0446\u0432\u0435\u0442"
  },
  profile: {
    title: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C \u0438\u0433\u0440\u043E\u043A\u0430",
    player: "\u0418\u0433\u0440\u043E\u043A",
    gamesPlayed: "\u0418\u0433\u0440 \u0441\u044B\u0433\u0440\u0430\u043D\u043E",
    wins: "\u041F\u043E\u0431\u0435\u0434",
    winRate: "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u043F\u043E\u0431\u0435\u0434",
    secondPlace: "2-\u0435 \u043C\u0435\u0441\u0442\u043E",
    thirdPlace: "3-\u0435 \u043C\u0435\u0441\u0442\u043E",
    fourthPlace: "4-\u0435 \u043C\u0435\u0441\u0442\u043E",
    matchHistory: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u043C\u0430\u0442\u0447\u0435\u0439",
    noMatches: "\u041C\u0430\u0442\u0447\u0435\u0439 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442.",
    placement: "\u041C\u0435\u0441\u0442\u043E",
    date: "\u0414\u0430\u0442\u0430",
    players: "\u0418\u0433\u0440\u043E\u043A\u0438",
    loadMore: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0435\u0449\u0451"
  },
  leaderboard: {
    title: "\u041B\u0443\u0447\u0448\u0438\u0435 \u0438\u0433\u0440\u043E\u043A\u0438",
    rank: "#",
    player: "\u0418\u0433\u0440\u043E\u043A",
    wins: "\u041F\u043E\u0431\u0435\u0434\u044B",
    games: "\u0418\u0433\u0440\u044B",
    winRate: "% \u043F\u043E\u0431\u0435\u0434",
    noData: "\u0418\u0433\u0440 \u043F\u043E\u043A\u0430 \u043D\u0435 \u0431\u044B\u043B\u043E."
  },
  skin: {
    human: "\u0427\u0435\u043B\u043E\u0432\u0435\u043A",
    guest: "\u0413\u043E\u0441\u0442\u044C",
    gameStatus: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0438\u0433\u0440\u044B",
    gameInProgress: "\u0418\u0433\u0440\u0430 \u0438\u0434\u0451\u0442...",
    gameLog: "\u0416\u0443\u0440\u043D\u0430\u043B \u0438\u0433\u0440\u044B",
    noEvents: "\u0421\u043E\u0431\u044B\u0442\u0438\u0439 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442",
    waitingForEvents: "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u0439...",
    gamePaused: "\u0418\u0433\u0440\u0430 \u043D\u0430 \u043F\u0430\u0443\u0437\u0435..."
  },
  admin: {
    title: "\u041F\u0430\u043D\u0435\u043B\u044C \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430",
    accessDenied: "\u0414\u043E\u0441\u0442\u0443\u043F \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u043E\u0432.",
    goToAccount: "\u0412 \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    loadError: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430",
    announcement: {
      title: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u0438\u0433\u0440\u044B",
      placeholder: '\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: "\u0427\u0435\u0440\u0435\u0437 5 \u043C\u0438\u043D\u0443\u0442 \u0431\u0443\u0434\u0435\u0442 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0438\u0433\u0440\u044B"',
      preview: "\u041F\u0440\u0435\u0434\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
      publishNow: "\u0420\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0441\u0440\u0430\u0437\u0443",
      startTime: "\u0412\u0440\u0435\u043C\u044F \u0441\u0442\u0430\u0440\u0442\u0430",
      endTime: "\u0412\u0440\u0435\u043C\u044F \u0441\u043D\u044F\u0442\u0438\u044F (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
      publish: "\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C",
      publishing: "\u0421\u043E\u0445\u0440\u0430\u043D\u044F\u044E...",
      deactivate: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
      deactivateConfirm: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0442\u0435\u043A\u0443\u0449\u0435\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435?",
      message: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
      status: "\u0421\u0442\u0430\u0442\u0443\u0441",
      timeWindow: "\u041E\u043A\u043D\u043E",
      noEndTime: "\u0431\u0435\u0437 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F",
      active: "\u0430\u043A\u0442\u0438\u0432\u0435\u043D",
      inactive: "\u043D\u0435\u0430\u043A\u0442\u0438\u0432\u0435\u043D"
    },
    users: {
      title: "\u0418\u0433\u0440\u043E\u043A\u0438",
      player: "\u0418\u0433\u0440\u043E\u043A",
      email: "\u042D\u043B. \u043F\u043E\u0447\u0442\u0430",
      role: "\u0420\u043E\u043B\u044C",
      ban: "\u0411\u0430\u043D",
      banned: "\u0417\u0430\u0431\u0430\u043D\u0435\u043D",
      active: "\u0410\u043A\u0442\u0438\u0432\u0435\u043D"
    },
    markdown: {
      bold: "\u0436\u0438\u0440\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442",
      italic: "\u043A\u0443\u0440\u0441\u0438\u0432",
      code: "\u043A\u043E\u0434",
      link: "\u0441\u0441\u044B\u043B\u043A\u0430",
      listItem: "\u043F\u0443\u043D\u043A\u0442"
    },
    news: {
      title: "\u041D\u043E\u0432\u043E\u0441\u0442\u0438 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u043E\u0439",
      versionLabel: "\u0412\u0435\u0440\u0441\u0438\u044F",
      versionPlaceholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: 0.0.26",
      contentLabel: "\u0427\u0442\u043E \u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u043D\u043E",
      contentPlaceholder: "\u041E\u043F\u0438\u0448\u0438, \u0447\u0442\u043E \u0432\u043E\u0448\u043B\u043E \u0432 \u044D\u0442\u0443 \u0432\u0435\u0440\u0441\u0438\u044E.",
      publishLabel: "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u043E\u0439",
      preview: "\u041F\u0440\u0435\u0434\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
      create: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0441\u0442\u044C",
      update: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F",
      saving: "\u0421\u043E\u0445\u0440\u0430\u043D\u044F\u044E...",
      cancelEdit: "\u041E\u0442\u043C\u0435\u043D\u0430",
      edit: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
      delete: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
      deleteConfirm: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u043D\u043E\u0432\u043E\u0441\u0442\u044C?",
      published: "\u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u043E",
      draft: "\u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A",
      empty: "\u041D\u043E\u0432\u043E\u0441\u0442\u0435\u0439 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442.",
      hideBlockLabel: "\u0421\u043A\u0440\u044B\u0442\u044C \u0432\u0435\u0441\u044C \u0431\u043B\u043E\u043A \u043D\u043E\u0432\u043E\u0441\u0442\u0435\u0439",
      hideItemLabel: "\u0421\u043A\u0440\u044B\u0442\u044C \u044D\u0442\u0443 \u043D\u043E\u0432\u043E\u0441\u0442\u044C",
      hidden: "\u0441\u043A\u0440\u044B\u0442\u043E",
      subtitle: "\u0421\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0435 \u043D\u043E\u0432\u043E\u0441\u0442\u0435\u0439 \u0442\u0435\u043F\u0435\u0440\u044C \u0431\u0435\u0440\u0435\u0442\u0441\u044F \u0438\u0437 \u0432\u0435\u0440\u0441\u0438\u043E\u043D\u0438\u0440\u0443\u0435\u043C\u044B\u0445 \u0444\u0430\u0439\u043B\u043E\u0432 \u0432 \u0440\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0440\u0438\u0438.",
      fileBasedHint: "\u0427\u0442\u043E\u0431\u044B \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0442\u0435\u043A\u0441\u0442\u044B \u043D\u043E\u0432\u043E\u0441\u0442\u0435\u0439 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u043E\u0439, \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0443\u0439 \u044F\u0437\u044B\u043A\u043E\u0432\u044B\u0435 \u0444\u0430\u0439\u043B\u044B \u043D\u043E\u0432\u043E\u0441\u0442\u0435\u0439 \u043F\u0440\u044F\u043C\u043E \u0432 \u0440\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0440\u0438\u0438."
    }
  },
  news: {
    title: "\u041D\u043E\u0432\u043E\u0441\u0442\u0438 \u0438\u0433\u0440\u044B",
    subtitle: "\u0412\u0435\u0440\u0441\u0438\u0438 \u0438 \u0447\u0442\u043E \u0443\u0436\u0435 \u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u043D\u043E.",
    empty: "\u041D\u043E\u0432\u043E\u0441\u0442\u0435\u0439 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442."
  },
  settings: {
    soundOn: "\u0417\u0432\u0443\u043A \u0432\u043A\u043B\u044E\u0447\u0451\u043D",
    soundOff: "\u0417\u0432\u0443\u043A \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D"
  }
};

// src/i18n/locales/de.json
var de_default = {
  meta: {
    title: "SheshDash - Mehrspieler-Brettspiel",
    description: "Ein Mehrspieler-Brettspiel f\xFCr 4 Spieler. Bewege deine Figuren \xFCber das Brett und sei der Erste, der das Zentrum erreicht!",
    fullDescription: "SheshDash - Ein Brettspiel f\xFCr 2-4 Spieler. W\xFCrfle, bewege deine Figuren \xFCber das Brett und sei der Erste im Zentrum, um zu gewinnen!"
  },
  landing: {
    playNow: "Jetzt spielen",
    learnRules: "Regeln lernen",
    termsOfService: "Nutzungsbedingungen",
    supportProject: "Projekt unterst\xFCtzen",
    myAccount: "Mein Konto",
    copyright: "\xA9 2026 SheshDash. Entwickler: Vadim Maltsev"
  },
  versionBanner: {
    updateAvailable: "Eine neue Version ist verf\xFCgbar",
    updateHint: "Aktuell: {{current}}. Neu: {{latest}}. Aktualisieren Sie die Seite, wenn es Ihnen passt.",
    incompatibleTitle: "Dieser Tab ist veraltet",
    incompatibleHint: "Aktuell: {{current}}. Minimal unterst\xFCtzt: {{minimum}}. Aktualisieren Sie die Seite, um sicher fortzufahren.",
    refreshNow: "Jetzt aktualisieren",
    later: "Sp\xE4ter",
    inGameWarning: "Du bist in einem aktiven Spiel. Das Aktualisieren trennt dich kurz \u2014 du solltest dich automatisch wieder verbinden.",
    inGameProceed: "Trotzdem aktualisieren",
    inGameCancel: "Im Spiel bleiben"
  },
  game: {
    title: "SheshDash Spiel",
    gameId: "Spiel-ID",
    copyId: "ID kopieren",
    idCopied: "Spiel-ID in Zwischenablage kopiert!",
    createGame: "Neues Spiel erstellen",
    privateGame: "Privates Spiel (aus der Online-Liste ausblenden)",
    joinGame: "Spiel beitreten",
    joinGameButton: "Spiel beitreten",
    startGame: "Spiel starten",
    back: "Zur\xFCck",
    yourName: "Dein Name",
    gameIdPlaceholder: "Spiel-ID",
    connected: "Verbunden",
    connecting: "Verbinden...",
    waitingForPlayers: "Warte auf Spieler...",
    players: "Spieler",
    shareGameId: "Teile die Spiel-ID mit Freunden!",
    canStartWithPlayers: "Du kannst mit 2-4 Spielern starten. Klicke 'Spiel starten' wenn bereit!",
    needMorePlayers: "Mindestens 2 Spieler erforderlich.",
    botSuggestion: "Bot-Vorschlag in",
    currentPlayers: "Aktuelle Spieler:",
    yourTurn: "Du bist dran!",
    waiting: "Warten...",
    rolled: "Gew\xFCrfelt",
    gameOver: "Spiel vorbei!",
    exitGame: "Spiel verlassen",
    winner: "Gewinner",
    turnTimer: "Verbleibend",
    results: "Endstand",
    place: "Platz",
    preferredColor: "Bevorzugte Farbe",
    autoAssignColor: "Automatisch",
    colorRed: "Rot",
    colorBlue: "Blau",
    colorGreen: "Gr\xFCn",
    colorOrange: "Orangefarben",
    pause: "Pausieren",
    resume: "Fortsetzen",
    paused: "Pausiert",
    pausedHint: "Das Spiel ist pausiert. Zum Fortsetzen auf \u201EFortsetzen\u201C klicken.",
    onlyCreatorCanStart: "Nur der Ersteller kann das Spiel starten."
  },
  kickVote: {
    confirm: "{{name}} aus dem Spiel entfernen?",
    title: "Spieler entfernen?",
    requestsToKick: "m\xF6chte entfernen",
    targetBot: "Ziel: Bot",
    targetHuman: "Ziel: Spieler",
    votes: "Stimmen",
    approve: "Zustimmen",
    reject: "Ablehnen",
    waiting: "Warten auf weitere Stimmen",
    readOnly: "Abstimmung l\xE4uft",
    kickedTitle: "Du wurdest aus dem Spiel entfernt",
    kickedNotice: "Deine Figuren sind jetzt transparent und blockieren das Spiel nicht mehr.",
    returnToLobby: "Zur\xFCck zur Lobby",
    observeGame: "Spiel beobachten"
  },
  actions: {
    yourActions: "Deine Aktionen",
    rollDice: "W\xFCrfle um deinen Zug zu beginnen!",
    needSix: "Du brauchst eine 6 um deine erste Figur zu setzen!",
    rolledSix: "Du hast eine 6 gew\xFCrfelt! Bonuswurf garantiert!",
    rolledSixOptions: [
      "Neue Figur setzen (falls verf\xFCgbar)",
      "ODER bestehende Figur 6 Schritte bewegen"
    ],
    rolledSixNote: "Beide Optionen geben dir einen weiteren Wurf!",
    selectPiece: "W\xE4hle eine Figur um {{steps}} Schritte zu ziehen.",
    selectedPiece: "Gew\xE4hlte Figur: {{state}}",
    placePiece: "Figur setzen",
    moveSteps: "{{steps}} Schritte ziehen",
    deselect: "Abw\xE4hlen"
  },
  instructions: {
    title: "Spielanleitung:",
    rules: [
      "Die Figuren starten au\xDFerhalb des Bretts; w\xFCrfle eine 6, um eine auf das Startfeld (Ecke) zu setzen.",
      "Bewege Figuren im Uhrzeigersinn um das Brett",
      "Nach einer vollen Runde diagonal zur Mitte ziehen",
      "Erster Spieler mit allen 4 Figuren in der Mitte gewinnt!"
    ]
  },
  gameMode: {
    title: "Wie m\xF6chtest du spielen?",
    quickStart: "Schnellstart",
    quickStartDesc: "gegen 3 Bots, startet sofort",
    withFriends: "Mit Freunden",
    withFriendsDesc: "Code teilen, auf Freunde warten",
    findPlayers: "Spieler finden",
    findPlayersDesc: "\xF6ffentliche Lobby, jeder kann beitreten"
  },
  bots: {
    addTitle: "Bot-Spieler hinzuf\xFCgen?",
    addDescription: "Niemand ist beigetreten. M\xF6chtest du Bots hinzuf\xFCgen?",
    needMore: "Du brauchst noch {{count}} Spieler.",
    addButton: "{{count}} Bot hinzuf\xFCgen",
    addButtonPlural: "{{count}} Bots hinzuf\xFCgen",
    waitForPlayers: "Auf Spieler warten"
  },
  turn: {
    currentTurn: "Aktueller Zug",
    you: "Dein",
    skipped: "Zug \xFCbersprungen",
    completed: "Zug beendet"
  },
  errors: {
    error: "Fehler",
    pathBlocked: "Weg blockiert - kann nicht \xFCber Figuren springen",
    cannotLandOnOwnPiece: "Kann nicht auf eigene Figur ziehen",
    pieceInCorner: "Figur ist in der Reserve, du musst eine 6 w\xFCrfeln, um sie zu setzen",
    pieceAlreadyInCenter: "Figur bereits in Mitte",
    needToRoll6: "6 w\xFCrfeln zum Setzen",
    pieceNotInCorner: "Figur ist nicht in der Reserve",
    pieceNotFound: "Figur nicht gefunden",
    notYourTurn: "Nicht dein Zug",
    gameNotInProgress: "Spiel l\xE4uft nicht",
    stepsMustMatchDice: "Schritte m\xFCssen W\xFCrfel entsprechen",
    needExactRollForCenter: "Exakter Wurf f\xFCr Mitte erforderlich",
    onlyCreatorCanStart: "Nur der Ersteller des Spiels kann es starten",
    playerNameTaken: "Dieser Spielername ist in diesem Spiel bereits vergeben"
  },
  pieceStates: {
    in_corner: "In Reserve",
    on_perimeter: "Auf Brett",
    on_diagonal: "Auf Diagonale",
    in_center: "In Mitte"
  },
  playerInfo: {
    title: "Spieler",
    you: "(Du)",
    turn: "Zug",
    corner: "In Reserve:",
    onBoard: "Auf Brett:",
    inCenter: "In Mitte:",
    waitingFor: "Warte auf {{count}} Spieler...",
    statusRolled6: "Bonus!",
    statusCaptured: "Gefangen! Bonus!",
    statusPlacedPiece: "Gesetzt, Bonus!",
    statusMovedOn6: "6 gezogen, Bonus!",
    statusTurnSkipped: "\xDCbersprungen",
    statusTurnComplete: "Zug beendet"
  },
  dice: {
    rollDice: "W\xFCrfeln",
    rolled6Message: "Du hast eine 6 gew\xFCrfelt! Du kannst eine neue Figur setzen ODER eine bestehende 6 Schritte bewegen.",
    rolledBy: "Gew\xFCrfelt von",
    round: "Runde",
    rolls: "W\xFCrfe",
    captureBonus: "Fangbonus"
  },
  board: {
    currentPlayer: "Aktueller Spieler",
    historyStart: "Erste",
    historyPrev: "Zur\xFCck",
    historyNext: "Weiter",
    historyEnd: "Letzte",
    historyViewingPast: "Verlaufsmodus: Aktionen sind deaktiviert"
  },
  rules: {
    title: "Spielregeln",
    close: "Schlie\xDFen",
    showRules: "Regeln",
    objective: {
      title: "Ziel",
      description: "Sei der erste Spieler, der alle 4 Figuren vom Startfeld (Ecke) \xFCber den Rand, den diagonalen Pfad und ins Zentrum bringt."
    },
    setup: {
      title: "Aufbau",
      items: [
        "Jeder Spieler beginnt mit 4 Figuren au\xDFerhalb des Bretts (in Reserve)",
        "Spieler ziehen im Uhrzeigersinn",
        "Alle Figuren starten au\xDFerhalb bis eine 6 gew\xFCrfelt wird"
      ]
    },
    gameplay: {
      title: "Spielablauf",
      items: [
        "W\xFCrfle um Schritte zu bestimmen",
        "Zum Setzen der ersten Figur brauchst du eine 6",
        "Figuren bewegen sich im Uhrzeigersinn um den Rand (28 Positionen)",
        "Nach voller Runde diagonal zur Mitte (4 Schritte)",
        "Du kannst Figuren in der Reserve nicht bewegen, solange du keine 6 w\xFCrfelst"
      ]
    },
    rolling6: {
      title: "Eine 6 w\xFCrfeln",
      description: "Bei einer 6 hast du zwei Optionen:",
      options: [
        "Eine neue Figur auf das Startfeld (Ecke) setzen",
        "Bestehende Figur 6 Schritte vorw\xE4rts bewegen"
      ],
      note: "Beide geben Bonuswurf! Du kannst weiter w\xFCrfeln solange du 6en w\xFCrfelst."
    },
    capturing: {
      title: "Schlagen",
      items: [
        "Wenn deine Figur EXAKT auf gegnerischer Figur landet, schl\xE4gst du sie",
        "Die geschlagene Figur wird vom Brett genommen und in die Reserve des Gegners zur\xFCckgelegt",
        "Schlagen nur durch genaues Landen, nicht durch \xDCberspringen",
        "Schlagen gibt Bonuswurf (extra Zug)"
      ]
    },
    blocking: {
      title: "Blockieren",
      description: "Du KANNST NICHT \xFCber Figuren springen! Wenn eine Figur (deine oder gegnerische) im Weg ist, kannst du nicht vorbei. Der gesamte Weg muss frei sein."
    },
    winning: {
      title: "Gewinnen",
      description: "Der erste Spieler, der alle 4 Figuren in die Mitte bewegt, gewinnt!"
    },
    bonusRolls: {
      title: "Bonusw\xFCrfe",
      items: [
        "Bonuswurf bei 6 (egal ob Setzen oder Bewegen)",
        "Bonuswurf beim Schlagen gegnerischer Figur",
        "Bonusw\xFCrfe k\xF6nnen sich stapeln - bei weiterer 6 oder Schlagen geht es weiter!"
      ]
    },
    timer: {
      title: "Zugtimer",
      items: [
        "Jeder Spieler hat eine begrenzte Zeit, um seinen Zug abzuschlie\xDFen",
        "Wenn die Zeit abl\xE4uft, wird der Zug automatisch \xFCbersprungen"
      ]
    }
  },
  hint: {
    button: "Hinweis",
    title: "Vorgeschlagener Zug",
    noPieces: "Keine Figuren verf\xFCgbar",
    canPlace: "Du hast eine 6 gew\xFCrfelt! Setze eine Figur auf das Startfeld (Ecke)",
    canMove: "Bewege Figur von {{position}} um {{steps}} Schritte",
    close: "Schlie\xDFen"
  },
  theme: {
    sheshdash: "SheshDash",
    toggle: "Thema wechseln",
    system: "System",
    light: "Hell",
    dark: "Dunkel"
  },
  tutorial: {
    button: "Tutorial",
    skip: "\xDCberspringen",
    prev: "Zur\xFCck",
    next: "Weiter",
    finish: "Beenden",
    welcome: {
      title: "Willkommen bei SheshDash!",
      description: "Dieses kurze Tutorial zeigt dir, wie man spielt. Ziel: Bringe alle 4 Figuren vom Startfeld (Ecke) ins Zentrum!"
    },
    createGame: {
      title: "Spiel erstellen",
      description: "Klicke auf diese Schaltfl\xE4che, um ein neues Spiel zu erstellen. Du bekommst eine eindeutige ID, die du mit Freunden teilen kannst."
    },
    addBots: {
      title: "Bots hinzuf\xFCgen",
      description: "Wenn du nicht genug Spieler hast, kannst du Bots hinzuf\xFCgen. Das Spiel erfordert 2-4 Spieler zum Starten."
    },
    startGame: {
      title: "Spiel starten",
      description: "Wenn alle Spieler bereit sind (mindestens 2), klicke auf diese Schaltfl\xE4che, um das Spiel zu starten!"
    },
    diceButton: {
      title: "\u{1F3B2} W\xFCrfeln",
      description: "Klicke diese Taste zum W\xFCrfeln. Du brauchst eine 6 um deine erste Figur zu setzen!"
    },
    board: {
      title: "\u{1F3AE} Spielbrett",
      description: "Dies ist das 8\xD78\u2011Spielbrett. Figuren starten am Startfeld (Ecke) und bewegen sich im Uhrzeigersinn am Rand entlang."
    },
    playerInfo: {
      title: "\u{1F4CA} Spielerinformationen",
      description: "Hier siehst du alle Spieler, ihre Figuren und den aktuellen Zug. Schau wer gerade spielt!"
    },
    selectPiece: {
      title: "\u{1F3AF} Schritt 1: Figur w\xE4hlen",
      description: "HIER ist das Startfeld (Ecke)! Wenn du eine 6 w\xFCrfelst, klicke auf eine Figur, um sie aufs Brett zu bringen."
    },
    placeButton: {
      title: "\u2705 Schritt 2: Setzen-Taste",
      description: 'HIER erscheint eine "Figur setzen" Taste nach Auswahl. Klicke sie und die Figur wird auf die Startposition gesetzt! Du bekommst einen Bonuswurf!'
    },
    moveInstruction: {
      title: "\u{1F463} Wie man eine Figur bewegt",
      description: 'Nach dem W\xFCrfeln: \u2460 Klicke auf deine Figur auf dem Brett \u2461 Dr\xFCcke die "X Schritte ziehen" Taste rechts. Denk dran: Du kannst nicht \xFCber Figuren springen!'
    },
    goal: {
      title: "\u{1F3C6} Spielziel - MITTE!",
      description: "DA SIND SIE - die goldenen Felder (a8\u2192b7\u2192c6\u2192d5)! Bewege alle 4 Figuren zuerst diagonal hierher und GEWINNE! Weg: Rand (28 Schritte) \u2192 diagonal zur Mitte (4 Schritte)."
    }
  },
  common: {
    cancel: "Abbrechen",
    back: "Zur\xFCck",
    confirm: "Best\xE4tigen",
    close: "Schlie\xDFen"
  },
  joinVote: {
    title: "Beitrittsanfrage",
    wantsToJoin: "m\xF6chte dem Spiel beitreten",
    willReplaceBot: "Ersetzt einen Bot",
    keepPieces: "Beh\xE4lt die Figuren des Bots",
    newPieces: "Beginnt mit neuen Figuren",
    votes: "Stimmen",
    approve: "daf\xFCr",
    reject: "dagegen",
    total: "gesamt",
    approveButton: "Zustimmen",
    rejectButton: "Ablehnen",
    waiting: "Warte auf andere Spieler..."
  },
  joinStarted: {
    title: "Laufendem Spiel beitreten",
    gameInProgress: "Dieses Spiel l\xE4uft bereits.",
    chooseOption: "W\xE4hle, wie du beitreten m\xF6chtest:",
    replaceBot: "Bot ersetzen",
    replaceBotHint: "Position eines Bots \xFCbernehmen",
    newPlayer: "Als neuer Spieler beitreten",
    newPlayerHint: "Mit neuen Figuren starten",
    noOptions: "Beitritt nicht m\xF6glich: keine Bots und keine freien Pl\xE4tze.",
    note: "Hinweis",
    voteRequired: "Alle Spieler m\xFCssen deine Anfrage best\xE4tigen.",
    replaceBotTitle: "Bot ersetzen",
    selectBot: "Bot zum Ersetzen ausw\xE4hlen:",
    selectBotPlaceholder: "-- Bot ausw\xE4hlen --",
    keepPieces: "Bot-Figuren behalten und Position fortsetzen",
    keepPiecesHint: "Du \xFCbernimmst die aktuellen Figuren und Position des Bots",
    resetPiecesHint: "Die Bot-Figuren werden in die Startecke zur\xFCckgesetzt",
    yourName: "Dein Name",
    sendRequest: "Anfrage senden",
    newPlayerTitle: "Als neuer Spieler beitreten",
    newPlayerInfo: "Du trittst mit neuen Figuren in einer freien Ecke bei.",
    currentPlayers: "Aktuelle Spieler",
    lateJoinWarning: "Du trittst sp\xE4t bei; andere Spieler haben bereits Vorsprung!",
    waitingApproval: "Warten auf Best\xE4tigung",
    waitingApprovalText: "Die Spieler stimmen \xFCber deine Beitrittsanfrage ab."
  },
  userAgreement: {
    title: "Nutzungsvereinbarung",
    close: "Schlie\xDFen",
    acceptance: {
      title: "1. Annahme der Bedingungen",
      description: "Durch die Nutzung des SheshDash Spiels stimmst du den Bedingungen dieser Nutzungsvereinbarung zu. Wenn du nicht einverstanden bist, nutze das Spiel bitte nicht."
    },
    gameRules: {
      title: "2. Spielregeln",
      description: "Spieler verpflichten sich, die Regeln von SheshDash zu befolgen. Die Nutzung von Bots ist nur im Rahmen der vom Spiel bereitgestellten Funktionalit\xE4t erlaubt. Betrugsversuche, Hacks oder Ausnutzung von Schwachstellen sind verboten."
    },
    intellectualProperty: {
      title: "3. Geistiges Eigentum",
      description: "Alle Rechte an dem Spiel SheshDash, einschlie\xDFlich Code, Design, Grafiken, Serverlogik, Spielmechanik und Regeln, liegen beim Autor Vadim Maltsev. Der Name \u201ESheshDash\u201C ist dem Rechteinhaber vorbehalten. Das Projekt ist nicht Open Source. Kopieren, Verbreiten oder Modifizieren ohne schriftliche Genehmigung des Autors ist untersagt."
    },
    userConduct: {
      title: "4. Nutzerverhalten",
      items: [
        "Respektiere andere Spieler und nutze keine beleidigenden Ausdr\xFCcke",
        "Versuche nicht das Spiel zu hacken oder zu st\xF6ren",
        "Erstelle keine mehrfachen Konten f\xFCr unfaire Vorteile",
        "Melde Fehler und Schwachstellen dem Autor"
      ]
    },
    disclaimer: {
      title: "5. Haftungsausschluss",
      description: 'Das Spiel wird "wie besehen" ohne Garantien bereitgestellt. Der Autor haftet nicht f\xFCr Verluste oder Sch\xE4den durch die Nutzung des Spiels.'
    },
    changes: {
      title: "6. \xC4nderungen der Vereinbarung",
      description: "Der Autor beh\xE4lt sich das Recht vor, die Bedingungen dieser Vereinbarung jederzeit zu \xE4ndern. Die fortgesetzte Nutzung nach \xC4nderungen bedeutet deine Zustimmung zu den neuen Bedingungen."
    },
    copyright: "\xA9 2026 SheshDash. Alle Rechte vorbehalten.",
    author: "Entwickler: Vadim Maltsev",
    prohibited: {
      title: "Verbotene Handlungen",
      items: [
        "das Spiel kopieren, vervielf\xE4ltigen oder verbreiten",
        "Klone, Modifikationen oder abgeleitete Produkte erstellen",
        "Code, Design, Spielmechanik oder Spielregeln verwenden",
        "das Spiel oder Teile davon unter eigenem Namen betreiben"
      ]
    },
    exclusiveRights: {
      title: "Ausschlie\xDFliche Rechte",
      description: "Alle ausschlie\xDFlichen Rechte an dem Spiel liegen beim Rechteinhaber."
    },
    legalInfo: {
      title: "Rechtliche Informationen",
      description: "SheshDash ist propriet\xE4re Software. Jegliches Kopieren, Verbreiten oder Modifizieren ist ohne schriftliche Zustimmung des Rechteinhabers untersagt."
    }
  },
  navigation: {
    backToHome: "Zur\xFCck zur Startseite"
  },
  donate: {
    title: "Projekt unterst\xFCtzen",
    thankYou: "Danke f\xFCr deine Unterst\xFCtzung!",
    description: "SheshDash ist ein Indie-Projekt. Deine Unterst\xFCtzung hilft, die Server zu bezahlen und neue Funktionen zu entwickeln.",
    waysToSupport: "Weitere M\xF6glichkeiten zu helfen",
    spreadWord: "Weitersagen",
    spreadWordDesc: "Teile SheshDash mit Freunden und Familie.",
    reportBugs: "Bugs melden",
    reportBugsDesc: "Hilf, das Spiel zu verbessern, indem du Fehler meldest.",
    suggestFeatures: "Ideen vorschlagen",
    suggestFeaturesDesc: "Hast du eine Idee? Sag uns, was du gern sehen w\xFCrdest!",
    chooseCountry: "Wo befindest du dich?",
    countryHelp: "Wir zeigen legale Optionen nach Region. Wenn etwas in deinem Land nicht verf\xFCgbar ist, sagt dir die Plattform das.",
    countryRussia: "Russland",
    countryInternational: "Andere L\xE4nder",
    optionsTitle: "Spenden \xFCber Boosty",
    platformBoostyTitle: "Boosty",
    platformBoostyDesc: "Mitgliedschaften und Einmal-Support; Auszahlungen auf Karten in Russland.",
    platformCloudtipsTitle: "CloudTips",
    platformCloudtipsDesc: "Spenden und Abos f\xFCr Creator; Auszahlungen auf Karten in Russland.",
    platformDonationAlertsTitle: "DonationAlerts",
    platformDonationAlertsDesc: "Spenden f\xFCr Streams; geeignet, wenn du streamst.",
    platformPatreonTitle: "Patreon",
    platformPatreonDesc: "Mitgliedschaften f\xFCr Creator. In einigen L\xE4ndern keine Auszahlungen (u. a. Russland).",
    platformBmacTitle: "Buy Me a Coffee",
    platformBmacDesc: "Einmalige und regelm\xE4\xDFige Unterst\xFCtzung \xFCber Stripe; Verf\xFCgbarkeit je nach Land.",
    platformKofiTitle: "Ko-fi",
    platformKofiDesc: "Unterst\xFCtzung \xFCber Stripe/PayPal; Verf\xFCgbarkeit je nach Land.",
    platformGithubTitle: "GitHub Sponsors",
    platformGithubDesc: "Wenn das Projekt Open Source ist und du in einer unterst\xFCtzten Region bist.",
    statusSetup: "Im Aufbau",
    statusCheckCountry: "Verf\xFCgbarkeit pr\xFCfen",
    statusStreaming: "Nur f\xFCr Streams",
    availabilityNote: "Wenn eine Plattform in deinem Land nicht verf\xFCgbar ist, kann sie keine Spenden annehmen.",
    boostyTitle: "Boosty",
    boostyDesc: "Einmalige oder regelm\xE4\xDFige Unterst\xFCtzung. Zahlungen werden \xFCber Boosty abgewickelt.",
    boostyButton: "Boosty \xF6ffnen",
    boostyQrAlt: "Boosty-Spenden-QR-Code",
    boostyQrHint: "QR-Code scannen, um Boosty zu \xF6ffnen."
  },
  account: {
    title: "Konto",
    loginTitle: "Anmelden",
    loginDesc: "Melde dich an, um deine Statistiken und Spielhistorie zu verfolgen.",
    loginGoogle: "Mit Google anmelden",
    loginTelegram: "Mit Telegram anmelden",
    playAsGuest: "Als Gast spielen",
    settings: "Kontoeinstellungen",
    displayName: "Anzeigename",
    save: "Speichern",
    saved: "Gespeichert!",
    logout: "Abmelden",
    logoutConfirm: "Bist du sicher, dass du dich abmelden m\xF6chtest?",
    linkedAccounts: "Verkn\xFCpfte Konten",
    memberSince: "Mitglied seit",
    dangerZone: "Gefahrenbereich",
    deleteAccount: "Konto l\xF6schen",
    preferredColor: "Bevorzugte Farbe"
  },
  profile: {
    title: "Spielerprofil",
    player: "Spieler",
    gamesPlayed: "Gespielte Spiele",
    wins: "Siege",
    winRate: "Siegquote",
    secondPlace: "2. Platz",
    thirdPlace: "3. Platz",
    fourthPlace: "4. Platz",
    matchHistory: "Spielverlauf",
    noMatches: "Noch keine Spiele.",
    placement: "Platz",
    date: "Datum",
    players: "Spieler",
    loadMore: "Mehr laden"
  },
  leaderboard: {
    title: "Top-Spieler",
    rank: "#",
    player: "Spieler",
    wins: "Siege",
    games: "Spiele",
    winRate: "Siegquote",
    noData: "Noch keine Spiele gespielt."
  },
  lobby: {
    onlinePlayers: "Spieler online",
    waitingGames: "\xD6ffentliche Spiele",
    findMatch: "Online-Spiel finden",
    cancelMatch: "Suche abbrechen",
    searching: "Suche nach Spielern...",
    queueCount: "Spieler in Warteschlange: {{count}} / 4",
    onlineCount: "Spieler online: {{count}}",
    join: "Beitreten",
    creator: "Ersteller",
    noGames: "Keine \xF6ffentlichen Spiele verf\xFCgbar",
    botsOfferTitle: "Jetzt mit Bots starten?",
    botsOfferText: "Es fehlen {{count}} Spieler. Starte sofort und f\xFClle den Rest mit Bots.",
    startWithBots: "Mit Bots starten",
    keepWaiting: "Weiter warten"
  },
  skin: {
    human: "Mensch",
    guest: "Gast",
    gameStatus: "Spielstatus",
    gameInProgress: "Spiel l\xE4uft...",
    gameLog: "Spielprotokoll",
    noEvents: "Noch keine Ereignisse",
    waitingForEvents: "Warte auf Spielereignisse...",
    gamePaused: "Spiel pausiert..."
  },
  admin: {
    title: "Admin-Bereich",
    accessDenied: "Zugang nur f\xFCr Administratoren.",
    goToAccount: "Zum Konto",
    loadError: "Admin-Daten konnten nicht geladen werden",
    announcement: {
      title: "Systemnachricht",
      placeholder: 'z. B. "Spielupdate in 5 Minuten"',
      preview: "Vorschau",
      publishNow: "Sofort ver\xF6ffentlichen",
      startTime: "Startzeit",
      endTime: "Endzeit (optional)",
      publish: "Ver\xF6ffentlichen",
      publishing: "Ver\xF6ffentliche...",
      deactivate: "Deaktivieren",
      deactivateConfirm: "Aktuelle Ank\xFCndigung deaktivieren?",
      message: "Nachricht",
      status: "Zustand",
      timeWindow: "Zeitfenster",
      noEndTime: "kein Ende",
      active: "aktiv",
      inactive: "inaktiv"
    },
    users: {
      title: "Spieler",
      player: "Spieler",
      email: "E-Mail",
      role: "Rolle",
      ban: "Sperre",
      banned: "Gesperrt",
      active: "Aktiv"
    },
    markdown: {
      bold: "Fettdruck",
      italic: "Kursiv",
      code: "Code",
      link: "Link",
      listItem: "Punkt"
    },
    news: {
      title: "Neuigkeiten auf der Startseite",
      versionLabel: "Versionsnummer",
      versionPlaceholder: "Zum Beispiel: 0.0.26",
      contentLabel: "Was ist enthalten",
      contentPlaceholder: "Beschreibe, was in dieser Version enthalten ist.",
      publishLabel: "Auf der Startseite anzeigen",
      preview: "Vorschau",
      create: "Neuigkeit anlegen",
      update: "\xC4nderungen speichern",
      saving: "Speichere...",
      cancelEdit: "Abbrechen",
      edit: "Bearbeiten",
      delete: "L\xF6schen",
      deleteConfirm: "Diese Neuigkeit l\xF6schen?",
      published: "ver\xF6ffentlicht",
      draft: "Entwurf",
      empty: "Noch keine Neuigkeiten.",
      hideBlockLabel: "Gesamten News-Block ausblenden",
      hideItemLabel: "Diese Nachricht ausblenden",
      hidden: "ausgeblendet",
      subtitle: "Der eigentliche News-Inhalt kommt jetzt aus versionierten Dateien im Repository.",
      fileBasedHint: "Um die News-Texte auf der Startseite zu \xE4ndern, bearbeite die sprachspezifischen News-Dateien direkt im Repository."
    }
  },
  news: {
    title: "Spielneuigkeiten",
    subtitle: "Versionen und was darin umgesetzt wurde.",
    empty: "Noch keine Neuigkeiten."
  },
  settings: {
    soundOn: "Ton an",
    soundOff: "Ton aus"
  }
};

// src/i18n/locales/es.json
var es_default = {
  meta: {
    title: "SheshDash - Juego de Mesa Multijugador",
    description: "Un juego de mesa multijugador para 4 jugadores. \xA1Mueve tus fichas por el tablero y s\xE9 el primero en llegar al centro!",
    fullDescription: "SheshDash - Un juego de mesa para 2-4 jugadores. \xA1Tira el dado, mueve tus fichas por el tablero y s\xE9 el primero en llegar al centro para ganar!"
  },
  landing: {
    playNow: "Jugar ahora",
    learnRules: "Aprender las reglas",
    termsOfService: "T\xE9rminos de servicio",
    supportProject: "Apoyar el proyecto",
    myAccount: "Mi cuenta",
    copyright: "\xA9 2026 SheshDash. Desarrollador: Vadim Maltsev"
  },
  versionBanner: {
    updateAvailable: "Hay una nueva versi\xF3n disponible",
    updateHint: "Actual: {{current}}. Nueva: {{latest}}. Actualiza la p\xE1gina cuando te convenga.",
    incompatibleTitle: "Esta pesta\xF1a est\xE1 desactualizada",
    incompatibleHint: "Actual: {{current}}. Versi\xF3n m\xEDnima compatible: {{minimum}}. Actualiza la p\xE1gina para continuar con seguridad.",
    refreshNow: "Actualizar ahora",
    later: "M\xE1s tarde",
    inGameWarning: "Est\xE1s en una partida activa. Actualizar te desconectar\xE1 temporalmente \u2014 deber\xEDas volver a conectarte autom\xE1ticamente.",
    inGameProceed: "Actualizar de todas formas",
    inGameCancel: "Quedarse en la partida"
  },
  game: {
    title: "Juego SheshDash",
    gameId: "ID del Juego",
    copyId: "Copiar ID",
    idCopied: "\xA1ID del juego copiado al portapapeles!",
    createGame: "Crear Nuevo Juego",
    privateGame: "Partida privada (ocultar de la lista en l\xEDnea)",
    joinGame: "Unirse a Juego",
    joinGameButton: "Unirse",
    startGame: "Iniciar Juego",
    back: "Atr\xE1s",
    yourName: "Tu nombre",
    gameIdPlaceholder: "ID del Juego",
    connected: "Conectado",
    connecting: "Conectando...",
    waitingForPlayers: "Esperando Jugadores...",
    players: "jugadores",
    shareGameId: "\xA1Comparte el ID con amigos!",
    canStartWithPlayers: "Puedes empezar con 2-4 jugadores. \xA1Haz clic en 'Iniciar' cuando est\xE9s listo!",
    needMorePlayers: "Se necesitan al menos 2 jugadores.",
    botSuggestion: "Sugerencia de bot en",
    currentPlayers: "Jugadores Actuales:",
    yourTurn: "\xA1Tu Turno!",
    waiting: "Esperando...",
    rolled: "Dado",
    gameOver: "\xA1Juego Terminado!",
    exitGame: "Salir del juego",
    winner: "Ganador",
    turnTimer: "Tiempo restante",
    results: "Clasificaci\xF3n final",
    place: "Puesto",
    preferredColor: "Color preferido",
    autoAssignColor: "Autom\xE1tico",
    colorRed: "Rojo",
    colorBlue: "Azul",
    colorGreen: "Verde",
    colorOrange: "Naranja",
    pause: "Pausar",
    resume: "Reanudar",
    paused: "En pausa",
    pausedHint: "La partida est\xE1 en pausa. Pulsa \xABReanudar\xBB para continuar.",
    onlyCreatorCanStart: "Solo el creador puede iniciar la partida."
  },
  kickVote: {
    confirm: "\xBFExpulsar a {{name}} de la partida?",
    title: "\xBFExpulsar jugador?",
    requestsToKick: "quiere expulsar a",
    targetBot: "Objetivo: bot",
    targetHuman: "Objetivo: jugador",
    votes: "Votos",
    approve: "Aprobar",
    reject: "Rechazar",
    waiting: "Esperando otros votos",
    readOnly: "Votaci\xF3n en curso",
    kickedTitle: "Te han expulsado de la partida",
    kickedNotice: "Tus fichas ahora son transparentes y ya no bloquean la partida.",
    returnToLobby: "Volver al lobby",
    observeGame: "Observar partida"
  },
  actions: {
    yourActions: "Tus Acciones",
    rollDice: "\xA1Tira el dado para comenzar tu turno!",
    needSix: "\xA1Necesitas sacar un 6 para colocar tu primera ficha!",
    rolledSix: "\xA1Sacaste un 6! \xA1Tirada extra garantizada!",
    rolledSixOptions: [
      "Colocar nueva ficha (si est\xE1 disponible)",
      "O mover ficha existente 6 pasos"
    ],
    rolledSixNote: "\xA1Cualquier opci\xF3n te da otra tirada!",
    selectPiece: "Selecciona una ficha para mover {{steps}} pasos.",
    selectedPiece: "Ficha Seleccionada: {{state}}",
    placePiece: "Colocar Ficha",
    moveSteps: "Mover {{steps}} pasos",
    deselect: "Deseleccionar"
  },
  instructions: {
    title: "C\xF3mo Jugar:",
    rules: [
      "Las fichas empiezan fuera del tablero; saca un 6 para colocar una en la casilla de salida (esquina).",
      "Mueve las fichas en sentido horario",
      "Despu\xE9s de una vuelta completa, mueve en diagonal al centro",
      "\xA1El primer jugador en llevar las 4 fichas al centro gana!"
    ]
  },
  gameMode: {
    title: "\xBFC\xF3mo quieres jugar?",
    quickStart: "Inicio r\xE1pido",
    quickStartDesc: "contra 3 bots, empieza de inmediato",
    withFriends: "Con amigos",
    withFriendsDesc: "comparte un c\xF3digo, espera a tus amigos",
    findPlayers: "Buscar jugadores",
    findPlayersDesc: "lobby p\xFAblico, cualquiera puede unirse"
  },
  bots: {
    addTitle: "\xBFAgregar Bots?",
    addDescription: "Nadie m\xE1s se ha unido. \xBFQuieres agregar bots para empezar?",
    needMore: "Necesitas {{count}} jugador(es) m\xE1s.",
    addButton: "Agregar {{count}} Bot",
    addButtonPlural: "Agregar {{count}} Bots",
    waitForPlayers: "Esperar Jugadores"
  },
  turn: {
    currentTurn: "Turno Actual",
    you: "Tu",
    skipped: "Turno omitido",
    completed: "Turno completado"
  },
  errors: {
    error: "Error",
    pathBlocked: "Camino bloqueado - no se puede saltar sobre fichas",
    cannotLandOnOwnPiece: "No puedes caer en tu propia ficha",
    pieceInCorner: "La ficha est\xE1 en la reserva, debes sacar un 6 para colocarla",
    pieceAlreadyInCenter: "Ficha ya est\xE1 en el centro",
    needToRoll6: "Necesitas sacar 6 para colocar ficha",
    pieceNotInCorner: "La ficha no est\xE1 en la reserva",
    pieceNotFound: "Ficha no encontrada",
    notYourTurn: "No es tu turno",
    gameNotInProgress: "Juego no en progreso",
    stepsMustMatchDice: "Los pasos deben coincidir con el dado",
    needExactRollForCenter: "Se necesita tirada exacta para entrar al centro",
    onlyCreatorCanStart: "Solo el creador de la partida puede iniciarla",
    playerNameTaken: "Ese nombre de jugador ya est\xE1 en uso en esta partida"
  },
  pieceStates: {
    in_corner: "En reserva",
    on_perimeter: "En Tablero",
    on_diagonal: "En Diagonal",
    in_center: "En Centro"
  },
  playerInfo: {
    title: "Jugadores",
    you: "(T\xFA)",
    turn: "Turno",
    corner: "En reserva:",
    onBoard: "En Tablero:",
    inCenter: "En Centro:",
    waitingFor: "Esperando {{count}} jugador(es)...",
    statusRolled6: "\xA1Bonus!",
    statusCaptured: "\xA1Capturado! \xA1Bonus!",
    statusPlacedPiece: "Colocada, \xA1Bonus!",
    statusMovedOn6: "Movido 6, \xA1Bonus!",
    statusTurnSkipped: "Saltado",
    statusTurnComplete: "Turno terminado"
  },
  dice: {
    rollDice: "Tirar Dado",
    rolled6Message: "\xA1Sacaste un 6! Puedes colocar una nueva ficha O mover una existente 6 pasos.",
    rolledBy: "Tirado por",
    round: "Ronda",
    rolls: "Tiradas",
    captureBonus: "Bonificaci\xF3n por captura"
  },
  board: {
    currentPlayer: "Jugador Actual",
    historyStart: "Primero",
    historyPrev: "Anterior",
    historyNext: "Siguiente",
    historyEnd: "\xDAltimo",
    historyViewingPast: "Modo historial: las acciones est\xE1n deshabilitadas"
  },
  rules: {
    title: "Reglas del Juego",
    close: "Cerrar",
    showRules: "Reglas",
    objective: {
      title: "Objetivo",
      description: "S\xE9 el primer jugador en mover las 4 fichas desde la casilla de salida (esquina), por el per\xEDmetro, la diagonal y hasta el centro."
    },
    setup: {
      title: "Preparaci\xF3n",
      items: [
        "Cada jugador comienza con 4 fichas fuera del tablero (en reserva)",
        "Los jugadores juegan en sentido horario",
        "Todas las fichas empiezan fuera hasta sacar un 6"
      ]
    },
    gameplay: {
      title: "Juego",
      items: [
        "Tira el dado para determinar cu\xE1ntos pasos mover",
        "Para colocar tu primera ficha, debes sacar un 6",
        "Las fichas se mueven en sentido horario (28 posiciones)",
        "Despu\xE9s de completar una vuelta, entran en diagonal al centro (4 pasos)",
        "No puedes mover fichas en la reserva hasta sacar un 6"
      ]
    },
    rolling6: {
      title: "Sacar un 6",
      description: "Cuando sacas un 6, tienes dos opciones:",
      options: [
        "Colocar una ficha nueva en la casilla de salida (esquina)",
        "Mover ficha existente 6 pasos adelante"
      ],
      note: "\xA1Cualquier opci\xF3n te da una tirada extra! Puedes seguir tirando mientras saques 6s."
    },
    capturing: {
      title: "Capturar",
      items: [
        "Si tu ficha cae EXACTAMENTE en una ficha oponente, la capturas",
        "La ficha capturada se retira del tablero y vuelve a la reserva del oponente",
        "No puedes capturar saltando - debes caer exactamente en la posici\xF3n",
        "Capturar te da una tirada extra"
      ]
    },
    blocking: {
      title: "Bloquear",
      description: "\xA1NO PUEDES saltar sobre otras fichas! Si cualquier ficha (tuya u oponente) bloquea tu camino, no puedes pasar. Todo el camino debe estar despejado."
    },
    winning: {
      title: "Ganar",
      description: "\xA1El primer jugador en mover las 4 fichas al centro gana el juego!"
    },
    bonusRolls: {
      title: "Tiradas Extra",
      items: [
        "Tirada extra al sacar 6 (sin importar si colocas o mueves)",
        "Tirada extra al capturar ficha oponente",
        "Las tiradas extra se acumulan - \xA1si sacas otro 6 o capturas otra ficha, contin\xFAas!"
      ]
    },
    timer: {
      title: "Temporizador de turno",
      items: [
        "Cada jugador tiene un tiempo limitado para completar su turno",
        "Si se acaba el tiempo, el turno se salta autom\xE1ticamente"
      ]
    }
  },
  hint: {
    button: "Pista",
    title: "Movimiento Sugerido",
    noPieces: "No hay fichas disponibles",
    canPlace: "\xA1Sali\xF3 6! Coloca una ficha en la casilla de salida (esquina)",
    canMove: "Mover ficha desde {{position}} {{steps}} pasos",
    close: "Cerrar"
  },
  theme: {
    sheshdash: "SheshDash",
    toggle: "Cambiar tema",
    system: "Sistema",
    light: "Claro",
    dark: "Oscuro"
  },
  tutorial: {
    button: "Tutorial",
    skip: "Saltar",
    prev: "Atr\xE1s",
    next: "Siguiente",
    finish: "Terminar",
    welcome: {
      title: "\xA1Bienvenido a SheshDash!",
      description: "Este tutorial r\xE1pido te mostrar\xE1 c\xF3mo jugar. Objetivo: mover las 4 fichas desde la casilla de salida (esquina) hasta el centro."
    },
    createGame: {
      title: "Crear juego",
      description: "Haz clic en este bot\xF3n para crear un nuevo juego. Obtendr\xE1s un ID \xFAnico para compartir con amigos."
    },
    addBots: {
      title: "Agregar bots",
      description: "Si no tienes suficientes jugadores, puedes agregar bots. El juego requiere 2-4 jugadores para comenzar."
    },
    startGame: {
      title: "Iniciar juego",
      description: "Cuando todos los jugadores est\xE9n listos (m\xEDnimo 2), \xA1haz clic en este bot\xF3n para iniciar el juego!"
    },
    diceButton: {
      title: "\u{1F3B2} Tirar Dado",
      description: "\xA1Haz clic en este bot\xF3n para tirar el dado. Necesitas sacar un 6 para colocar tu primera ficha!"
    },
    board: {
      title: "\u{1F3AE} Tablero de Juego",
      description: "Este es el tablero 8\xD78. Las fichas entran por la casilla de salida (esquina) y luego avanzan en sentido horario por el per\xEDmetro."
    },
    playerInfo: {
      title: "\u{1F4CA} Informaci\xF3n de Jugadores",
      description: "\xA1Aqu\xED puedes ver todos los jugadores, sus fichas y el turno actual. \xA1Observa qui\xE9n est\xE1 jugando!"
    },
    selectPiece: {
      title: "\u{1F3AF} Paso 1: Seleccionar Ficha",
      description: "\xA1AQU\xCD est\xE1 la casilla de salida (esquina)! Cuando saques un 6, haz clic en una ficha para ponerla en el tablero."
    },
    placeButton: {
      title: "\u2705 Paso 2: Bot\xF3n Colocar",
      description: '\xA1AQU\xCD aparecer\xE1 un bot\xF3n "Colocar Ficha" despu\xE9s de seleccionar. Haz clic y la ficha se colocar\xE1 en la posici\xF3n inicial! \xA1Obtendr\xE1s una tirada extra!'
    },
    moveInstruction: {
      title: "\u{1F463} C\xF3mo Mover una Ficha",
      description: 'Despu\xE9s de tirar: \u2460 Haz clic en tu ficha en el tablero \u2461 Presiona el bot\xF3n "Mover X pasos" a la derecha. \xA1Recuerda: no puedes saltar sobre otras fichas!'
    },
    goal: {
      title: "\u{1F3C6} Objetivo del Juego - \xA1CENTRO!",
      description: "\xA1AH\xCD EST\xC1N - las casillas doradas (a8\u2192b7\u2192c6\u2192d5)! \xA1S\xE9 el primero en mover las 4 fichas aqu\xED en diagonal y GANA! Camino: per\xEDmetro (28 pasos) \u2192 diagonal al centro (4 pasos)."
    }
  },
  common: {
    cancel: "Cancelar",
    back: "Atr\xE1s",
    confirm: "Confirmar",
    close: "Cerrar"
  },
  joinVote: {
    title: "Solicitud de uni\xF3n",
    wantsToJoin: "quiere unirse al juego",
    willReplaceBot: "Reemplazar\xE1 un bot",
    keepPieces: "Conservar\xE1 las fichas del bot",
    newPieces: "Comenzar\xE1 con fichas nuevas",
    votes: "Votos",
    approve: "a favor",
    reject: "en contra",
    total: "total",
    approveButton: "Aprobar",
    rejectButton: "Rechazar",
    waiting: "Esperando a otros jugadores..."
  },
  joinStarted: {
    title: "Unirse a partida en curso",
    gameInProgress: "Esta partida ya est\xE1 en curso.",
    chooseOption: "Elige c\xF3mo quieres unirte:",
    replaceBot: "Reemplazar un bot",
    replaceBotHint: "Tomar la posici\xF3n de un bot",
    newPlayer: "Unirse como jugador nuevo",
    newPlayerHint: "Empezar con fichas nuevas",
    noOptions: "No puedes unirte: no hay bots ni espacios libres.",
    note: "Nota",
    voteRequired: "Todos los jugadores deben aprobar tu solicitud.",
    replaceBotTitle: "Reemplazar un bot",
    selectBot: "Selecciona el bot a reemplazar:",
    selectBotPlaceholder: "-- Selecciona un bot --",
    keepPieces: "Conservar las fichas del bot y su posici\xF3n",
    keepPiecesHint: "Tomar\xE1s las fichas y la posici\xF3n actuales del bot",
    resetPiecesHint: "Las fichas del bot volver\xE1n a la esquina inicial",
    yourName: "Tu nombre",
    sendRequest: "Enviar solicitud",
    newPlayerTitle: "Unirse como jugador nuevo",
    newPlayerInfo: "Te unir\xE1s con fichas nuevas en una esquina disponible.",
    currentPlayers: "Jugadores actuales",
    lateJoinWarning: "Te unes tarde; otros jugadores ya tienen ventaja.",
    waitingApproval: "Esperando aprobaci\xF3n",
    waitingApprovalText: "Los jugadores est\xE1n votando tu solicitud para unirte."
  },
  userAgreement: {
    title: "Acuerdo de Usuario",
    close: "Cerrar",
    acceptance: {
      title: "1. Aceptaci\xF3n de T\xE9rminos",
      description: "Al usar el juego SheshDash, aceptas los t\xE9rminos de este Acuerdo de Usuario. Si no est\xE1s de acuerdo, por favor no uses el juego."
    },
    gameRules: {
      title: "2. Reglas del Juego",
      description: "Los jugadores aceptan seguir las reglas de SheshDash. El uso de bots est\xE1 permitido solo dentro de la funcionalidad proporcionada por el juego. Cualquier intento de hacer trampa, usar hacks o explotar vulnerabilidades est\xE1 prohibido."
    },
    intellectualProperty: {
      title: "3. Propiedad Intelectual",
      description: "Todos los derechos sobre el juego SheshDash, incluido el c\xF3digo, el dise\xF1o, los gr\xE1ficos, la l\xF3gica del servidor, la mec\xE1nica y las reglas del juego, pertenecen al autor Vadim Maltsev. El nombre del juego \xABSheshDash\xBB est\xE1 reservado por el titular de los derechos. El proyecto no es de c\xF3digo abierto. Se proh\xEDbe copiar, distribuir o modificar el juego sin el permiso escrito del autor."
    },
    userConduct: {
      title: "4. Conducta del Usuario",
      items: [
        "Respeta a otros jugadores y no uses lenguaje ofensivo",
        "No intentes hackear o interrumpir el juego",
        "No crees m\xFAltiples cuentas para obtener ventajas injustas",
        "Reporta errores y vulnerabilidades al autor"
      ]
    },
    disclaimer: {
      title: "5. Descargo de Responsabilidad",
      description: 'El juego se proporciona "tal cual" sin garant\xEDas. El autor no es responsable de p\xE9rdidas o da\xF1os derivados del uso del juego.'
    },
    changes: {
      title: "6. Cambios al Acuerdo",
      description: "El autor se reserva el derecho de modificar los t\xE9rminos de este acuerdo en cualquier momento. El uso continuado despu\xE9s de los cambios constituye tu aceptaci\xF3n de los nuevos t\xE9rminos."
    },
    copyright: "\xA9 2026 SheshDash. Todos los derechos reservados.",
    author: "Desarrollador: Vadim Maltsev",
    prohibited: {
      title: "Acciones prohibidas",
      items: [
        "copiar, reproducir o distribuir el juego",
        "crear clones, modificaciones o productos derivados",
        "usar el c\xF3digo, el dise\xF1o, la mec\xE1nica o las reglas del juego",
        "explotar el juego o partes de \xE9l bajo su propio nombre"
      ]
    },
    exclusiveRights: {
      title: "Derechos exclusivos",
      description: "Todos los derechos exclusivos sobre el juego pertenecen al titular de los derechos."
    },
    legalInfo: {
      title: "Informaci\xF3n legal",
      description: "SheshDash es software propietario. Cualquier copia, distribuci\xF3n o modificaci\xF3n est\xE1 prohibida sin el consentimiento escrito del titular de los derechos."
    }
  },
  navigation: {
    backToHome: "Volver al inicio"
  },
  donate: {
    title: "Apoya el proyecto",
    thankYou: "\xA1Gracias por tu apoyo!",
    description: "SheshDash es un proyecto indie. Tu apoyo ayuda a mantener los servidores y crear nuevas funciones.",
    waysToSupport: "Otras formas de ayudar",
    spreadWord: "Corre la voz",
    spreadWordDesc: "Comparte SheshDash con amigos y familia.",
    reportBugs: "Reporta errores",
    reportBugsDesc: "Ayuda a mejorar el juego informando fallos.",
    suggestFeatures: "Sugiere funciones",
    suggestFeaturesDesc: "\xBFTienes una idea? Dinos qu\xE9 te gustar\xEDa ver.",
    chooseCountry: "\xBFD\xF3nde est\xE1s?",
    countryHelp: "Mostramos opciones legales por regi\xF3n. Si algo no est\xE1 disponible en tu pa\xEDs, la plataforma te lo indicar\xE1.",
    countryRussia: "Rusia",
    countryInternational: "Otros pa\xEDses",
    optionsTitle: "Donar a trav\xE9s de Boosty",
    platformBoostyTitle: "Boosty",
    platformBoostyDesc: "Membres\xEDas y apoyo \xFAnico; retiros a tarjetas en Rusia.",
    platformCloudtipsTitle: "CloudTips",
    platformCloudtipsDesc: "Donaciones y suscripciones para creadores; retiros a tarjetas en Rusia.",
    platformDonationAlertsTitle: "DonationAlerts",
    platformDonationAlertsDesc: "Donaciones para streams; \xFAsalo si haces directos.",
    platformPatreonTitle: "Patreon",
    platformPatreonDesc: "Membres\xEDas para creadores. En algunos pa\xEDses los retiros no est\xE1n disponibles (incluida Rusia).",
    platformBmacTitle: "Buy Me a Coffee",
    platformBmacDesc: "Apoyo \xFAnico y recurrente v\xEDa Stripe; disponibilidad seg\xFAn pa\xEDs.",
    platformKofiTitle: "Ko-fi",
    platformKofiDesc: "Apoyo v\xEDa Stripe/PayPal; disponibilidad seg\xFAn pa\xEDs.",
    platformGithubTitle: "GitHub Sponsors",
    platformGithubDesc: "Si el proyecto es open source y est\xE1s en una regi\xF3n compatible.",
    statusSetup: "En preparaci\xF3n",
    statusCheckCountry: "Verifica disponibilidad",
    statusStreaming: "Solo para streams",
    availabilityNote: "Si una plataforma no funciona en tu pa\xEDs, no permitir\xE1 donaciones.",
    boostyTitle: "Boosty",
    boostyDesc: "Apoyo \xFAnico o recurrente. Los pagos los procesa Boosty.",
    boostyButton: "Abrir Boosty",
    boostyQrAlt: "C\xF3digo QR para donar en Boosty",
    boostyQrHint: "Escanea el QR para abrir Boosty."
  },
  account: {
    title: "Cuenta",
    loginTitle: "Iniciar sesi\xF3n",
    loginDesc: "Inicia sesi\xF3n para ver tus estad\xEDsticas e historial de partidas.",
    loginGoogle: "Iniciar sesi\xF3n con Google",
    loginTelegram: "Iniciar sesi\xF3n con Telegram",
    playAsGuest: "Jugar como invitado",
    settings: "Configuraci\xF3n de cuenta",
    displayName: "Nombre visible",
    save: "Guardar",
    saved: "\xA1Guardado!",
    logout: "Cerrar sesi\xF3n",
    logoutConfirm: "\xBFEst\xE1s seguro de que quieres cerrar sesi\xF3n?",
    linkedAccounts: "Cuentas vinculadas",
    memberSince: "Miembro desde",
    dangerZone: "Zona de peligro",
    deleteAccount: "Eliminar cuenta",
    preferredColor: "Color preferido"
  },
  profile: {
    title: "Perfil del jugador",
    player: "Jugador",
    gamesPlayed: "Partidas jugadas",
    wins: "Victorias",
    winRate: "Tasa de victorias",
    secondPlace: "2.o puesto",
    thirdPlace: "3.er puesto",
    fourthPlace: "4.o puesto",
    matchHistory: "Historial de partidas",
    noMatches: "A\xFAn no hay partidas.",
    placement: "Puesto",
    date: "Fecha",
    players: "Jugadores",
    loadMore: "Cargar m\xE1s"
  },
  leaderboard: {
    title: "Mejores jugadores",
    rank: "#",
    player: "Jugador",
    wins: "Victorias",
    games: "Partidas",
    winRate: "% victorias",
    noData: "A\xFAn no se han jugado partidas."
  },
  lobby: {
    onlinePlayers: "Jugadores en l\xEDnea",
    waitingGames: "Partidas p\xFAblicas",
    findMatch: "Buscar partida en l\xEDnea",
    cancelMatch: "Cancelar b\xFAsqueda",
    searching: "Buscando jugadores...",
    queueCount: "Jugadores en cola: {{count}} / 4",
    onlineCount: "Jugadores en l\xEDnea: {{count}}",
    join: "Unirse",
    creator: "Creador",
    noGames: "No hay partidas p\xFAblicas disponibles",
    botsOfferTitle: "\xBFEmpezar ahora con bots?",
    botsOfferText: "Faltan {{count}} jugador(es). Empieza ahora y completa el resto con bots.",
    startWithBots: "Empezar con bots",
    keepWaiting: "Seguir esperando"
  },
  skin: {
    human: "Humano",
    guest: "Invitado",
    gameStatus: "Estado del juego",
    gameInProgress: "Juego en curso...",
    gameLog: "Registro del juego",
    noEvents: "A\xFAn no hay eventos",
    waitingForEvents: "Esperando eventos del juego...",
    gamePaused: "Juego en pausa..."
  },
  admin: {
    title: "Panel de administraci\xF3n",
    accessDenied: "Acceso solo para administradores.",
    goToAccount: "Ir a la cuenta",
    loadError: "No se pudieron cargar los datos de administraci\xF3n",
    announcement: {
      title: "Anuncio del sistema",
      placeholder: 'p. ej., "Actualizaci\xF3n del juego en 5 minutos"',
      preview: "Vista previa",
      publishNow: "Publicar ahora",
      startTime: "Hora de inicio",
      endTime: "Hora de fin (opcional)",
      publish: "Publicar",
      publishing: "Publicando...",
      deactivate: "Desactivar",
      deactivateConfirm: "\xBFDesactivar el anuncio actual?",
      message: "Mensaje",
      status: "Estado",
      timeWindow: "Ventana",
      noEndTime: "sin fin",
      active: "activo",
      inactive: "inactivo"
    },
    users: {
      title: "Jugadores",
      player: "Jugador",
      email: "Correo",
      role: "Rol",
      ban: "Bloqueo",
      banned: "Bloqueado",
      active: "Activo"
    },
    markdown: {
      bold: "texto en negrita",
      italic: "cursiva",
      code: "c\xF3digo",
      link: "enlace",
      listItem: "elemento"
    },
    news: {
      title: "Novedades en la p\xE1gina principal",
      versionLabel: "Versi\xF3n",
      versionPlaceholder: "Por ejemplo: 0.0.26",
      contentLabel: "Qu\xE9 se implement\xF3",
      contentPlaceholder: "Describe lo que incluye esta versi\xF3n.",
      publishLabel: "Mostrar en la p\xE1gina principal",
      preview: "Vista previa",
      create: "Crear novedad",
      update: "Guardar cambios",
      saving: "Guardando...",
      cancelEdit: "Cancelar",
      edit: "Editar",
      delete: "Eliminar",
      deleteConfirm: "\xBFEliminar esta novedad?",
      published: "publicado",
      draft: "borrador",
      empty: "Todav\xEDa no hay novedades.",
      hideBlockLabel: "Ocultar todo el bloque de noticias",
      hideItemLabel: "Ocultar esta noticia",
      hidden: "oculto",
      subtitle: "El contenido de noticias ahora se toma de archivos versionados dentro del repositorio.",
      fileBasedHint: "Para cambiar los textos de noticias en la portada, edita directamente en el repositorio los archivos de noticias por idioma."
    }
  },
  news: {
    title: "Novedades del juego",
    subtitle: "Versiones y lo que se implement\xF3 en cada una.",
    empty: "Todav\xEDa no hay novedades."
  },
  settings: {
    soundOn: "Sonido activado",
    soundOff: "Sonido desactivado"
  }
};

// src/i18n/locales/it.json
var it_default = {
  meta: {
    title: "SheshDash - Gioco da Tavolo Multiplayer",
    description: "Un gioco da tavolo multiplayer per 4 giocatori. Muovi le tue pedine sul tabellone e sii il primo a raggiungere il centro!",
    fullDescription: "SheshDash - Un gioco da tavolo per 2-4 giocatori. Tira i dadi, muovi le pedine sul tabellone e sii il primo al centro per vincere!"
  },
  landing: {
    playNow: "Gioca ora",
    learnRules: "Impara le regole",
    termsOfService: "Termini di servizio",
    supportProject: "Sostieni il progetto",
    myAccount: "Il mio account",
    copyright: "\xA9 2026 SheshDash. Sviluppatore: Vadim Maltsev"
  },
  versionBanner: {
    updateAvailable: "\xC8 disponibile una nuova versione",
    updateHint: "Attuale: {{current}}. Nuova: {{latest}}. Aggiorna la pagina quando ti \xE8 comodo.",
    incompatibleTitle: "Questa scheda \xE8 obsoleta",
    incompatibleHint: "Attuale: {{current}}. Versione minima supportata: {{minimum}}. Aggiorna la pagina per continuare in sicurezza.",
    refreshNow: "Aggiorna ora",
    later: "Pi\xF9 tardi",
    inGameWarning: "Sei in una partita attiva. Aggiornare ti disconnetter\xE0 temporaneamente \u2014 dovresti riconnetterti automaticamente.",
    inGameProceed: "Aggiorna comunque",
    inGameCancel: "Rimani nel gioco"
  },
  game: {
    title: "Gioco SheshDash",
    gameId: "ID Partita",
    copyId: "Copia ID",
    idCopied: "ID partita copiato negli appunti!",
    createGame: "Crea Nuova Partita",
    privateGame: "Partita privata (nascondi dall'elenco online)",
    joinGame: "Unisciti a Partita",
    joinGameButton: "Unisciti",
    startGame: "Inizia Partita",
    back: "Indietro",
    yourName: "Il tuo nome",
    gameIdPlaceholder: "ID Partita",
    connected: "Connesso",
    connecting: "Connessione...",
    waitingForPlayers: "In Attesa di Giocatori...",
    players: "giocatori",
    shareGameId: "Condividi l'ID con gli amici!",
    canStartWithPlayers: "Puoi iniziare con 2-4 giocatori. Clicca 'Inizia' quando sei pronto!",
    needMorePlayers: "Servono almeno 2 giocatori.",
    botSuggestion: "Suggerimento bot tra",
    currentPlayers: "Giocatori Attuali:",
    yourTurn: "Il Tuo Turno!",
    waiting: "In Attesa...",
    rolled: "Dado",
    gameOver: "Partita Terminata!",
    exitGame: "Esci dal gioco",
    winner: "Vincitore",
    turnTimer: "Tempo rimasto",
    results: "Classifica finale",
    place: "Posto",
    preferredColor: "Colore preferito",
    autoAssignColor: "Automatico",
    colorRed: "Rosso",
    colorBlue: "Blu",
    colorGreen: "Verde",
    colorOrange: "Arancione",
    pause: "Pausa",
    resume: "Riprendi",
    paused: "In pausa",
    pausedHint: "La partita \xE8 in pausa. Premi \xABRiprendi\xBB per continuare.",
    onlyCreatorCanStart: "Solo il creatore pu\xF2 avviare la partita."
  },
  kickVote: {
    confirm: "Rimuovere {{name}} dalla partita?",
    title: "Rimuovere giocatore?",
    requestsToKick: "vuole rimuovere",
    targetBot: "Bersaglio: bot",
    targetHuman: "Bersaglio: giocatore",
    votes: "Voti",
    approve: "Approva",
    reject: "Rifiuta",
    waiting: "In attesa degli altri voti",
    readOnly: "Votazione in corso",
    kickedTitle: "Sei stato rimosso dalla partita",
    kickedNotice: "Le tue pedine ora sono trasparenti e non bloccano pi\xF9 la partita.",
    returnToLobby: "Torna alla lobby",
    observeGame: "Osserva la partita"
  },
  actions: {
    yourActions: "Le Tue Azioni",
    rollDice: "Tira il dado per iniziare il tuo turno!",
    needSix: "Devi tirare un 6 per posizionare la tua prima pedina!",
    rolledSix: "Hai tirato un 6! Tiro bonus garantito!",
    rolledSixOptions: [
      "Posiziona nuova pedina (se disponibile)",
      "OPPURE muovi pedina esistente di 6 passi"
    ],
    rolledSixNote: "Entrambe le scelte ti danno un altro tiro!",
    selectPiece: "Seleziona una pedina per muovere {{steps}} passi.",
    selectedPiece: "Pedina Selezionata: {{state}}",
    placePiece: "Posiziona Pedina",
    moveSteps: "Muovi {{steps}} passi",
    deselect: "Deseleziona"
  },
  instructions: {
    title: "Come Giocare:",
    rules: [
      "Le pedine iniziano fuori dal tabellone; tira un 6 per metterne una sulla casella di partenza (angolo).",
      "Muovi le pedine in senso orario intorno al tabellone",
      "Dopo un giro completo, muovi in diagonale verso il centro",
      "Il primo giocatore a portare tutte e 4 le pedine al centro vince!"
    ]
  },
  gameMode: {
    title: "Come vuoi giocare?",
    quickStart: "Avvio rapido",
    quickStartDesc: "contro 3 bot, inizia subito",
    withFriends: "Con gli amici",
    withFriendsDesc: "condividi un codice, aspetta gli amici",
    findPlayers: "Trova giocatori",
    findPlayersDesc: "lobby pubblica, chiunque pu\xF2 unirsi"
  },
  bots: {
    addTitle: "Aggiungere Bot?",
    addDescription: "Nessun altro si \xE8 unito. Vuoi aggiungere bot per iniziare?",
    needMore: "Servono ancora {{count}} giocatore(i).",
    addButton: "Aggiungi {{count}} Bot",
    addButtonPlural: "Aggiungi {{count}} Bot",
    waitForPlayers: "Aspetta Giocatori"
  },
  turn: {
    currentTurn: "Turno Attuale",
    you: "Tuo",
    skipped: "Turno saltato",
    completed: "Turno completato"
  },
  errors: {
    error: "Errore",
    pathBlocked: "Percorso bloccato - non puoi saltare sopra le pedine",
    cannotLandOnOwnPiece: "Non puoi atterrare sulla tua pedina",
    pieceInCorner: "La pedina \xE8 in riserva, devi tirare un 6 per posizionarla",
    pieceAlreadyInCenter: "Pedina gi\xE0 al centro",
    needToRoll6: "Devi tirare 6 per posizionare pedina",
    pieceNotInCorner: "La pedina non \xE8 in riserva",
    pieceNotFound: "Pedina non trovata",
    notYourTurn: "Non \xE8 il tuo turno",
    gameNotInProgress: "Partita non in corso",
    stepsMustMatchDice: "I passi devono corrispondere al dado",
    needExactRollForCenter: "Serve tiro esatto per entrare al centro",
    onlyCreatorCanStart: "Solo il creatore della partita pu\xF2 avviarla",
    playerNameTaken: "Questo nome giocatore \xE8 gi\xE0 in uso in questa partita"
  },
  pieceStates: {
    in_corner: "In riserva",
    on_perimeter: "Sul Tabellone",
    on_diagonal: "In Diagonale",
    in_center: "Al Centro"
  },
  playerInfo: {
    title: "Giocatori",
    you: "(Tu)",
    turn: "Turno",
    corner: "In riserva:",
    onBoard: "Sul Tabellone:",
    inCenter: "Al Centro:",
    waitingFor: "In attesa di {{count}} giocatore(i)...",
    statusRolled6: "Bonus!",
    statusCaptured: "Catturato! Bonus!",
    statusPlacedPiece: "Posizionata, Bonus!",
    statusMovedOn6: "Mosso 6, Bonus!",
    statusTurnSkipped: "Saltato",
    statusTurnComplete: "Turno completato"
  },
  dice: {
    rollDice: "Tira Dado",
    rolled6Message: "Hai tirato un 6! Puoi posizionare una nuova pedina OPPURE muoverne una esistente di 6 passi.",
    rolledBy: "Tirato da",
    round: "Round",
    rolls: "Tiri",
    captureBonus: "Bonus cattura"
  },
  board: {
    currentPlayer: "Giocatore Attuale",
    historyStart: "Primo",
    historyPrev: "Precedente",
    historyNext: "Successivo",
    historyEnd: "Ultimo",
    historyViewingPast: "Modalit\xE0 cronologia: azioni disabilitate"
  },
  rules: {
    title: "Regole del Gioco",
    close: "Chiudi",
    showRules: "Regole",
    objective: {
      title: "Obiettivo",
      description: "Sii il primo a muovere tutte le 4 pedine dalla casella di partenza (angolo), lungo il perimetro, sulla diagonale e fino al centro."
    },
    setup: {
      title: "Preparazione",
      items: [
        "Ogni giocatore inizia con 4 pedine fuori dal tabellone (in riserva)",
        "I giocatori giocano in senso orario",
        "Tutte le pedine iniziano fuori finch\xE9 non si tira un 6"
      ]
    },
    gameplay: {
      title: "Gioco",
      items: [
        "Tira il dado per determinare quanti passi muovere",
        "Per posizionare la tua prima pedina, devi tirare un 6",
        "Le pedine si muovono in senso orario intorno al perimetro (28 posizioni)",
        "Dopo aver completato un giro, entrano nella diagonale verso il centro (4 passi)",
        "Non puoi muovere le pedine in riserva finch\xE9 non esce un 6"
      ]
    },
    rolling6: {
      title: "Tirare un 6",
      description: "Quando tiri un 6, hai due opzioni:",
      options: [
        "Posizionare una nuova pedina sulla casella di partenza (angolo)",
        "Muovere pedina esistente 6 passi avanti"
      ],
      note: "Entrambe le scelte ti danno un tiro bonus! Puoi continuare a tirare finch\xE9 tiri 6."
    },
    capturing: {
      title: "Catturare",
      items: [
        "Se la tua pedina atterra ESATTAMENTE su una pedina avversaria, la catturi",
        "La pedina catturata viene rimossa dal tabellone e torna nella riserva dell\u2019avversario",
        "Non puoi catturare saltando - devi atterrare esattamente sulla posizione",
        "Catturare ti d\xE0 un tiro bonus (turno extra)"
      ]
    },
    blocking: {
      title: "Bloccare",
      description: "NON PUOI saltare sopra altre pedine! Se qualsiasi pedina (tua o avversaria) blocca il tuo percorso, non puoi passare. L'intero percorso deve essere libero."
    },
    winning: {
      title: "Vincere",
      description: "Il primo giocatore a muovere tutte e 4 le pedine al centro vince la partita!"
    },
    bonusRolls: {
      title: "Tiri Bonus",
      items: [
        "Tiro bonus quando tiri 6 (indipendentemente se posizioni o muovi)",
        "Tiro bonus quando catturi pedina avversaria",
        "I tiri bonus si accumulano - se tiri un altro 6 o catturi di nuovo, continui!"
      ]
    },
    timer: {
      title: "Timer del turno",
      items: [
        "Ogni giocatore ha un tempo limitato per completare il turno",
        "Se il tempo scade, il turno viene automaticamente saltato"
      ]
    }
  },
  hint: {
    button: "Suggerimento",
    title: "Mossa Suggerita",
    noPieces: "Nessuna pedina disponibile",
    canPlace: "Hai tirato un 6! Posiziona una pedina sulla casella di partenza (angolo)",
    canMove: "Muovi pedina da {{position}} di {{steps}} passi",
    close: "Chiudi"
  },
  theme: {
    sheshdash: "SheshDash",
    toggle: "Cambia tema",
    system: "Sistema",
    light: "Chiaro",
    dark: "Scuro"
  },
  tutorial: {
    button: "Tutorial",
    skip: "Salta",
    prev: "Indietro",
    next: "Avanti",
    finish: "Fine",
    welcome: {
      title: "Benvenuto in SheshDash!",
      description: "Questo breve tutorial interattivo ti mostra come giocare. Obiettivo: spostare tutte le 4 pedine dalla casella di partenza (angolo) al centro."
    },
    createGame: {
      title: "Crea partita",
      description: "Clicca questo pulsante per creare una nuova partita. Otterrai un ID unico da condividere con gli amici."
    },
    addBots: {
      title: "Aggiungi bot",
      description: "Se non hai abbastanza giocatori, puoi aggiungere bot. La partita richiede 2-4 giocatori per iniziare."
    },
    startGame: {
      title: "Inizia partita",
      description: "Quando tutti i giocatori sono pronti (minimo 2), clicca questo pulsante per iniziare la partita!"
    },
    diceButton: {
      title: "\u{1F3B2} Tira Dado",
      description: "Clicca questo pulsante per tirare il dado. Devi tirare un 6 per posizionare la tua prima pedina!"
    },
    board: {
      title: "\u{1F3AE} Tabellone",
      description: "Questo \xE8 il tabellone 8\xD78. Le pedine entrano dalla casella di partenza (angolo) e poi si muovono in senso orario lungo il perimetro."
    },
    playerInfo: {
      title: "\u{1F4CA} Informazioni Giocatori",
      description: "Qui puoi vedere tutti i giocatori, le loro pedine e il turno attuale. Guarda chi sta giocando!"
    },
    selectPiece: {
      title: "\u{1F3AF} Passo 1: Seleziona Pedina",
      description: "QUI c\u2019\xE8 la casella di partenza (angolo)! Quando esce un 6, clicca una pedina per metterla sul tabellone."
    },
    placeButton: {
      title: "\u2705 Passo 2: Pulsante Posiziona",
      description: 'QUI apparir\xE0 un pulsante "Posiziona Pedina" dopo la selezione. Cliccalo e la pedina sar\xE0 posizionata nella posizione iniziale! Otterrai un tiro bonus!'
    },
    moveInstruction: {
      title: "\u{1F463} Come Muovere una Pedina",
      description: 'Dopo aver tirato: \u2460 Clicca sulla tua pedina sul tabellone \u2461 Premi il pulsante "Muovi X passi" a destra. Ricorda: non puoi saltare sopra altre pedine!'
    },
    goal: {
      title: "\u{1F3C6} Obiettivo del Gioco - CENTRO!",
      description: "ECCOLE - le caselle dorate (a8\u2192b7\u2192c6\u2192d5)! Sii il primo a muovere tutte e 4 le pedine qui in diagonale e VINCI! Percorso: perimetro (28 passi) \u2192 diagonale al centro (4 passi)."
    }
  },
  common: {
    cancel: "Annulla",
    back: "Indietro",
    confirm: "Conferma",
    close: "Chiudi"
  },
  joinVote: {
    title: "Richiesta di unione",
    wantsToJoin: "vuole unirsi alla partita",
    willReplaceBot: "Sostituir\xE0 un bot",
    keepPieces: "Manterr\xE0 le pedine del bot",
    newPieces: "Inizier\xE0 con nuove pedine",
    votes: "Voti",
    approve: "a favore",
    reject: "contrari",
    total: "totale",
    approveButton: "Approva",
    rejectButton: "Rifiuta",
    waiting: "In attesa degli altri giocatori..."
  },
  joinStarted: {
    title: "Unisciti a partita in corso",
    gameInProgress: "Questa partita \xE8 gi\xE0 in corso.",
    chooseOption: "Scegli come unirti:",
    replaceBot: "Sostituisci un bot",
    replaceBotHint: "Prendi la posizione di un bot",
    newPlayer: "Unisciti come nuovo giocatore",
    newPlayerHint: "Inizia con nuove pedine",
    noOptions: "Non puoi unirti: nessun bot da sostituire e nessuno slot libero.",
    note: "Nota",
    voteRequired: "Tutti i giocatori devono approvare la tua richiesta.",
    replaceBotTitle: "Sostituisci un bot",
    selectBot: "Seleziona il bot da sostituire:",
    selectBotPlaceholder: "-- Seleziona un bot --",
    keepPieces: "Mantieni le pedine del bot e la posizione attuale",
    keepPiecesHint: "Prenderai le pedine e la posizione attuali del bot",
    resetPiecesHint: "Le pedine del bot saranno riportate all\u2019angolo iniziale",
    yourName: "Il tuo nome",
    sendRequest: "Invia richiesta",
    newPlayerTitle: "Unisciti come nuovo giocatore",
    newPlayerInfo: "Entrerai con nuove pedine in un angolo disponibile.",
    currentPlayers: "Giocatori attuali",
    lateJoinWarning: "Ti unisci tardi; gli altri giocatori sono gi\xE0 avanti!",
    waitingApproval: "In attesa di approvazione",
    waitingApprovalText: "I giocatori stanno votando la tua richiesta di ingresso."
  },
  userAgreement: {
    title: "Accordo Utente",
    close: "Chiudi",
    acceptance: {
      title: "1. Accettazione dei Termini",
      description: "Utilizzando il gioco SheshDash, accetti i termini di questo Accordo Utente. Se non sei d'accordo, per favore non usare il gioco."
    },
    gameRules: {
      title: "2. Regole del Gioco",
      description: "I giocatori accettano di seguire le regole di SheshDash. L'uso di bot \xE8 consentito solo all'interno della funzionalit\xE0 fornita dal gioco. Qualsiasi tentativo di imbrogliare, usare hack o sfruttare vulnerabilit\xE0 \xE8 vietato."
    },
    intellectualProperty: {
      title: "3. Propriet\xE0 Intellettuale",
      description: "Tutti i diritti sul gioco SheshDash, inclusi codice, design, grafica, logica server, meccanica e regole di gioco, appartengono all\u2019autore Vadim Maltsev. Il nome del gioco \xABSheshDash\xBB \xE8 riservato al titolare dei diritti. Il progetto non \xE8 open source. \xC8 vietato copiare, distribuire o modificare il gioco senza il permesso scritto dell\u2019autore."
    },
    userConduct: {
      title: "4. Condotta dell'Utente",
      items: [
        "Rispetta gli altri giocatori e non usare linguaggio offensivo",
        "Non tentare di hackerare o interrompere il gioco",
        "Non creare account multipli per ottenere vantaggi ingiusti",
        "Segnala bug e vulnerabilit\xE0 all'autore"
      ]
    },
    disclaimer: {
      title: "5. Esclusione di Responsabilit\xE0",
      description: `Il gioco \xE8 fornito "cos\xEC com'\xE8" senza garanzie. L'autore non \xE8 responsabile per perdite o danni derivanti dall'uso del gioco.`
    },
    changes: {
      title: "6. Modifiche all'Accordo",
      description: "L'autore si riserva il diritto di modificare i termini di questo accordo in qualsiasi momento. L'uso continuato dopo le modifiche costituisce la tua accettazione dei nuovi termini."
    },
    copyright: "\xA9 2026 SheshDash. Tutti i diritti riservati.",
    author: "Sviluppatore: Vadim Maltsev",
    prohibited: {
      title: "Azioni vietate",
      items: [
        "copiare, riprodurre o distribuire il gioco",
        "creare cloni, modifiche o prodotti derivati",
        "utilizzare il codice, il design, la meccanica o le regole del gioco",
        "gestire il gioco o parti di esso con il proprio nome"
      ]
    },
    exclusiveRights: {
      title: "Diritti esclusivi",
      description: "Tutti i diritti esclusivi sul gioco appartengono al titolare dei diritti."
    },
    legalInfo: {
      title: "Informazioni legali",
      description: "SheshDash \xE8 software proprietario. Qualsiasi copia, distribuzione o modifica \xE8 vietata senza il consenso scritto del titolare dei diritti."
    }
  },
  navigation: {
    backToHome: "Torna alla home"
  },
  donate: {
    title: "Sostieni il progetto",
    thankYou: "Grazie per il tuo supporto!",
    description: "SheshDash \xE8 un progetto indie. Il tuo supporto aiuta a pagare i server e a creare nuove funzionalit\xE0.",
    waysToSupport: "Altri modi per aiutare",
    spreadWord: "Fallo sapere",
    spreadWordDesc: "Condividi SheshDash con amici e famiglia.",
    reportBugs: "Segnala bug",
    reportBugsDesc: "Aiuta a migliorare il gioco segnalando i problemi.",
    suggestFeatures: "Suggerisci idee",
    suggestFeaturesDesc: "Hai un\u2019idea? Dicci cosa vorresti vedere.",
    chooseCountry: "Dove ti trovi?",
    countryHelp: "Mostriamo opzioni legali per regione. Se qualcosa non \xE8 disponibile nel tuo paese, la piattaforma te lo dir\xE0.",
    countryRussia: "Russia",
    countryInternational: "Altri paesi",
    optionsTitle: "Dona tramite Boosty",
    platformBoostyTitle: "Boosty",
    platformBoostyDesc: "Abbonamenti e supporto una tantum; prelievi su carte in Russia.",
    platformCloudtipsTitle: "CloudTips",
    platformCloudtipsDesc: "Donazioni e abbonamenti per creator; prelievi su carte in Russia.",
    platformDonationAlertsTitle: "DonationAlerts",
    platformDonationAlertsDesc: "Donazioni per streaming; usalo se fai live.",
    platformPatreonTitle: "Patreon",
    platformPatreonDesc: "Abbonamenti per creator. Prelievi non disponibili in alcuni paesi (inclusa la Russia).",
    platformBmacTitle: "Buy Me a Coffee",
    platformBmacDesc: "Supporto una tantum e ricorrente via Stripe; disponibilit\xE0 secondo paese.",
    platformKofiTitle: "Ko-fi",
    platformKofiDesc: "Supporto via Stripe/PayPal; disponibilit\xE0 secondo paese.",
    platformGithubTitle: "GitHub Sponsors",
    platformGithubDesc: "Se il progetto \xE8 open source e sei in una regione supportata.",
    statusSetup: "In preparazione",
    statusCheckCountry: "Verifica disponibilit\xE0",
    statusStreaming: "Solo per streaming",
    availabilityNote: "Se una piattaforma non \xE8 disponibile nel tuo paese, non permetter\xE0 le donazioni.",
    boostyTitle: "Boosty",
    boostyDesc: "Supporto una tantum o ricorrente. I pagamenti sono gestiti da Boosty.",
    boostyButton: "Apri Boosty",
    boostyQrAlt: "QR code per donare su Boosty",
    boostyQrHint: "Scansiona il QR per aprire Boosty."
  },
  account: {
    title: "Account",
    loginTitle: "Accedi",
    loginDesc: "Accedi per monitorare le tue statistiche e la cronologia delle partite.",
    loginGoogle: "Accedi con Google",
    loginTelegram: "Accedi con Telegram",
    playAsGuest: "Gioca come ospite",
    settings: "Impostazioni account",
    displayName: "Nome visualizzato",
    save: "Salva",
    saved: "Salvato!",
    logout: "Esci",
    logoutConfirm: "Sei sicuro di voler uscire?",
    linkedAccounts: "Account collegati",
    memberSince: "Membro dal",
    dangerZone: "Zona pericolosa",
    deleteAccount: "Elimina account",
    preferredColor: "Colore preferito"
  },
  profile: {
    title: "Profilo giocatore",
    player: "Giocatore",
    gamesPlayed: "Partite giocate",
    wins: "Vittorie",
    winRate: "Percentuale vittorie",
    secondPlace: "2o posto",
    thirdPlace: "3o posto",
    fourthPlace: "4o posto",
    matchHistory: "Cronologia partite",
    noMatches: "Nessuna partita ancora.",
    placement: "Posto",
    date: "Data",
    players: "Giocatori",
    loadMore: "Carica altro"
  },
  leaderboard: {
    title: "Migliori giocatori",
    rank: "#",
    player: "Giocatore",
    wins: "Vittorie",
    games: "Partite",
    winRate: "% vittorie",
    noData: "Nessuna partita giocata ancora."
  },
  lobby: {
    onlinePlayers: "Giocatori online",
    waitingGames: "Partite pubbliche",
    findMatch: "Trova partita online",
    cancelMatch: "Annulla ricerca",
    searching: "Ricerca giocatori...",
    queueCount: "Giocatori in coda: {{count}} / 4",
    onlineCount: "Giocatori online: {{count}}",
    join: "Entra",
    creator: "Creatore",
    noGames: "Nessuna partita pubblica disponibile",
    botsOfferTitle: "Iniziare ora con i bot?",
    botsOfferText: "Mancano {{count}} giocatore(i). Inizia subito e completa il resto con i bot.",
    startWithBots: "Inizia con bot",
    keepWaiting: "Continua ad aspettare"
  },
  skin: {
    human: "Umano",
    guest: "Ospite",
    gameStatus: "Stato del gioco",
    gameInProgress: "Gioco in corso...",
    gameLog: "Registro di gioco",
    noEvents: "Nessun evento ancora",
    waitingForEvents: "In attesa di eventi di gioco...",
    gamePaused: "Partita in pausa..."
  },
  admin: {
    title: "Pannello di amministrazione",
    accessDenied: "Accesso solo per gli amministratori.",
    goToAccount: "Vai all'account",
    loadError: "Impossibile caricare i dati di amministrazione",
    announcement: {
      title: "Annuncio di sistema",
      placeholder: 'es. "Aggiornamento del gioco tra 5 minuti"',
      preview: "Anteprima",
      publishNow: "Pubblica ora",
      startTime: "Ora di inizio",
      endTime: "Ora di fine (facoltativo)",
      publish: "Pubblica",
      publishing: "Pubblicazione...",
      deactivate: "Disattiva",
      deactivateConfirm: "Disattivare l'annuncio corrente?",
      message: "Messaggio",
      status: "Stato",
      timeWindow: "Finestra",
      noEndTime: "senza fine",
      active: "attivo",
      inactive: "inattivo"
    },
    users: {
      title: "Giocatori",
      player: "Giocatore",
      email: "E-mail",
      role: "Ruolo",
      ban: "Blocco",
      banned: "Bloccato",
      active: "Attivo"
    },
    markdown: {
      bold: "testo in grassetto",
      italic: "corsivo",
      code: "codice",
      link: "collegamento",
      listItem: "elemento"
    },
    news: {
      title: "Novit\xE0 nella home page",
      versionLabel: "Versione",
      versionPlaceholder: "Per esempio: 0.0.26",
      contentLabel: "Cosa \xE8 stato realizzato",
      contentPlaceholder: "Descrivi cosa include questa versione.",
      publishLabel: "Mostra nella home page",
      preview: "Anteprima",
      create: "Crea notizia",
      update: "Salva modifiche",
      saving: "Salvataggio...",
      cancelEdit: "Annulla",
      edit: "Modifica",
      delete: "Elimina",
      deleteConfirm: "Eliminare questa notizia?",
      published: "pubblicata",
      draft: "bozza",
      empty: "Ancora nessuna novit\xE0.",
      hideBlockLabel: "Nascondi l'intero blocco notizie",
      hideItemLabel: "Nascondi questa notizia",
      hidden: "nascosta",
      subtitle: "Il contenuto delle notizie ora arriva da file versionati nel repository.",
      fileBasedHint: "Per cambiare i testi delle notizie in homepage, modifica direttamente nel repository i file news per ogni lingua."
    }
  },
  news: {
    title: "Novit\xE0 del gioco",
    subtitle: "Versioni e cosa \xE8 stato realizzato in ciascuna.",
    empty: "Ancora nessuna novit\xE0."
  },
  settings: {
    soundOn: "Audio attivo",
    soundOff: "Audio disattivato"
  }
};

// src/i18n/locales/zh.json
var zh_default = {
  meta: {
    title: "SheshDash - \u591A\u4EBA\u68CB\u76D8\u6E38\u620F",
    description: "\u4E00\u6B3E4\u4EBA\u591A\u4EBA\u68CB\u76D8\u6E38\u620F\u3002\u5728\u68CB\u76D8\u4E0A\u79FB\u52A8\u4F60\u7684\u68CB\u5B50\uFF0C\u7B2C\u4E00\u4E2A\u5230\u8FBE\u4E2D\u5FC3\u7684\u4EBA\u83B7\u80DC\uFF01",
    fullDescription: "SheshDash - 2-4\u4EBA\u68CB\u76D8\u6E38\u620F\u3002\u63B7\u9AB0\u5B50\uFF0C\u5728\u68CB\u76D8\u4E0A\u79FB\u52A8\u68CB\u5B50\uFF0C\u7B2C\u4E00\u4E2A\u5230\u8FBE\u4E2D\u5FC3\u5373\u53EF\u83B7\u80DC\uFF01"
  },
  landing: {
    playNow: "\u7ACB\u5373\u6E38\u620F",
    learnRules: "\u5B66\u4E60\u89C4\u5219",
    termsOfService: "\u670D\u52A1\u6761\u6B3E",
    supportProject: "\u652F\u6301\u9879\u76EE",
    myAccount: "\u6211\u7684\u8D26\u6237",
    copyright: "\xA9 2026 SheshDash. \u5F00\u53D1\u8005:Vadim Maltsev"
  },
  versionBanner: {
    updateAvailable: "\u6709\u65B0\u7248\u672C\u53EF\u7528",
    updateHint: "\u5F53\u524D\uFF1A{{current}}\u3002\u6700\u65B0\uFF1A{{latest}}\u3002\u65B9\u4FBF\u65F6\u8BF7\u5237\u65B0\u9875\u9762\u3002",
    incompatibleTitle: "\u6B64\u6807\u7B7E\u9875\u7248\u672C\u5DF2\u8FC7\u671F",
    incompatibleHint: "\u5F53\u524D\uFF1A{{current}}\u3002\u6700\u4F4E\u652F\u6301\u7248\u672C\uFF1A{{minimum}}\u3002\u8BF7\u5237\u65B0\u9875\u9762\u4EE5\u5B89\u5168\u7EE7\u7EED\u3002",
    refreshNow: "\u7ACB\u5373\u5237\u65B0",
    later: "\u7A0D\u540E",
    inGameWarning: "\u60A8\u6B63\u5728\u6E38\u620F\u4E2D\u3002\u5237\u65B0\u5C06\u6682\u65F6\u65AD\u5F00\u8FDE\u63A5\uFF0C\u4F46\u5E94\u4F1A\u81EA\u52A8\u91CD\u65B0\u8FDE\u63A5\u3002",
    inGameProceed: "\u4ECD\u7136\u66F4\u65B0",
    inGameCancel: "\u7559\u5728\u6E38\u620F\u4E2D"
  },
  game: {
    title: "SheshDash \u6E38\u620F",
    gameId: "\u6E38\u620FID",
    copyId: "\u590D\u5236ID",
    idCopied: "\u6E38\u620FID\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F\uFF01",
    createGame: "\u521B\u5EFA\u65B0\u6E38\u620F",
    privateGame: "\u79C1\u5BC6\u6E38\u620F\uFF08\u4ECE\u5728\u7EBF\u5217\u8868\u4E2D\u9690\u85CF\uFF09",
    joinGame: "\u52A0\u5165\u6E38\u620F",
    joinGameButton: "\u52A0\u5165",
    startGame: "\u5F00\u59CB\u6E38\u620F",
    back: "\u8FD4\u56DE",
    yourName: "\u4F60\u7684\u540D\u5B57",
    gameIdPlaceholder: "\u6E38\u620FID",
    connected: "\u5DF2\u8FDE\u63A5",
    connecting: "\u8FDE\u63A5\u4E2D...",
    waitingForPlayers: "\u7B49\u5F85\u73A9\u5BB6...",
    players: "\u73A9\u5BB6",
    shareGameId: "\u4E0E\u670B\u53CB\u5206\u4EAB\u6E38\u620FID\uFF01",
    canStartWithPlayers: '\u53EF\u4EE52-4\u540D\u73A9\u5BB6\u5F00\u59CB\u3002\u51C6\u5907\u597D\u540E\u70B9\u51FB"\u5F00\u59CB\u6E38\u620F"\uFF01',
    needMorePlayers: "\u81F3\u5C11\u9700\u89812\u540D\u73A9\u5BB6\u3002",
    botSuggestion: "\u673A\u5668\u4EBA\u5EFA\u8BAE",
    currentPlayers: "\u5F53\u524D\u73A9\u5BB6\uFF1A",
    yourTurn: "\u8F6E\u5230\u4F60\u4E86\uFF01",
    waiting: "\u7B49\u5F85\u4E2D...",
    rolled: "\u63B7\u9AB0",
    gameOver: "\u6E38\u620F\u7ED3\u675F\uFF01",
    winner: "\u83B7\u80DC\u8005",
    exitGame: "\u9000\u51FA\u6E38\u620F",
    turnTimer: "\u5269\u4F59\u65F6\u95F4",
    results: "\u6700\u7EC8\u6392\u540D",
    place: "\u540D\u6B21",
    preferredColor: "\u504F\u597D\u989C\u8272",
    autoAssignColor: "\u81EA\u52A8\u5206\u914D",
    colorRed: "\u7EA2\u8272",
    colorBlue: "\u84DD\u8272",
    colorGreen: "\u7EFF\u8272",
    colorOrange: "\u6A59\u8272",
    pause: "\u6682\u505C",
    resume: "\u7EE7\u7EED",
    paused: "\u5DF2\u6682\u505C",
    pausedHint: "\u6E38\u620F\u5DF2\u6682\u505C\u3002\u70B9\u51FB\u201C\u7EE7\u7EED\u201D\u5373\u53EF\u6062\u590D\u3002",
    onlyCreatorCanStart: "\u53EA\u6709\u521B\u5EFA\u8005\u624D\u80FD\u5F00\u59CB\u6E38\u620F\u3002"
  },
  kickVote: {
    confirm: "\u8981\u5C06 {{name}} \u79FB\u51FA\u6E38\u620F\u5417\uFF1F",
    title: "\u79FB\u51FA\u73A9\u5BB6\uFF1F",
    requestsToKick: "\u60F3\u8981\u79FB\u51FA",
    targetBot: "\u76EE\u6807\uFF1A\u673A\u5668\u4EBA",
    targetHuman: "\u76EE\u6807\uFF1A\u73A9\u5BB6",
    votes: "\u6295\u7968",
    approve: "\u540C\u610F",
    reject: "\u62D2\u7EDD",
    waiting: "\u7B49\u5F85\u5176\u4ED6\u6295\u7968",
    readOnly: "\u6295\u7968\u8FDB\u884C\u4E2D",
    kickedTitle: "\u4F60\u5DF2\u88AB\u79FB\u51FA\u6E38\u620F",
    kickedNotice: "\u4F60\u7684\u68CB\u5B50\u73B0\u5728\u4F1A\u534A\u900F\u660E\u663E\u793A\uFF0C\u5E76\u4E14\u4E0D\u518D\u963B\u6321\u6E38\u620F\u3002",
    returnToLobby: "\u8FD4\u56DE\u5927\u5385",
    observeGame: "\u89C2\u6218"
  },
  actions: {
    yourActions: "\u4F60\u7684\u884C\u52A8",
    rollDice: "\u63B7\u9AB0\u5B50\u5F00\u59CB\u4F60\u7684\u56DE\u5408\uFF01",
    needSix: "\u4F60\u9700\u8981\u63B7\u51FA6\u624D\u80FD\u653E\u7F6E\u7B2C\u4E00\u4E2A\u68CB\u5B50\uFF01",
    rolledSix: "\u4F60\u63B7\u51FA\u4E866\uFF01\u4FDD\u8BC1\u989D\u5916\u6295\u63B7\uFF01",
    rolledSixOptions: [
      "\u653E\u7F6E\u65B0\u68CB\u5B50\uFF08\u5982\u679C\u53EF\u7528\uFF09",
      "\u6216\u79FB\u52A8\u73B0\u6709\u68CB\u5B506\u6B65"
    ],
    rolledSixNote: "\u4EFB\u4E00\u9009\u62E9\u90FD\u80FD\u518D\u63B7\u4E00\u6B21\uFF01",
    selectPiece: "\u9009\u62E9\u4E00\u4E2A\u68CB\u5B50\u79FB\u52A8{{steps}}\u6B65\u3002",
    selectedPiece: "\u5DF2\u9009\u68CB\u5B50\uFF1A{{state}}",
    placePiece: "\u653E\u7F6E\u68CB\u5B50",
    moveSteps: "\u79FB\u52A8{{steps}}\u6B65",
    deselect: "\u53D6\u6D88\u9009\u62E9"
  },
  instructions: {
    title: "\u6E38\u620F\u89C4\u5219\uFF1A",
    rules: [
      "\u68CB\u5B50\u8D77\u59CB\u5728\u68CB\u76D8\u5916\uFF0C\u63B7\u51FA6\u5373\u53EF\u5C06\u4E00\u679A\u653E\u5230\u8D77\u59CB\u89D2\u683C\u3002",
      "\u987A\u65F6\u9488\u79FB\u52A8\u68CB\u5B50",
      "\u5B8C\u6210\u4E00\u5708\u540E\uFF0C\u5BF9\u89D2\u7EBF\u79FB\u5411\u4E2D\u5FC3",
      "\u7B2C\u4E00\u4E2A\u5C06\u6240\u67094\u4E2A\u68CB\u5B50\u79FB\u5230\u4E2D\u5FC3\u7684\u73A9\u5BB6\u83B7\u80DC\uFF01"
    ]
  },
  gameMode: {
    title: "\u4F60\u60F3\u600E\u4E48\u73A9\uFF1F",
    quickStart: "\u5FEB\u901F\u5F00\u59CB",
    quickStartDesc: "\u5BF9\u62183\u4E2A\u673A\u5668\u4EBA\uFF0C\u7ACB\u5373\u5F00\u59CB",
    withFriends: "\u4E0E\u670B\u53CB",
    withFriendsDesc: "\u5206\u4EAB\u4EE3\u7801\uFF0C\u7B49\u5F85\u670B\u53CB",
    findPlayers: "\u5BFB\u627E\u73A9\u5BB6",
    findPlayersDesc: "\u516C\u5F00\u5927\u5385\uFF0C\u4EFB\u4F55\u4EBA\u90FD\u53EF\u4EE5\u52A0\u5165"
  },
  bots: {
    addTitle: "\u6DFB\u52A0\u673A\u5668\u4EBA\uFF1F",
    addDescription: "\u8FD8\u6CA1\u6709\u5176\u4ED6\u4EBA\u52A0\u5165\u3002\u8981\u6DFB\u52A0\u673A\u5668\u4EBA\u5F00\u59CB\u5417\uFF1F",
    needMore: "\u8FD8\u9700\u8981{{count}}\u4E2A\u73A9\u5BB6\u3002",
    addButton: "\u6DFB\u52A0{{count}}\u4E2A\u673A\u5668\u4EBA",
    addButtonPlural: "\u6DFB\u52A0{{count}}\u4E2A\u673A\u5668\u4EBA",
    waitForPlayers: "\u7B49\u5F85\u73A9\u5BB6"
  },
  turn: {
    currentTurn: "\u5F53\u524D\u56DE\u5408",
    you: "\u4F60\u7684",
    skipped: "\u56DE\u5408\u5DF2\u8DF3\u8FC7",
    completed: "\u56DE\u5408\u5DF2\u5B8C\u6210"
  },
  errors: {
    error: "\u9519\u8BEF",
    pathBlocked: "\u8DEF\u5F84\u88AB\u963B\u6321 - \u65E0\u6CD5\u8DF3\u8FC7\u68CB\u5B50",
    cannotLandOnOwnPiece: "\u65E0\u6CD5\u843D\u5728\u81EA\u5DF1\u7684\u68CB\u5B50\u4E0A",
    pieceInCorner: "\u68CB\u5B50\u5728\u50A8\u5907\u4E2D\uFF0C\u5FC5\u987B\u63B7\u51FA6\u624D\u80FD\u653E\u7F6E",
    pieceAlreadyInCenter: "\u68CB\u5B50\u5DF2\u5728\u4E2D\u5FC3",
    needToRoll6: "\u9700\u8981\u63B7\u51FA6\u624D\u80FD\u653E\u7F6E\u68CB\u5B50",
    pieceNotInCorner: "\u68CB\u5B50\u4E0D\u5728\u50A8\u5907\u4E2D",
    pieceNotFound: "\u672A\u627E\u5230\u68CB\u5B50",
    notYourTurn: "\u8FD8\u6CA1\u8F6E\u5230\u4F60",
    gameNotInProgress: "\u6E38\u620F\u672A\u8FDB\u884C\u4E2D",
    stepsMustMatchDice: "\u6B65\u6570\u5FC5\u987B\u4E0E\u9AB0\u5B50\u5339\u914D",
    needExactRollForCenter: "\u9700\u8981\u7CBE\u786E\u7684\u70B9\u6570\u624D\u80FD\u8FDB\u5165\u4E2D\u5FC3",
    onlyCreatorCanStart: "\u53EA\u6709\u6E38\u620F\u521B\u5EFA\u8005\u624D\u80FD\u5F00\u59CB\u6E38\u620F",
    playerNameTaken: "\u8FD9\u4E2A\u73A9\u5BB6\u540D\u5728\u8FD9\u5C40\u6E38\u620F\u4E2D\u5DF2\u88AB\u5360\u7528"
  },
  pieceStates: {
    in_corner: "\u5728\u50A8\u5907\u4E2D",
    on_perimeter: "\u5728\u68CB\u76D8\u4E0A",
    on_diagonal: "\u5728\u5BF9\u89D2\u7EBF\u4E0A",
    in_center: "\u5728\u4E2D\u5FC3"
  },
  playerInfo: {
    title: "\u73A9\u5BB6",
    you: "\uFF08\u4F60\uFF09",
    turn: "\u56DE\u5408",
    corner: "\u50A8\u5907\uFF1A",
    onBoard: "\u68CB\u76D8\u4E0A\uFF1A",
    inCenter: "\u4E2D\u5FC3\uFF1A",
    waitingFor: "\u7B49\u5F85{{count}}\u4E2A\u73A9\u5BB6...",
    statusRolled6: "\u5956\u52B1\uFF01",
    statusCaptured: "\u6355\u83B7\uFF01\u5956\u52B1\uFF01",
    statusPlacedPiece: "\u5DF2\u653E\u7F6E\uFF0C\u5956\u52B1\uFF01",
    statusMovedOn6: "\u79FB\u52A86\u6B65\uFF0C\u5956\u52B1\uFF01",
    statusTurnSkipped: "\u8DF3\u8FC7",
    statusTurnComplete: "\u56DE\u5408\u7ED3\u675F"
  },
  dice: {
    rollDice: "\u63B7\u9AB0\u5B50",
    rolled6Message: "\u4F60\u63B7\u51FA\u4E866\uFF01\u53EF\u4EE5\u653E\u7F6E\u65B0\u68CB\u5B50\u6216\u79FB\u52A8\u73B0\u6709\u68CB\u5B506\u6B65\u3002",
    rolledBy: "\u63B7\u9AB0\u8005",
    round: "\u8F6E\u6B21",
    rolls: "\u63B7\u9AB0",
    captureBonus: "\u6355\u83B7\u5956\u52B1"
  },
  board: {
    currentPlayer: "\u5F53\u524D\u73A9\u5BB6",
    historyStart: "\u6700\u524D",
    historyPrev: "\u4E0A\u4E00\u6B65",
    historyNext: "\u4E0B\u4E00\u6B65",
    historyEnd: "\u6700\u540E",
    historyViewingPast: "\u5386\u53F2\u6A21\u5F0F\uFF1A\u64CD\u4F5C\u5DF2\u7981\u7528"
  },
  rules: {
    title: "\u6E38\u620F\u89C4\u5219",
    close: "\u5173\u95ED",
    showRules: "\u89C4\u5219",
    objective: {
      title: "\u76EE\u6807",
      description: "\u7387\u5148\u5C064\u679A\u68CB\u5B50\u4ECE\u8D77\u59CB\u683C\uFF08\u89D2\uFF09\u6CBF\u5468\u8FB9\u548C\u5BF9\u89D2\u7EBF\u79FB\u52A8\u5230\u4E2D\u5FC3\u533A\u57DF\u7684\u73A9\u5BB6\u83B7\u80DC\u3002"
    },
    setup: {
      title: "\u8BBE\u7F6E",
      items: [
        "\u6BCF\u4F4D\u73A9\u5BB6\u8D77\u59CB\u67094\u679A\u68CB\u5B50\u5728\u68CB\u76D8\u5916\uFF08\u50A8\u5907\uFF09",
        "\u73A9\u5BB6\u987A\u65F6\u9488\u8F6E\u6D41",
        "\u6240\u6709\u68CB\u5B50\u5728\u63B7\u51FA6\u4E4B\u524D\u90FD\u5728\u68CB\u76D8\u5916"
      ]
    },
    gameplay: {
      title: "\u6E38\u620F\u73A9\u6CD5",
      items: [
        "\u63B7\u9AB0\u5B50\u786E\u5B9A\u79FB\u52A8\u6B65\u6570",
        "\u8981\u653E\u7F6E\u7B2C\u4E00\u4E2A\u68CB\u5B50\uFF0C\u5FC5\u987B\u63B7\u51FA6",
        "\u68CB\u5B50\u987A\u65F6\u9488\u6CBF\u5916\u56F4\u79FB\u52A8\uFF0828\u4E2A\u4F4D\u7F6E\uFF09",
        "\u5B8C\u6210\u4E00\u5708\u540E\uFF0C\u6CBF\u5BF9\u89D2\u7EBF\u8FDB\u5165\u4E2D\u5FC3\uFF084\u6B65\uFF09",
        "\u50A8\u5907\u4E2D\u7684\u68CB\u5B50\u5728\u63B7\u51FA6\u4E4B\u524D\u4E0D\u80FD\u79FB\u52A8"
      ]
    },
    rolling6: {
      title: "\u63B7\u51FA6",
      description: "\u5F53\u4F60\u63B7\u51FA6\u65F6\uFF0C\u6709\u4E24\u4E2A\u9009\u62E9\uFF1A",
      options: [
        "\u5C06\u65B0\u7684\u68CB\u5B50\u653E\u5230\u8D77\u59CB\u683C\uFF08\u89D2\uFF09",
        "\u5C06\u73B0\u6709\u68CB\u5B50\u5411\u524D\u79FB\u52A86\u6B65"
      ],
      note: "\u4EFB\u4E00\u9009\u62E9\u90FD\u80FD\u83B7\u5F97\u989D\u5916\u6295\u63B7\uFF01\u53EA\u8981\u63B7\u51FA6\u5C31\u53EF\u4EE5\u7EE7\u7EED\u3002"
    },
    capturing: {
      title: "\u6355\u83B7",
      items: [
        "\u5982\u679C\u4F60\u7684\u68CB\u5B50\u6070\u597D\u843D\u5728\u5BF9\u624B\u7684\u68CB\u5B50\u4E0A\uFF0C\u5C31\u6355\u83B7\u5B83",
        "\u88AB\u5403\u6389\u7684\u68CB\u5B50\u4ECE\u68CB\u76D8\u4E0A\u79FB\u9664\uFF0C\u5E76\u56DE\u5230\u5BF9\u624B\u7684\u50A8\u5907",
        "\u4E0D\u80FD\u901A\u8FC7\u8DF3\u8FC7\u6765\u6355\u83B7 - \u5FC5\u987B\u6070\u597D\u843D\u5728\u8BE5\u4F4D\u7F6E",
        "\u6355\u83B7\u53EF\u83B7\u5F97\u989D\u5916\u6295\u63B7\uFF08\u989D\u5916\u56DE\u5408\uFF09"
      ]
    },
    blocking: {
      title: "\u963B\u6321",
      description: "\u4F60\u4E0D\u80FD\u8DF3\u8FC7\u5176\u4ED6\u68CB\u5B50\uFF01\u5982\u679C\u4EFB\u4F55\u68CB\u5B50\uFF08\u4F60\u7684\u6216\u5BF9\u624B\u7684\uFF09\u963B\u6321\u4E86\u4F60\u7684\u8DEF\u5F84\uFF0C\u4F60\u5C31\u65E0\u6CD5\u901A\u8FC7\u3002\u6574\u6761\u8DEF\u5F84\u5FC5\u987B\u7545\u901A\u3002"
    },
    winning: {
      title: "\u83B7\u80DC",
      description: "\u7B2C\u4E00\u4E2A\u5C06\u6240\u67094\u4E2A\u68CB\u5B50\u79FB\u5230\u4E2D\u5FC3\u533A\u57DF\u7684\u73A9\u5BB6\u8D62\u5F97\u6E38\u620F\uFF01"
    },
    bonusRolls: {
      title: "\u989D\u5916\u6295\u63B7",
      items: [
        "\u63B7\u51FA6\u65F6\u83B7\u5F97\u989D\u5916\u6295\u63B7\uFF08\u65E0\u8BBA\u662F\u653E\u7F6E\u8FD8\u662F\u79FB\u52A8\uFF09",
        "\u6355\u83B7\u5BF9\u624B\u68CB\u5B50\u65F6\u83B7\u5F97\u989D\u5916\u6295\u63B7",
        "\u989D\u5916\u6295\u63B7\u53EF\u4EE5\u53E0\u52A0 - \u5982\u679C\u518D\u6B21\u63B7\u51FA6\u6216\u518D\u6B21\u6355\u83B7\uFF0C\u7EE7\u7EED\u8FDB\u884C\uFF01"
      ]
    },
    timer: {
      title: "\u56DE\u5408\u8BA1\u65F6\u5668",
      items: [
        "\u6BCF\u4F4D\u73A9\u5BB6\u6709\u9650\u5B9A\u65F6\u95F4\u5B8C\u6210\u56DE\u5408",
        "\u5982\u679C\u65F6\u95F4\u7528\u5C3D\uFF0C\u56DE\u5408\u5C06\u81EA\u52A8\u8DF3\u8FC7"
      ]
    }
  },
  hint: {
    button: "\u63D0\u793A",
    title: "\u5EFA\u8BAE\u7684\u79FB\u52A8",
    noPieces: "\u6CA1\u6709\u53EF\u7528\u7684\u68CB\u5B50",
    canPlace: "\u63B7\u51FA6\uFF01\u5C06\u68CB\u5B50\u653E\u5230\u8D77\u59CB\u683C\uFF08\u89D2\uFF09",
    canMove: "\u5C06\u68CB\u5B50\u4ECE{{position}}\u79FB\u52A8{{steps}}\u6B65",
    close: "\u5173\u95ED"
  },
  theme: {
    sheshdash: "SheshDash",
    toggle: "\u5207\u6362\u4E3B\u9898",
    system: "\u7CFB\u7EDF",
    light: "\u6D45\u8272",
    dark: "\u6DF1\u8272"
  },
  tutorial: {
    button: "\u6559\u7A0B",
    skip: "\u8DF3\u8FC7",
    prev: "\u4E0A\u4E00\u6B65",
    next: "\u4E0B\u4E00\u6B65",
    finish: "\u5B8C\u6210",
    welcome: {
      title: "\u6B22\u8FCE\u6765\u5230SheshDash\uFF01",
      description: "\u8FD9\u4E2A\u7B80\u77ED\u7684\u4E92\u52A8\u6559\u7A0B\u4F1A\u6559\u4F60\u600E\u4E48\u73A9\u3002\u76EE\u6807\uFF1A\u7387\u5148\u5C064\u679A\u68CB\u5B50\u4ECE\u8D77\u59CB\u683C\uFF08\u89D2\uFF09\u79FB\u5230\u4E2D\u5FC3\uFF01"
    },
    createGame: {
      title: "\u521B\u5EFA\u6E38\u620F",
      description: "\u70B9\u51FB\u6B64\u6309\u94AE\u521B\u5EFA\u65B0\u6E38\u620F\u3002\u60A8\u5C06\u83B7\u5F97\u4E00\u4E2A\u552F\u4E00\u7684ID\uFF0C\u53EF\u4EE5\u4E0E\u670B\u53CB\u5206\u4EAB\u3002"
    },
    addBots: {
      title: "\u6DFB\u52A0\u673A\u5668\u4EBA",
      description: "\u5982\u679C\u73A9\u5BB6\u4E0D\u8DB3\uFF0C\u60A8\u53EF\u4EE5\u6DFB\u52A0\u673A\u5668\u4EBA\u3002\u6E38\u620F\u9700\u89812-4\u540D\u73A9\u5BB6\u624D\u80FD\u5F00\u59CB\u3002"
    },
    startGame: {
      title: "\u5F00\u59CB\u6E38\u620F",
      description: "\u5F53\u6240\u6709\u73A9\u5BB6\u51C6\u5907\u5C31\u7EEA\uFF08\u81F3\u5C112\u4EBA\uFF09\u65F6\uFF0C\u70B9\u51FB\u6B64\u6309\u94AE\u5F00\u59CB\u6E38\u620F\uFF01"
    },
    diceButton: {
      title: "\u{1F3B2} \u63B7\u9AB0\u5B50",
      description: "\u70B9\u51FB\u6B64\u6309\u94AE\u63B7\u9AB0\u5B50\u3002\u4F60\u9700\u8981\u63B7\u51FA6\u624D\u80FD\u653E\u7F6E\u7B2C\u4E00\u4E2A\u68CB\u5B50\uFF01"
    },
    board: {
      title: "\u{1F3AE} \u6E38\u620F\u68CB\u76D8",
      description: "\u8FD9\u662F8\xD78\u68CB\u76D8\u3002\u68CB\u5B50\u4ECE\u8D77\u59CB\u683C\uFF08\u89D2\uFF09\u8FDB\u5165\uFF0C\u7136\u540E\u6CBF\u5468\u8FB9\u987A\u65F6\u9488\u79FB\u52A8\u3002"
    },
    playerInfo: {
      title: "\u{1F4CA} \u73A9\u5BB6\u4FE1\u606F",
      description: "\u5728\u8FD9\u91CC\u4F60\u53EF\u4EE5\u770B\u5230\u6240\u6709\u73A9\u5BB6\u3001\u4ED6\u4EEC\u7684\u68CB\u5B50\u548C\u5F53\u524D\u56DE\u5408\u3002\u89C2\u5BDF\u8C01\u5728\u73A9\uFF01"
    },
    selectPiece: {
      title: "\u{1F3AF} \u6B65\u9AA41\uFF1A\u9009\u62E9\u68CB\u5B50",
      description: "\u8FD9\u91CC\u662F\u8D77\u59CB\u683C\uFF08\u89D2\uFF09\uFF01\u63B7\u51FA6\u540E\u70B9\u51FB\u68CB\u5B50\u5C06\u5176\u653E\u5230\u68CB\u76D8\u4E0A\u3002"
    },
    placeButton: {
      title: "\u2705 \u6B65\u9AA42\uFF1A\u653E\u7F6E\u6309\u94AE",
      description: '\u5728\u8FD9\u91CC\u4F1A\u51FA\u73B0"\u653E\u7F6E\u68CB\u5B50"\u6309\u94AE\u3002\u70B9\u51FB\u5B83\uFF0C\u68CB\u5B50\u5C06\u88AB\u653E\u7F6E\u5728\u8D77\u59CB\u4F4D\u7F6E\uFF01\u4F60\u5C06\u83B7\u5F97\u989D\u5916\u6295\u63B7\uFF01'
    },
    moveInstruction: {
      title: "\u{1F463} \u5982\u4F55\u79FB\u52A8\u68CB\u5B50",
      description: '\u63B7\u9AB0\u540E\uFF1A\u2460 \u70B9\u51FB\u68CB\u76D8\u4E0A\u7684\u4F60\u7684\u68CB\u5B50 \u2461 \u6309\u53F3\u4FA7\u7684"\u79FB\u52A8X\u6B65"\u6309\u94AE\u3002\u8BB0\u4F4F\uFF1A\u4F60\u4E0D\u80FD\u8DF3\u8FC7\u5176\u4ED6\u68CB\u5B50\uFF01'
    },
    goal: {
      title: "\u{1F3C6} \u6E38\u620F\u76EE\u6807 - \u4E2D\u5FC3\uFF01",
      description: "\u5C31\u662F\u5B83\u4EEC - \u91D1\u8272\u683C\u5B50\uFF08a8\u2192b7\u2192c6\u2192d5\uFF09\uFF01\u7B2C\u4E00\u4E2A\u5C06\u6240\u67094\u4E2A\u68CB\u5B50\u5BF9\u89D2\u7EBF\u79FB\u5230\u8FD9\u91CC\u5E76\u83B7\u80DC\uFF01\u8DEF\u5F84\uFF1A\u8FB9\u7F18\uFF0828\u6B65\uFF09\u2192\u5BF9\u89D2\u7EBF\u5230\u4E2D\u5FC3\uFF084\u6B65\uFF09\u3002"
    }
  },
  common: {
    cancel: "\u53D6\u6D88",
    back: "\u8FD4\u56DE",
    confirm: "\u786E\u8BA4",
    close: "\u5173\u95ED"
  },
  joinVote: {
    title: "\u52A0\u5165\u8BF7\u6C42",
    wantsToJoin: "\u60F3\u8981\u52A0\u5165\u6E38\u620F",
    willReplaceBot: "\u5C06\u66FF\u6362\u673A\u5668\u4EBA",
    keepPieces: "\u4FDD\u7559\u673A\u5668\u4EBA\u7684\u68CB\u5B50",
    newPieces: "\u4F7F\u7528\u65B0\u68CB\u5B50\u5F00\u59CB",
    votes: "\u6295\u7968",
    approve: "\u8D5E\u6210",
    reject: "\u53CD\u5BF9",
    total: "\u603B\u8BA1",
    approveButton: "\u6279\u51C6",
    rejectButton: "\u62D2\u7EDD",
    waiting: "\u7B49\u5F85\u5176\u4ED6\u73A9\u5BB6..."
  },
  joinStarted: {
    title: "\u52A0\u5165\u8FDB\u884C\u4E2D\u7684\u6E38\u620F",
    gameInProgress: "\u8FD9\u5C40\u6E38\u620F\u5DF2\u7ECF\u5F00\u59CB\u3002",
    chooseOption: "\u9009\u62E9\u4F60\u7684\u52A0\u5165\u65B9\u5F0F\uFF1A",
    replaceBot: "\u66FF\u6362\u673A\u5668\u4EBA",
    replaceBotHint: "\u63A5\u7BA1\u673A\u5668\u4EBA\u7684\u4F4D\u7F6E",
    newPlayer: "\u4F5C\u4E3A\u65B0\u73A9\u5BB6\u52A0\u5165",
    newPlayerHint: "\u4F7F\u7528\u65B0\u68CB\u5B50\u5F00\u59CB",
    noOptions: "\u65E0\u6CD5\u52A0\u5165\uFF1A\u6CA1\u6709\u53EF\u66FF\u6362\u7684\u673A\u5668\u4EBA\uFF0C\u4E5F\u6CA1\u6709\u7A7A\u4F4D\u3002",
    note: "\u63D0\u793A",
    voteRequired: "\u6240\u6709\u73A9\u5BB6\u90FD\u5FC5\u987B\u6279\u51C6\u4F60\u7684\u52A0\u5165\u8BF7\u6C42\u3002",
    replaceBotTitle: "\u66FF\u6362\u673A\u5668\u4EBA",
    selectBot: "\u9009\u62E9\u8981\u66FF\u6362\u7684\u673A\u5668\u4EBA\uFF1A",
    selectBotPlaceholder: "-- \u9009\u62E9\u673A\u5668\u4EBA --",
    keepPieces: "\u4FDD\u7559\u673A\u5668\u4EBA\u7684\u68CB\u5B50\u548C\u5F53\u524D\u4F4D\u7F6E",
    keepPiecesHint: "\u4F60\u5C06\u63A5\u7BA1\u673A\u5668\u4EBA\u7684\u5F53\u524D\u68CB\u5B50\u548C\u4F4D\u7F6E",
    resetPiecesHint: "\u673A\u5668\u4EBA\u7684\u68CB\u5B50\u5C06\u91CD\u7F6E\u5230\u8D77\u59CB\u89D2\u843D",
    yourName: "\u4F60\u7684\u540D\u5B57",
    sendRequest: "\u53D1\u9001\u8BF7\u6C42",
    newPlayerTitle: "\u4F5C\u4E3A\u65B0\u73A9\u5BB6\u52A0\u5165",
    newPlayerInfo: "\u4F60\u5C06\u5728\u53EF\u7528\u89D2\u843D\u4F7F\u7528\u65B0\u68CB\u5B50\u52A0\u5165\u6E38\u620F\u3002",
    currentPlayers: "\u5F53\u524D\u73A9\u5BB6",
    lateJoinWarning: "\u4F60\u662F\u4E2D\u9014\u52A0\u5165\uFF0C\u5176\u4ED6\u73A9\u5BB6\u5DF2\u7ECF\u9886\u5148\uFF01",
    waitingApproval: "\u7B49\u5F85\u6279\u51C6",
    waitingApprovalText: "\u73A9\u5BB6\u6B63\u5728\u5BF9\u4F60\u7684\u52A0\u5165\u8BF7\u6C42\u8FDB\u884C\u6295\u7968\u3002"
  },
  userAgreement: {
    title: "\u7528\u6237\u534F\u8BAE",
    close: "\u5173\u95ED",
    acceptance: {
      title: "1. \u63A5\u53D7\u6761\u6B3E",
      description: "\u4F7F\u7528SheshDash\u6E38\u620F\uFF0C\u5373\u8868\u793A\u4F60\u540C\u610F\u672C\u7528\u6237\u534F\u8BAE\u7684\u6761\u6B3E\u3002\u5982\u679C\u4E0D\u540C\u610F\uFF0C\u8BF7\u4E0D\u8981\u4F7F\u7528\u672C\u6E38\u620F\u3002"
    },
    gameRules: {
      title: "2. \u6E38\u620F\u89C4\u5219",
      description: "\u73A9\u5BB6\u540C\u610F\u9075\u5B88SheshDash\u7684\u89C4\u5219\u3002\u53EA\u5141\u8BB8\u5728\u6E38\u620F\u63D0\u4F9B\u7684\u529F\u80FD\u8303\u56F4\u5185\u4F7F\u7528\u673A\u5668\u4EBA\u3002\u7981\u6B62\u4EFB\u4F55\u4F5C\u5F0A\u3001\u4F7F\u7528\u9ED1\u5BA2\u5DE5\u5177\u6216\u5229\u7528\u6F0F\u6D1E\u7684\u884C\u4E3A\u3002"
    },
    intellectualProperty: {
      title: "3. \u77E5\u8BC6\u4EA7\u6743",
      description: "\u6E38\u620F SheshDash \u7684\u6240\u6709\u6743\u5229\uFF08\u5305\u62EC\u4EE3\u7801\u3001\u8BBE\u8BA1\u3001\u56FE\u5F62\u3001\u670D\u52A1\u5668\u903B\u8F91\u3001\u6E38\u620F\u673A\u5236\u548C\u89C4\u5219\uFF09\u5F52\u4F5C\u8005 Vadim Maltsev \u6240\u6709\u3002\u6E38\u620F\u540D\u79F0\u201CSheshDash\u201D\u7531\u6743\u5229\u4EBA\u4FDD\u7559\u3002\u8BE5\u9879\u76EE\u4E0D\u662F\u5F00\u6E90\u3002\u672A\u7ECF\u4F5C\u8005\u4E66\u9762\u8BB8\u53EF\uFF0C\u7981\u6B62\u590D\u5236\u3001\u4F20\u64AD\u6216\u4FEE\u6539\u3002"
    },
    userConduct: {
      title: "4. \u7528\u6237\u884C\u4E3A",
      items: [
        "\u5C0A\u91CD\u5176\u4ED6\u73A9\u5BB6\uFF0C\u4E0D\u4F7F\u7528\u5192\u72AF\u6027\u8BED\u8A00",
        "\u4E0D\u8981\u8BD5\u56FE\u9ED1\u5BA2\u653B\u51FB\u6216\u7834\u574F\u6E38\u620F",
        "\u4E0D\u8981\u521B\u5EFA\u591A\u4E2A\u8D26\u6237\u4EE5\u83B7\u5F97\u4E0D\u516C\u5E73\u4F18\u52BF",
        "\u5411\u4F5C\u8005\u62A5\u544A\u9519\u8BEF\u548C\u6F0F\u6D1E"
      ]
    },
    disclaimer: {
      title: "5. \u514D\u8D23\u58F0\u660E",
      description: '\u6E38\u620F\u6309"\u539F\u6837"\u63D0\u4F9B\uFF0C\u4E0D\u63D0\u4F9B\u4EFB\u4F55\u4FDD\u8BC1\u3002\u4F5C\u8005\u5BF9\u56E0\u4F7F\u7528\u6E38\u620F\u800C\u4EA7\u751F\u7684\u4EFB\u4F55\u635F\u5931\u6216\u635F\u5BB3\u6982\u4E0D\u8D1F\u8D23\u3002'
    },
    changes: {
      title: "6. \u534F\u8BAE\u53D8\u66F4",
      description: "\u4F5C\u8005\u4FDD\u7559\u968F\u65F6\u4FEE\u6539\u672C\u534F\u8BAE\u6761\u6B3E\u7684\u6743\u5229\u3002\u53D8\u66F4\u540E\u7EE7\u7EED\u4F7F\u7528\u5373\u8868\u793A\u4F60\u63A5\u53D7\u65B0\u6761\u6B3E\u3002"
    },
    copyright: "\xA9 2026 SheshDash. \u4FDD\u7559\u6240\u6709\u6743\u5229\u3002",
    author: "\u5F00\u53D1\u8005\uFF1AVadim Maltsev",
    prohibited: {
      title: "\u7981\u6B62\u4E8B\u9879",
      items: [
        "\u590D\u5236\u3001\u518D\u73B0\u6216\u4F20\u64AD\u672C\u6E38\u620F",
        "\u521B\u5EFA\u514B\u9686\u3001\u4FEE\u6539\u6216\u884D\u751F\u4EA7\u54C1",
        "\u4F7F\u7528\u6E38\u620F\u7684\u4EE3\u7801\u3001\u8BBE\u8BA1\u3001\u673A\u5236\u6216\u89C4\u5219",
        "\u4EE5\u81EA\u5DF1\u7684\u540D\u4E49\u8FD0\u8425\u6E38\u620F\u6216\u5176\u4EFB\u4F55\u90E8\u5206"
      ]
    },
    exclusiveRights: {
      title: "\u4E13\u6709\u6743\u5229",
      description: "\u6E38\u620F\u7684\u5168\u90E8\u4E13\u6709\u6743\u5229\u5F52\u6743\u5229\u4EBA\u6240\u6709\u3002"
    },
    legalInfo: {
      title: "\u6CD5\u5F8B\u4FE1\u606F",
      description: "SheshDash \u4E3A\u4E13\u6709\u8F6F\u4EF6\u3002\u672A\u7ECF\u6743\u5229\u4EBA\u4E66\u9762\u540C\u610F\uFF0C\u7981\u6B62\u590D\u5236\u3001\u4F20\u64AD\u6216\u4FEE\u6539\u3002"
    }
  },
  navigation: {
    backToHome: "\u8FD4\u56DE\u9996\u9875"
  },
  donate: {
    title: "\u652F\u6301\u9879\u76EE",
    thankYou: "\u611F\u8C22\u4F60\u7684\u652F\u6301\uFF01",
    description: "SheshDash \u662F\u4E00\u4E2A\u72EC\u7ACB\u9879\u76EE\u3002\u4F60\u7684\u652F\u6301\u6709\u52A9\u4E8E\u670D\u52A1\u5668\u7EF4\u62A4\u548C\u65B0\u529F\u80FD\u5F00\u53D1\u3002",
    waysToSupport: "\u5176\u4ED6\u652F\u6301\u65B9\u5F0F",
    spreadWord: "\u544A\u8BC9\u670B\u53CB",
    spreadWordDesc: "\u628A SheshDash \u5206\u4EAB\u7ED9\u670B\u53CB\u548C\u5BB6\u4EBA\u3002",
    reportBugs: "\u53CD\u9988\u95EE\u9898",
    reportBugsDesc: "\u62A5\u544A\u4F60\u53D1\u73B0\u7684\u9519\u8BEF\uFF0C\u5E2E\u52A9\u6211\u4EEC\u6539\u8FDB\u3002",
    suggestFeatures: "\u63D0\u51FA\u5EFA\u8BAE",
    suggestFeaturesDesc: "\u6709\u60F3\u6CD5\uFF1F\u544A\u8BC9\u6211\u4EEC\u4F60\u60F3\u770B\u5230\u4EC0\u4E48\u3002",
    chooseCountry: "\u4F60\u6240\u5728\u7684\u5730\u533A",
    countryHelp: "\u6211\u4EEC\u6309\u5730\u533A\u63D0\u4F9B\u5408\u6CD5\u9009\u9879\u3002\u5982\u679C\u5728\u4F60\u7684\u56FD\u5BB6\u4E0D\u53EF\u7528\uFF0C\u5E73\u53F0\u4F1A\u63D0\u793A\u3002",
    countryRussia: "\u4FC4\u7F57\u65AF",
    countryInternational: "\u5176\u4ED6\u56FD\u5BB6",
    optionsTitle: "\u901A\u8FC7 Boosty \u6350\u52A9",
    platformBoostyTitle: "Boosty",
    platformBoostyDesc: "\u4F1A\u5458\u4E0E\u5355\u6B21\u652F\u6301\uFF1B\u53EF\u63D0\u73B0\u5230\u4FC4\u7F57\u65AF\u94F6\u884C\u5361\u3002",
    platformCloudtipsTitle: "CloudTips",
    platformCloudtipsDesc: "\u521B\u4F5C\u8005\u6350\u52A9\u4E0E\u8BA2\u9605\uFF1B\u53EF\u63D0\u73B0\u5230\u4FC4\u7F57\u65AF\u94F6\u884C\u5361\u3002",
    platformDonationAlertsTitle: "DonationAlerts",
    platformDonationAlertsDesc: "\u9762\u5411\u76F4\u64AD\u7684\u6350\u52A9\uFF1B\u5982\u6709\u76F4\u64AD\u53EF\u7528\u3002",
    platformPatreonTitle: "Patreon",
    platformPatreonDesc: "\u4F1A\u5458\u652F\u6301\u3002\u90E8\u5206\u56FD\u5BB6\u65E0\u6CD5\u63D0\u73B0\u5417\uFF08\u5305\u62EC\u4FC4\u7F57\u65AF\uFF09\u3002",
    platformBmacTitle: "Buy Me a Coffee",
    platformBmacDesc: "\u901A\u8FC7 Stripe \u7684\u5355\u6B21/\u8BA2\u9605\u652F\u6301\uFF1B\u53D6\u51B3\u4E8E\u56FD\u5BB6\u3002",
    platformKofiTitle: "Ko-fi",
    platformKofiDesc: "\u901A\u8FC7 Stripe/PayPal\uFF1B\u53D6\u51B3\u4E8E\u56FD\u5BB6\u3002",
    platformGithubTitle: "GitHub Sponsors",
    platformGithubDesc: "\u5982\u679C\u662F\u5F00\u6E90\u9879\u76EE\u4E14\u5728\u652F\u6301\u5730\u533A\u3002",
    statusSetup: "\u51C6\u5907\u4E2D",
    statusCheckCountry: "\u8BF7\u786E\u8BA4\u53EF\u7528\u6027",
    statusStreaming: "\u4EC5\u9650\u76F4\u64AD",
    availabilityNote: "\u5982\u679C\u5E73\u53F0\u5728\u4F60\u7684\u56FD\u5BB6\u4E0D\u53EF\u7528\uFF0C\u5C06\u65E0\u6CD5\u5B8C\u6210\u6350\u52A9\u3002",
    boostyTitle: "Boosty",
    boostyDesc: "\u4E00\u6B21\u6027\u6216\u5B9A\u671F\u652F\u6301\u3002\u652F\u4ED8\u7531 Boosty \u5904\u7406\u3002",
    boostyButton: "\u6253\u5F00 Boosty",
    boostyQrAlt: "Boosty \u6350\u52A9\u4E8C\u7EF4\u7801",
    boostyQrHint: "\u626B\u63CF\u4E8C\u7EF4\u7801\u6253\u5F00 Boosty\u3002"
  },
  account: {
    title: "\u8D26\u6237",
    loginTitle: "\u767B\u5F55",
    loginDesc: "\u767B\u5F55\u4EE5\u67E5\u770B\u4F60\u7684\u7EDF\u8BA1\u6570\u636E\u548C\u6E38\u620F\u5386\u53F2\u3002",
    loginGoogle: "\u4F7F\u7528 Google \u767B\u5F55",
    loginTelegram: "\u4F7F\u7528 Telegram \u767B\u5F55",
    playAsGuest: "\u4EE5\u6E38\u5BA2\u8EAB\u4EFD\u73A9",
    settings: "\u8D26\u6237\u8BBE\u7F6E",
    displayName: "\u663E\u793A\u540D\u79F0",
    save: "\u4FDD\u5B58",
    saved: "\u5DF2\u4FDD\u5B58\uFF01",
    logout: "\u9000\u51FA\u767B\u5F55",
    logoutConfirm: "\u786E\u5B9A\u8981\u9000\u51FA\u767B\u5F55\u5417\uFF1F",
    linkedAccounts: "\u5DF2\u5173\u8054\u8D26\u6237",
    memberSince: "\u6CE8\u518C\u65F6\u95F4",
    dangerZone: "\u5371\u9669\u533A\u57DF",
    deleteAccount: "\u5220\u9664\u8D26\u6237",
    preferredColor: "\u504F\u597D\u989C\u8272"
  },
  profile: {
    title: "\u73A9\u5BB6\u8D44\u6599",
    player: "\u73A9\u5BB6",
    gamesPlayed: "\u6E38\u620F\u573A\u6B21",
    wins: "\u80DC\u5229",
    winRate: "\u80DC\u7387",
    secondPlace: "\u7B2C2\u540D",
    thirdPlace: "\u7B2C3\u540D",
    fourthPlace: "\u7B2C4\u540D",
    matchHistory: "\u6BD4\u8D5B\u8BB0\u5F55",
    noMatches: "\u6682\u65E0\u6BD4\u8D5B\u8BB0\u5F55\u3002",
    placement: "\u540D\u6B21",
    date: "\u65E5\u671F",
    players: "\u73A9\u5BB6",
    loadMore: "\u52A0\u8F7D\u66F4\u591A"
  },
  leaderboard: {
    title: "\u9876\u7EA7\u73A9\u5BB6",
    rank: "#",
    player: "\u73A9\u5BB6",
    wins: "\u80DC\u573A",
    games: "\u573A\u6B21",
    winRate: "\u80DC\u7387",
    noData: "\u6682\u65E0\u6BD4\u8D5B\u8BB0\u5F55\u3002"
  },
  lobby: {
    onlinePlayers: "\u5728\u7EBF\u73A9\u5BB6",
    waitingGames: "\u516C\u5F00\u623F\u95F4",
    findMatch: "\u67E5\u627E\u5728\u7EBF\u5BF9\u5C40",
    cancelMatch: "\u53D6\u6D88\u5339\u914D",
    searching: "\u6B63\u5728\u5BFB\u627E\u73A9\u5BB6...",
    queueCount: "\u961F\u5217\u4E2D\u7684\u73A9\u5BB6: {{count}} / 4",
    onlineCount: "\u5728\u7EBF\u73A9\u5BB6: {{count}}",
    join: "\u52A0\u5165",
    creator: "\u521B\u5EFA\u8005",
    noGames: "\u6682\u65E0\u53EF\u52A0\u5165\u7684\u516C\u5F00\u623F\u95F4",
    botsOfferTitle: "\u73B0\u5728\u4E0E\u673A\u5668\u4EBA\u5F00\u59CB\u5417\uFF1F",
    botsOfferText: "\u8FD8\u7F3A {{count}} \u540D\u73A9\u5BB6\u3002\u7ACB\u5373\u5F00\u59CB\uFF0C\u5176\u4F59\u4F4D\u7F6E\u7531\u673A\u5668\u4EBA\u8865\u8DB3\u3002",
    startWithBots: "\u4E0E\u673A\u5668\u4EBA\u5F00\u59CB",
    keepWaiting: "\u7EE7\u7EED\u7B49\u5F85"
  },
  skin: {
    human: "\u771F\u4EBA",
    guest: "\u8BBF\u5BA2",
    gameStatus: "\u6E38\u620F\u72B6\u6001",
    gameInProgress: "\u6E38\u620F\u8FDB\u884C\u4E2D...",
    gameLog: "\u6E38\u620F\u65E5\u5FD7",
    noEvents: "\u6682\u65E0\u4E8B\u4EF6",
    waitingForEvents: "\u7B49\u5F85\u6E38\u620F\u4E8B\u4EF6...",
    gamePaused: "\u6E38\u620F\u5DF2\u6682\u505C..."
  },
  admin: {
    title: "\u7BA1\u7406\u9762\u677F",
    accessDenied: "\u4EC5\u7BA1\u7406\u5458\u53EF\u8BBF\u95EE\u3002",
    goToAccount: "\u524D\u5F80\u8D26\u6237",
    loadError: "\u65E0\u6CD5\u52A0\u8F7D\u7BA1\u7406\u6570\u636E",
    announcement: {
      title: "\u7CFB\u7EDF\u516C\u544A",
      placeholder: '\u4F8B\u5982\uFF1A"5\u5206\u949F\u540E\u5C06\u8FDB\u884C\u6E38\u620F\u66F4\u65B0"',
      preview: "\u9884\u89C8",
      publishNow: "\u7ACB\u5373\u53D1\u5E03",
      startTime: "\u5F00\u59CB\u65F6\u95F4",
      endTime: "\u7ED3\u675F\u65F6\u95F4\uFF08\u53EF\u9009\uFF09",
      publish: "\u53D1\u5E03",
      publishing: "\u53D1\u5E03\u4E2D...",
      deactivate: "\u505C\u7528",
      deactivateConfirm: "\u505C\u7528\u5F53\u524D\u516C\u544A\u5417\uFF1F",
      message: "\u6D88\u606F",
      status: "\u72B6\u6001",
      timeWindow: "\u65F6\u95F4\u7A97\u53E3",
      noEndTime: "\u65E0\u7ED3\u675F\u65F6\u95F4",
      active: "\u6D3B\u8DC3",
      inactive: "\u672A\u6FC0\u6D3B"
    },
    users: {
      title: "\u73A9\u5BB6",
      player: "\u73A9\u5BB6",
      email: "\u90AE\u7BB1",
      role: "\u89D2\u8272",
      ban: "\u5C01\u7981",
      banned: "\u5DF2\u5C01\u7981",
      active: "\u6D3B\u8DC3"
    },
    markdown: {
      bold: "\u7C97\u4F53\u6587\u5B57",
      italic: "\u659C\u4F53",
      code: "\u4EE3\u7801",
      link: "\u94FE\u63A5",
      listItem: "\u5217\u8868\u9879"
    },
    news: {
      title: "\u9996\u9875\u65B0\u95FB",
      versionLabel: "\u7248\u672C",
      versionPlaceholder: "\u4F8B\u5982\uFF1A0.0.26",
      contentLabel: "\u5DF2\u5B9E\u73B0\u5185\u5BB9",
      contentPlaceholder: "\u63CF\u8FF0\u6B64\u7248\u672C\u5305\u542B\u7684\u529F\u80FD\u3002",
      publishLabel: "\u663E\u793A\u5728\u9996\u9875",
      preview: "\u9884\u89C8",
      create: "\u521B\u5EFA\u65B0\u95FB",
      update: "\u4FDD\u5B58\u66F4\u6539",
      saving: "\u4FDD\u5B58\u4E2D...",
      cancelEdit: "\u53D6\u6D88",
      edit: "\u7F16\u8F91",
      delete: "\u5220\u9664",
      deleteConfirm: "\u5220\u9664\u8FD9\u6761\u65B0\u95FB\uFF1F",
      published: "\u5DF2\u53D1\u5E03",
      draft: "\u8349\u7A3F",
      empty: "\u6682\u65F6\u8FD8\u6CA1\u6709\u65B0\u95FB\u3002",
      hideBlockLabel: "\u9690\u85CF\u6574\u4E2A\u65B0\u95FB\u533A\u5757",
      hideItemLabel: "\u9690\u85CF\u8FD9\u6761\u65B0\u95FB",
      hidden: "\u5DF2\u9690\u85CF",
      subtitle: "\u65B0\u95FB\u5185\u5BB9\u73B0\u5728\u6765\u81EA\u4ED3\u5E93\u4E2D\u7684\u7248\u672C\u5316\u6587\u4EF6\u3002",
      fileBasedHint: "\u5982\u679C\u8981\u4FEE\u6539\u9996\u9875\u65B0\u95FB\u6587\u6848\uFF0C\u8BF7\u76F4\u63A5\u7F16\u8F91\u4ED3\u5E93\u91CC\u5404\u8BED\u8A00\u5BF9\u5E94\u7684\u65B0\u95FB\u6587\u4EF6\u3002"
    }
  },
  news: {
    title: "\u6E38\u620F\u65B0\u95FB",
    subtitle: "\u5C55\u793A\u7248\u672C\u4EE5\u53CA\u8BE5\u7248\u672C\u5DF2\u5B9E\u73B0\u7684\u5185\u5BB9\u3002",
    empty: "\u6682\u65F6\u8FD8\u6CA1\u6709\u65B0\u95FB\u3002"
  },
  settings: {
    soundOn: "\u58F0\u97F3\u5F00\u542F",
    soundOff: "\u58F0\u97F3\u5173\u95ED"
  }
};

// src/i18n/locales/ja.json
var ja_default = {
  meta: {
    title: "SheshDash - \u30DE\u30EB\u30C1\u30D7\u30EC\u30A4\u30E4\u30FC\u30DC\u30FC\u30C9\u30B2\u30FC\u30E0",
    description: "4\u4EBA\u7528\u306E\u30DE\u30EB\u30C1\u30D7\u30EC\u30A4\u30E4\u30FC\u30DC\u30FC\u30C9\u30B2\u30FC\u30E0\u3002\u30B3\u30DE\u3092\u30DC\u30FC\u30C9\u4E0A\u3067\u52D5\u304B\u3057\u3066\u3001\u6700\u521D\u306B\u4E2D\u5FC3\u306B\u5230\u9054\u3057\u307E\u3057\u3087\u3046\uFF01",
    fullDescription: "SheshDash - 2\u301C4\u4EBA\u7528\u306E\u30DC\u30FC\u30C9\u30B2\u30FC\u30E0\u3002\u30B5\u30A4\u30B3\u30ED\u3092\u632F\u308A\u3001\u30B3\u30DE\u3092\u30DC\u30FC\u30C9\u4E0A\u3067\u52D5\u304B\u3057\u3001\u6700\u521D\u306B\u4E2D\u5FC3\u306B\u5230\u9054\u3057\u3066\u52DD\u5229\u3057\u307E\u3057\u3087\u3046\uFF01"
  },
  landing: {
    playNow: "\u4ECA\u3059\u3050\u30D7\u30EC\u30A4",
    learnRules: "\u30EB\u30FC\u30EB\u3092\u5B66\u3076",
    termsOfService: "\u5229\u7528\u898F\u7D04",
    supportProject: "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u652F\u63F4",
    myAccount: "\u30DE\u30A4\u30A2\u30AB\u30A6\u30F3\u30C8",
    copyright: "\xA9 2026 SheshDash. \u958B\u767A\u8005:Vadim Maltsev"
  },
  versionBanner: {
    updateAvailable: "\u65B0\u3057\u3044\u30D0\u30FC\u30B8\u30E7\u30F3\u304C\u5229\u7528\u3067\u304D\u307E\u3059",
    updateHint: "\u73FE\u5728: {{current}}\u3002\u6700\u65B0: {{latest}}\u3002\u90FD\u5408\u306E\u3088\u3044\u6642\u306B\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    incompatibleTitle: "\u3053\u306E\u30BF\u30D6\u306F\u53E4\u3044\u30D0\u30FC\u30B8\u30E7\u30F3\u3067\u3059",
    incompatibleHint: "\u73FE\u5728: {{current}}\u3002\u6700\u4F4E\u5BFE\u5FDC\u30D0\u30FC\u30B8\u30E7\u30F3: {{minimum}}\u3002\u5B89\u5168\u306B\u7D9A\u884C\u3059\u308B\u306B\u306F\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    refreshNow: "\u4ECA\u3059\u3050\u66F4\u65B0",
    later: "\u5F8C\u3067",
    inGameWarning: "\u30B2\u30FC\u30E0\u4E2D\u3067\u3059\u3002\u66F4\u65B0\u3059\u308B\u3068\u4E00\u6642\u7684\u306B\u5207\u65AD\u3055\u308C\u307E\u3059\u304C\u3001\u81EA\u52D5\u7684\u306B\u518D\u63A5\u7D9A\u3055\u308C\u307E\u3059\u3002",
    inGameProceed: "\u305D\u308C\u3067\u3082\u66F4\u65B0",
    inGameCancel: "\u30B2\u30FC\u30E0\u306B\u6B8B\u308B"
  },
  game: {
    title: "SheshDash \u30B2\u30FC\u30E0",
    gameId: "\u30B2\u30FC\u30E0ID",
    copyId: "ID\u3092\u30B3\u30D4\u30FC",
    idCopied: "\u30B2\u30FC\u30E0ID\u304C\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\uFF01",
    createGame: "\u65B0\u3057\u3044\u30B2\u30FC\u30E0\u3092\u4F5C\u6210",
    privateGame: "\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u30B2\u30FC\u30E0\uFF08\u30AA\u30F3\u30E9\u30A4\u30F3\u4E00\u89A7\u306B\u8868\u793A\u3057\u306A\u3044\uFF09",
    joinGame: "\u30B2\u30FC\u30E0\u306B\u53C2\u52A0",
    joinGameButton: "\u53C2\u52A0",
    startGame: "\u30B2\u30FC\u30E0\u958B\u59CB",
    back: "\u623B\u308B",
    yourName: "\u3042\u306A\u305F\u306E\u540D\u524D",
    gameIdPlaceholder: "\u30B2\u30FC\u30E0ID",
    connected: "\u63A5\u7D9A\u6E08\u307F",
    connecting: "\u63A5\u7D9A\u4E2D...",
    waitingForPlayers: "\u30D7\u30EC\u30A4\u30E4\u30FC\u5F85\u6A5F\u4E2D...",
    players: "\u30D7\u30EC\u30A4\u30E4\u30FC",
    shareGameId: "\u53CB\u9054\u3068\u30B2\u30FC\u30E0ID\u3092\u5171\u6709\u3057\u307E\u3057\u3087\u3046\uFF01",
    canStartWithPlayers: "2\u301C4\u4EBA\u3067\u30D7\u30EC\u30A4\u3067\u304D\u307E\u3059\u3002\u6E96\u5099\u304C\u3067\u304D\u305F\u3089\u300C\u30B2\u30FC\u30E0\u958B\u59CB\u300D\u3092\u30AF\u30EA\u30C3\u30AF\uFF01",
    needMorePlayers: "\u6700\u4F4E2\u4EBA\u306E\u30D7\u30EC\u30A4\u30E4\u30FC\u304C\u5FC5\u8981\u3067\u3059\u3002",
    botSuggestion: "\u30DC\u30C3\u30C8\u63D0\u6848\u307E\u3067",
    currentPlayers: "\u73FE\u5728\u306E\u30D7\u30EC\u30A4\u30E4\u30FC\uFF1A",
    yourTurn: "\u3042\u306A\u305F\u306E\u756A\uFF01",
    waiting: "\u5F85\u6A5F\u4E2D...",
    rolled: "\u51FA\u76EE",
    gameOver: "\u30B2\u30FC\u30E0\u7D42\u4E86\uFF01",
    winner: "\u52DD\u8005",
    exitGame: "\u30B2\u30FC\u30E0\u3092\u7D42\u4E86",
    turnTimer: "\u6B8B\u308A\u6642\u9593",
    results: "\u6700\u7D42\u9806\u4F4D",
    place: "\u9806\u4F4D",
    preferredColor: "\u5E0C\u671B\u306E\u8272",
    autoAssignColor: "\u81EA\u52D5",
    colorRed: "\u8D64",
    colorBlue: "\u9752",
    colorGreen: "\u7DD1",
    colorOrange: "\u30AA\u30EC\u30F3\u30B8",
    pause: "\u4E00\u6642\u505C\u6B62",
    resume: "\u518D\u958B",
    paused: "\u4E00\u6642\u505C\u6B62\u4E2D",
    pausedHint: "\u30B2\u30FC\u30E0\u306F\u4E00\u6642\u505C\u6B62\u4E2D\u3067\u3059\u3002\u7D9A\u3051\u308B\u306B\u306F\u300C\u518D\u958B\u300D\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    onlyCreatorCanStart: "\u30B2\u30FC\u30E0\u3092\u958B\u59CB\u3067\u304D\u308B\u306E\u306F\u4F5C\u6210\u8005\u3060\u3051\u3067\u3059\u3002"
  },
  kickVote: {
    confirm: "{{name}}\u3092\u30B2\u30FC\u30E0\u304B\u3089\u9664\u5916\u3057\u307E\u3059\u304B\uFF1F",
    title: "\u30D7\u30EC\u30A4\u30E4\u30FC\u3092\u9664\u5916\u3057\u307E\u3059\u304B\uFF1F",
    requestsToKick: "\u3092\u9664\u5916\u3057\u3088\u3046\u3068\u3057\u3066\u3044\u307E\u3059",
    targetBot: "\u5BFE\u8C61\uFF1A\u30DC\u30C3\u30C8",
    targetHuman: "\u5BFE\u8C61\uFF1A\u30D7\u30EC\u30A4\u30E4\u30FC",
    votes: "\u6295\u7968",
    approve: "\u627F\u8A8D",
    reject: "\u62D2\u5426",
    waiting: "\u4ED6\u306E\u6295\u7968\u3092\u5F85\u3063\u3066\u3044\u307E\u3059",
    readOnly: "\u6295\u7968\u4E2D",
    kickedTitle: "\u30B2\u30FC\u30E0\u304B\u3089\u9664\u5916\u3055\u308C\u307E\u3057\u305F",
    kickedNotice: "\u3042\u306A\u305F\u306E\u30B3\u30DE\u306F\u534A\u900F\u660E\u306B\u306A\u308A\u3001\u30B2\u30FC\u30E0\u9032\u884C\u3092\u59A8\u3052\u306A\u304F\u306A\u308A\u307E\u3057\u305F\u3002",
    returnToLobby: "\u30ED\u30D3\u30FC\u306B\u623B\u308B",
    observeGame: "\u30B2\u30FC\u30E0\u3092\u89B3\u6226"
  },
  actions: {
    yourActions: "\u3042\u306A\u305F\u306E\u30A2\u30AF\u30B7\u30E7\u30F3",
    rollDice: "\u30B5\u30A4\u30B3\u30ED\u3092\u632F\u3063\u3066\u30BF\u30FC\u30F3\u3092\u958B\u59CB\uFF01",
    needSix: "\u6700\u521D\u306E\u30B3\u30DE\u3092\u7F6E\u304F\u306B\u306F6\u3092\u51FA\u3059\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\uFF01",
    rolledSix: "6\u304C\u51FA\u307E\u3057\u305F\uFF01\u30DC\u30FC\u30CA\u30B9\u632F\u308A\u304C\u4FDD\u8A3C\u3055\u308C\u307E\u3059\uFF01",
    rolledSixOptions: [
      "\u65B0\u3057\u3044\u30B3\u30DE\u3092\u7F6E\u304F\uFF08\u5229\u7528\u53EF\u80FD\u306A\u5834\u5408\uFF09",
      "\u307E\u305F\u306F\u65E2\u5B58\u306E\u30B3\u30DE\u30926\u30DE\u30B9\u79FB\u52D5"
    ],
    rolledSixNote: "\u3069\u3061\u3089\u306E\u9078\u629E\u3067\u3082\u3082\u3046\u4E00\u5EA6\u632F\u308C\u307E\u3059\uFF01",
    selectPiece: "{{steps}}\u30DE\u30B9\u79FB\u52D5\u3059\u308B\u30B3\u30DE\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    selectedPiece: "\u9078\u629E\u3055\u308C\u305F\u30B3\u30DE\uFF1A{{state}}",
    placePiece: "\u30B3\u30DE\u3092\u7F6E\u304F",
    moveSteps: "{{steps}}\u30DE\u30B9\u79FB\u52D5",
    deselect: "\u9078\u629E\u89E3\u9664"
  },
  instructions: {
    title: "\u904A\u3073\u65B9\uFF1A",
    rules: [
      "\u99D2\u306F\u6700\u521D\u306F\u76E4\u5916\u306B\u3042\u308A\u30016\u3092\u51FA\u3059\u3068\u30B9\u30BF\u30FC\u30C8\u306E\u89D2\u30DE\u30B9\u306B\u7F6E\u3051\u307E\u3059\u3002",
      "\u6642\u8A08\u56DE\u308A\u306B\u30B3\u30DE\u3092\u79FB\u52D5",
      "1\u5468\u3057\u305F\u3089\u5BFE\u89D2\u7DDA\u3067\u4E2D\u5FC3\u3078",
      "4\u3064\u306E\u30B3\u30DE\u5168\u3066\u3092\u4E2D\u5FC3\u306B\u5165\u308C\u305F\u6700\u521D\u306E\u30D7\u30EC\u30A4\u30E4\u30FC\u304C\u52DD\u5229\uFF01"
    ]
  },
  gameMode: {
    title: "\u3069\u306E\u3088\u3046\u306B\u30D7\u30EC\u30A4\u3057\u307E\u3059\u304B\uFF1F",
    quickStart: "\u30AF\u30A4\u30C3\u30AF\u30B9\u30BF\u30FC\u30C8",
    quickStartDesc: "3\u4F53\u306E\u30DC\u30C3\u30C8\u3068\u5BFE\u6226\u3001\u3059\u3050\u306B\u958B\u59CB",
    withFriends: "\u30D5\u30EC\u30F3\u30C9\u3068",
    withFriendsDesc: "\u30B3\u30FC\u30C9\u3092\u5171\u6709\u3057\u3066\u53CB\u9054\u3092\u5F85\u3064",
    findPlayers: "\u30D7\u30EC\u30A4\u30E4\u30FC\u3092\u63A2\u3059",
    findPlayersDesc: "\u516C\u958B\u30ED\u30D3\u30FC\u3001\u8AB0\u3067\u3082\u53C2\u52A0\u53EF\u80FD"
  },
  bots: {
    addTitle: "\u30DC\u30C3\u30C8\u3092\u8FFD\u52A0\u3057\u307E\u3059\u304B\uFF1F",
    addDescription: "\u307E\u3060\u8AB0\u3082\u53C2\u52A0\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u30DC\u30C3\u30C8\u3092\u8FFD\u52A0\u3057\u3066\u30D7\u30EC\u30A4\u3092\u59CB\u3081\u307E\u3059\u304B\uFF1F",
    needMore: "\u3042\u3068{{count}}\u4EBA\u306E\u30D7\u30EC\u30A4\u30E4\u30FC\u304C\u5FC5\u8981\u3067\u3059\u3002",
    addButton: "{{count}}\u500B\u306E\u30DC\u30C3\u30C8\u3092\u8FFD\u52A0",
    addButtonPlural: "{{count}}\u500B\u306E\u30DC\u30C3\u30C8\u3092\u8FFD\u52A0",
    waitForPlayers: "\u30D7\u30EC\u30A4\u30E4\u30FC\u3092\u5F85\u3064"
  },
  turn: {
    currentTurn: "\u73FE\u5728\u306E\u30BF\u30FC\u30F3",
    you: "\u3042\u306A\u305F",
    skipped: "\u30BF\u30FC\u30F3\u3092\u30B9\u30AD\u30C3\u30D7",
    completed: "\u30BF\u30FC\u30F3\u5B8C\u4E86"
  },
  errors: {
    error: "\u30A8\u30E9\u30FC",
    pathBlocked: "\u30D1\u30B9\u304C\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u307E\u3059 - \u30B3\u30DE\u3092\u98DB\u3073\u8D8A\u3048\u3089\u308C\u307E\u305B\u3093",
    cannotLandOnOwnPiece: "\u81EA\u5206\u306E\u30B3\u30DE\u306B\u7740\u5730\u3067\u304D\u307E\u305B\u3093",
    pieceInCorner: "\u99D2\u306F\u4E88\u5099\u306B\u3042\u308A\u307E\u3059\u3002\u7F6E\u304F\u306B\u306F6\u304C\u5FC5\u8981\u3067\u3059",
    pieceAlreadyInCenter: "\u30B3\u30DE\u306F\u65E2\u306B\u4E2D\u5FC3\u306B\u3042\u308A\u307E\u3059",
    needToRoll6: "\u30B3\u30DE\u3092\u7F6E\u304F\u306B\u306F6\u3092\u51FA\u3059\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059",
    pieceNotInCorner: "\u99D2\u306F\u4E88\u5099\u306B\u3042\u308A\u307E\u305B\u3093",
    pieceNotFound: "\u30B3\u30DE\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093",
    notYourTurn: "\u3042\u306A\u305F\u306E\u756A\u3067\u306F\u3042\u308A\u307E\u305B\u3093",
    gameNotInProgress: "\u30B2\u30FC\u30E0\u304C\u9032\u884C\u4E2D\u3067\u306F\u3042\u308A\u307E\u305B\u3093",
    stepsMustMatchDice: "\u30DE\u30B9\u6570\u306F\u30B5\u30A4\u30B3\u30ED\u306E\u76EE\u3068\u4E00\u81F4\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059",
    needExactRollForCenter: "\u4E2D\u5FC3\u306B\u5165\u308B\u306B\u306F\u6B63\u78BA\u306A\u76EE\u304C\u5FC5\u8981\u3067\u3059",
    onlyCreatorCanStart: "\u30B2\u30FC\u30E0\u3092\u958B\u59CB\u3067\u304D\u308B\u306E\u306F\u4F5C\u6210\u8005\u3060\u3051\u3067\u3059",
    playerNameTaken: "\u305D\u306E\u30D7\u30EC\u30A4\u30E4\u30FC\u540D\u306F\u3053\u306E\u30B2\u30FC\u30E0\u3067\u3059\u3067\u306B\u4F7F\u308F\u308C\u3066\u3044\u307E\u3059"
  },
  pieceStates: {
    in_corner: "\u4E88\u5099",
    on_perimeter: "\u30DC\u30FC\u30C9\u4E0A",
    on_diagonal: "\u5BFE\u89D2\u7DDA\u4E0A",
    in_center: "\u4E2D\u5FC3"
  },
  playerInfo: {
    title: "\u30D7\u30EC\u30A4\u30E4\u30FC",
    you: "\uFF08\u3042\u306A\u305F\uFF09",
    turn: "\u30BF\u30FC\u30F3",
    corner: "\u4E88\u5099:",
    onBoard: "\u30DC\u30FC\u30C9\u4E0A\uFF1A",
    inCenter: "\u4E2D\u5FC3\uFF1A",
    waitingFor: "\u3042\u3068{{count}}\u4EBA\u306E\u30D7\u30EC\u30A4\u30E4\u30FC\u3092\u5F85\u3063\u3066\u3044\u307E\u3059...",
    statusRolled6: "\u30DC\u30FC\u30CA\u30B9\uFF01",
    statusCaptured: "\u6355\u7372\uFF01\u30DC\u30FC\u30CA\u30B9\uFF01",
    statusPlacedPiece: "\u914D\u7F6E\u6E08\u307F\u3001\u30DC\u30FC\u30CA\u30B9\uFF01",
    statusMovedOn6: "6\u30DE\u30B9\u79FB\u52D5\u3001\u30DC\u30FC\u30CA\u30B9\uFF01",
    statusTurnSkipped: "\u30B9\u30AD\u30C3\u30D7",
    statusTurnComplete: "\u30BF\u30FC\u30F3\u7D42\u4E86"
  },
  dice: {
    rollDice: "\u30B5\u30A4\u30B3\u30ED\u3092\u632F\u308B",
    rolled6Message: "6\u304C\u51FA\u307E\u3057\u305F\uFF01\u65B0\u3057\u3044\u30B3\u30DE\u3092\u7F6E\u304F\u304B\u3001\u65E2\u5B58\u306E\u30B3\u30DE\u30926\u30DE\u30B9\u79FB\u52D5\u3067\u304D\u307E\u3059\u3002",
    rolledBy: "\u632F\u3063\u305F\u4EBA",
    round: "\u30E9\u30A6\u30F3\u30C9",
    rolls: "\u632F\u308A",
    captureBonus: "\u30AD\u30E3\u30D7\u30C1\u30E3\u30DC\u30FC\u30CA\u30B9"
  },
  board: {
    currentPlayer: "\u73FE\u5728\u306E\u30D7\u30EC\u30A4\u30E4\u30FC",
    historyStart: "\u6700\u521D",
    historyPrev: "\u524D\u3078",
    historyNext: "\u6B21\u3078",
    historyEnd: "\u6700\u5F8C",
    historyViewingPast: "\u5C65\u6B74\u30E2\u30FC\u30C9: \u64CD\u4F5C\u306F\u7121\u52B9\u3067\u3059"
  },
  rules: {
    title: "\u30B2\u30FC\u30E0\u30EB\u30FC\u30EB",
    close: "\u9589\u3058\u308B",
    showRules: "\u30EB\u30FC\u30EB",
    objective: {
      title: "\u76EE\u7684",
      description: "\u30B9\u30BF\u30FC\u30C8\u30DE\u30B9\uFF08\u89D2\uFF09\u304B\u3089\u5468\u56DE\u3057\u3001\u5BFE\u89D2\u7DDA\u3092\u901A\u3063\u3066\u4E2D\u5FC3\u3078\u30014\u3064\u3059\u3079\u3066\u306E\u99D2\u3092\u6700\u521D\u306B\u904B\u3093\u3060\u30D7\u30EC\u30A4\u30E4\u30FC\u306E\u52DD\u3061\u3067\u3059\u3002"
    },
    setup: {
      title: "\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7",
      items: [
        "\u5404\u30D7\u30EC\u30A4\u30E4\u30FC\u306F\u76E4\u5916\uFF08\u4E88\u5099\uFF09\u306B4\u500B\u306E\u99D2\u304B\u3089\u958B\u59CB\u3057\u307E\u3059",
        "\u30D7\u30EC\u30A4\u30E4\u30FC\u306F\u6642\u8A08\u56DE\u308A\u306B\u30BF\u30FC\u30F3\u3092\u53D6\u308B",
        "6\u304C\u51FA\u308B\u307E\u3067\u5168\u3066\u306E\u30B3\u30DE\u306F\u30DC\u30FC\u30C9\u5916\u306B\u3042\u308B"
      ]
    },
    gameplay: {
      title: "\u30B2\u30FC\u30E0\u30D7\u30EC\u30A4",
      items: [
        "\u30B5\u30A4\u30B3\u30ED\u3092\u632F\u3063\u3066\u79FB\u52D5\u30DE\u30B9\u6570\u3092\u6C7A\u3081\u308B",
        "\u6700\u521D\u306E\u30B3\u30DE\u3092\u7F6E\u304F\u306B\u306F6\u3092\u51FA\u3059\u5FC5\u8981\u304C\u3042\u308B",
        "\u30B3\u30DE\u306F\u5916\u5468\u3092\u6642\u8A08\u56DE\u308A\u306B\u79FB\u52D5\u3059\u308B\uFF0828\u30DE\u30B9\uFF09",
        "1\u5468\u5B8C\u4E86\u5F8C\u3001\u5BFE\u89D2\u7DDA\u3067\u4E2D\u5FC3\u3078\u5165\u308B\uFF084\u30DE\u30B9\uFF09",
        "\u4E88\u5099\u306E\u99D2\u306F6\u304C\u51FA\u308B\u307E\u3067\u52D5\u304B\u305B\u307E\u305B\u3093"
      ]
    },
    rolling6: {
      title: "6\u3092\u51FA\u3059",
      description: "6\u3092\u51FA\u3057\u305F\u3089\u30012\u3064\u306E\u9078\u629E\u80A2\u304C\u3042\u308A\u307E\u3059\uFF1A",
      options: [
        "\u65B0\u3057\u3044\u99D2\u3092\u30B9\u30BF\u30FC\u30C8\u30DE\u30B9\uFF08\u89D2\uFF09\u306B\u7F6E\u304F",
        "\u65E2\u5B58\u306E\u30B3\u30DE\u30926\u30DE\u30B9\u524D\u9032\u3055\u305B\u308B"
      ],
      note: "\u3069\u3061\u3089\u306E\u9078\u629E\u3067\u3082\u30DC\u30FC\u30CA\u30B9\u632F\u308A\u304C\u3082\u3089\u3048\u307E\u3059\uFF016\u304C\u51FA\u7D9A\u3051\u308B\u9650\u308A\u632F\u308A\u7D9A\u3051\u3089\u308C\u307E\u3059\u3002"
    },
    capturing: {
      title: "\u6355\u7372",
      items: [
        "\u3042\u306A\u305F\u306E\u30B3\u30DE\u304C\u76F8\u624B\u306E\u30B3\u30DE\u306E\u30DE\u30B9\u306B\u6B63\u78BA\u306B\u7740\u5730\u3057\u305F\u3089\u3001\u305D\u308C\u3092\u6355\u7372\u3057\u307E\u3059",
        "\u53D6\u3089\u308C\u305F\u99D2\u306F\u76E4\u304B\u3089\u53D6\u308A\u9664\u304B\u308C\u3001\u76F8\u624B\u306E\u4E88\u5099\u306B\u623B\u308A\u307E\u3059",
        "\u98DB\u3073\u8D8A\u3048\u3066\u6355\u7372\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093 - \u6B63\u78BA\u306B\u305D\u306E\u30DE\u30B9\u306B\u7740\u5730\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059",
        "\u6355\u7372\u3059\u308B\u3068\u30DC\u30FC\u30CA\u30B9\u632F\u308A\u304C\u3082\u3089\u3048\u307E\u3059\uFF08\u8FFD\u52A0\u30BF\u30FC\u30F3\uFF09"
      ]
    },
    blocking: {
      title: "\u30D6\u30ED\u30C3\u30AF",
      description: "\u4ED6\u306E\u30B3\u30DE\u3092\u98DB\u3073\u8D8A\u3048\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\uFF01\u3069\u306E\u30B3\u30DE\uFF08\u81EA\u5206\u307E\u305F\u306F\u76F8\u624B\uFF09\u304C\u30D1\u30B9\u3092\u30D6\u30ED\u30C3\u30AF\u3057\u3066\u3044\u3066\u3082\u3001\u901A\u904E\u3067\u304D\u307E\u305B\u3093\u3002\u30D1\u30B9\u5168\u4F53\u304C\u7A7A\u3044\u3066\u3044\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"
    },
    winning: {
      title: "\u52DD\u5229",
      description: "4\u3064\u306E\u30B3\u30DE\u5168\u3066\u3092\u4E2D\u5FC3\u30A8\u30EA\u30A2\u306B\u6700\u521D\u306B\u79FB\u52D5\u3055\u305B\u305F\u30D7\u30EC\u30A4\u30E4\u30FC\u304C\u30B2\u30FC\u30E0\u306B\u52DD\u3061\u307E\u3059\uFF01"
    },
    bonusRolls: {
      title: "\u30DC\u30FC\u30CA\u30B9\u632F\u308A",
      items: [
        "6\u3092\u51FA\u3057\u305F\u3068\u304D\u30DC\u30FC\u30CA\u30B9\u632F\u308A\u304C\u3082\u3089\u3048\u308B\uFF08\u914D\u7F6E\u307E\u305F\u306F\u79FB\u52D5\u306B\u95A2\u308F\u3089\u305A\uFF09",
        "\u76F8\u624B\u306E\u30B3\u30DE\u3092\u6355\u7372\u3057\u305F\u3068\u304D\u30DC\u30FC\u30CA\u30B9\u632F\u308A\u304C\u3082\u3089\u3048\u308B",
        "\u30DC\u30FC\u30CA\u30B9\u632F\u308A\u306F\u91CD\u306A\u308B - \u3082\u3046\u4E00\u5EA66\u3092\u51FA\u3057\u305F\u308A\u3001\u3082\u3046\u4E00\u5EA6\u6355\u7372\u3057\u305F\u3089\u7D9A\u3051\u3089\u308C\u308B\uFF01"
      ]
    },
    timer: {
      title: "\u30BF\u30FC\u30F3\u30BF\u30A4\u30DE\u30FC",
      items: [
        "\u5404\u30D7\u30EC\u30A4\u30E4\u30FC\u306F\u30BF\u30FC\u30F3\u3092\u5B8C\u4E86\u3059\u308B\u305F\u3081\u306E\u5236\u9650\u6642\u9593\u304C\u3042\u308A\u307E\u3059",
        "\u6642\u9593\u5207\u308C\u306B\u306A\u308B\u3068\u3001\u30BF\u30FC\u30F3\u306F\u81EA\u52D5\u7684\u306B\u30B9\u30AD\u30C3\u30D7\u3055\u308C\u307E\u3059"
      ]
    }
  },
  hint: {
    button: "\u30D2\u30F3\u30C8",
    title: "\u63A8\u5968\u3055\u308C\u308B\u79FB\u52D5",
    noPieces: "\u5229\u7528\u53EF\u80FD\u306A\u30B3\u30DE\u304C\u3042\u308A\u307E\u305B\u3093",
    canPlace: "6\u304C\u51FA\u307E\u3057\u305F\uFF01\u30B9\u30BF\u30FC\u30C8\u30DE\u30B9\uFF08\u89D2\uFF09\u306B\u99D2\u3092\u7F6E\u3044\u3066\u304F\u3060\u3055\u3044",
    canMove: "{{position}}\u306E\u30B3\u30DE\u3092{{steps}}\u30DE\u30B9\u79FB\u52D5",
    close: "\u9589\u3058\u308B"
  },
  theme: {
    sheshdash: "\u30B7\u30A7\u30B7\u30E5\u30C0\u30B7\u30E5",
    toggle: "\u30C6\u30FC\u30DE\u3092\u5207\u308A\u66FF\u3048",
    system: "\u30B7\u30B9\u30C6\u30E0",
    light: "\u30E9\u30A4\u30C8",
    dark: "\u30C0\u30FC\u30AF"
  },
  tutorial: {
    button: "\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB",
    skip: "\u30B9\u30AD\u30C3\u30D7",
    prev: "\u623B\u308B",
    next: "\u6B21\u3078",
    finish: "\u5B8C\u4E86",
    welcome: {
      title: "SheshDash\u3078\u3088\u3046\u3053\u305D\uFF01",
      description: "\u3053\u306E\u7C21\u5358\u306A\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u3067\u904A\u3073\u65B9\u3092\u7D39\u4ECB\u3057\u307E\u3059\u3002\u76EE\u6A19\uFF1A\u30B9\u30BF\u30FC\u30C8\u30DE\u30B9\uFF08\u89D2\uFF09\u304B\u3089\u4E2D\u5FC3\u30784\u3064\u306E\u99D2\u3092\u6700\u521D\u306B\u904B\u3076\u3053\u3068\uFF01"
    },
    createGame: {
      title: "\u30B2\u30FC\u30E0\u3092\u4F5C\u6210",
      description: "\u3053\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u65B0\u3057\u3044\u30B2\u30FC\u30E0\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002\u53CB\u9054\u3068\u5171\u6709\u3067\u304D\u308B\u30E6\u30CB\u30FC\u30AF\u306AID\u304C\u767A\u884C\u3055\u308C\u307E\u3059\u3002"
    },
    addBots: {
      title: "\u30DC\u30C3\u30C8\u3092\u8FFD\u52A0",
      description: "\u30D7\u30EC\u30A4\u30E4\u30FC\u304C\u8DB3\u308A\u306A\u3044\u5834\u5408\u306F\u3001\u30DC\u30C3\u30C8\u3092\u8FFD\u52A0\u3067\u304D\u307E\u3059\u3002\u30B2\u30FC\u30E0\u3092\u958B\u59CB\u3059\u308B\u306B\u306F2\u301C4\u4EBA\u306E\u30D7\u30EC\u30A4\u30E4\u30FC\u304C\u5FC5\u8981\u3067\u3059\u3002"
    },
    startGame: {
      title: "\u30B2\u30FC\u30E0\u958B\u59CB",
      description: "\u3059\u3079\u3066\u306E\u30D7\u30EC\u30A4\u30E4\u30FC\u306E\u6E96\u5099\u304C\u3067\u304D\u305F\u3089\uFF08\u6700\u4F4E2\u4EBA\uFF09\u3001\u3053\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30B2\u30FC\u30E0\u3092\u958B\u59CB\u3057\u307E\u3057\u3087\u3046\uFF01"
    },
    diceButton: {
      title: "\u{1F3B2} \u30B5\u30A4\u30B3\u30ED\u3092\u632F\u308B",
      description: "\u3053\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30B5\u30A4\u30B3\u30ED\u3092\u632F\u308A\u307E\u3059\u3002\u6700\u521D\u306E\u30B3\u30DE\u3092\u7F6E\u304F\u306B\u306F6\u3092\u51FA\u3059\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\uFF01"
    },
    board: {
      title: "\u{1F3AE} \u30B2\u30FC\u30E0\u30DC\u30FC\u30C9",
      description: "\u3053\u308C\u306F8\xD78\u306E\u76E4\u3067\u3059\u3002\u99D2\u306F\u30B9\u30BF\u30FC\u30C8\u30DE\u30B9\uFF08\u89D2\uFF09\u304B\u3089\u5165\u308A\u3001\u6642\u8A08\u56DE\u308A\u306B\u5468\u56DE\u3057\u307E\u3059\u3002"
    },
    playerInfo: {
      title: "\u{1F4CA} \u30D7\u30EC\u30A4\u30E4\u30FC\u60C5\u5831",
      description: "\u3053\u3053\u3067\u5168\u3066\u306E\u30D7\u30EC\u30A4\u30E4\u30FC\u3001\u305D\u306E\u30B3\u30DE\u3001\u73FE\u5728\u306E\u30BF\u30FC\u30F3\u3092\u898B\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u8AB0\u304C\u30D7\u30EC\u30A4\u3057\u3066\u3044\u308B\u304B\u898B\u3066\u307F\u307E\u3057\u3087\u3046\uFF01"
    },
    selectPiece: {
      title: "\u{1F3AF} \u30B9\u30C6\u30C3\u30D71\uFF1A\u30B3\u30DE\u3092\u9078\u629E",
      description: "\u3053\u3053\u304C\u30B9\u30BF\u30FC\u30C8\u30DE\u30B9\uFF08\u89D2\uFF09\u3067\u3059\uFF016\u304C\u51FA\u305F\u3089\u99D2\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u76E4\u306B\u51FA\u3057\u307E\u3059\u3002"
    },
    placeButton: {
      title: "\u2705 \u30B9\u30C6\u30C3\u30D72\uFF1A\u914D\u7F6E\u30DC\u30BF\u30F3",
      description: "\u3053\u3053\u306B\u300C\u30B3\u30DE\u3092\u7F6E\u304F\u300D\u30DC\u30BF\u30F3\u304C\u9078\u629E\u5F8C\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u30B3\u30DE\u304C\u30B9\u30BF\u30FC\u30C8\u4F4D\u7F6E\u306B\u7F6E\u304B\u308C\u307E\u3059\uFF01\u30DC\u30FC\u30CA\u30B9\u632F\u308A\u304C\u3082\u3089\u3048\u307E\u3059\uFF01"
    },
    moveInstruction: {
      title: "\u{1F463} \u30B3\u30DE\u306E\u79FB\u52D5\u65B9\u6CD5",
      description: "\u632F\u3063\u305F\u5F8C\uFF1A\u2460 \u30DC\u30FC\u30C9\u4E0A\u306E\u3042\u306A\u305F\u306E\u30B3\u30DE\u3092\u30AF\u30EA\u30C3\u30AF \u2461 \u53F3\u5074\u306E\u300CX\u30DE\u30B9\u79FB\u52D5\u300D\u30DC\u30BF\u30F3\u3092\u62BC\u3059\u3002\u899A\u3048\u3066\u304A\u3044\u3066\u304F\u3060\u3055\u3044\uFF1A\u4ED6\u306E\u30B3\u30DE\u3092\u98DB\u3073\u8D8A\u3048\u3089\u308C\u307E\u305B\u3093\uFF01"
    },
    goal: {
      title: "\u{1F3C6} \u30B2\u30FC\u30E0\u306E\u76EE\u6A19 - \u4E2D\u5FC3\uFF01",
      description: "\u305D\u308C\u304C\u3053\u3053\u3067\u3059 - \u91D1\u8272\u306E\u30DE\u30B9\uFF08a8\u2192b7\u2192c6\u2192d5\uFF09\uFF014\u3064\u306E\u30B3\u30DE\u5168\u3066\u3092\u5BFE\u89D2\u7DDA\u3067\u3053\u3053\u306B\u6700\u521D\u306B\u79FB\u52D5\u3055\u305B\u3066\u52DD\u5229\uFF01\u30D1\u30B9\uFF1A\u5468\u308A\uFF0828\u30DE\u30B9\uFF09\u2192 \u5BFE\u89D2\u7DDA\u3067\u4E2D\u5FC3\u3078\uFF084\u30DE\u30B9\uFF09\u3002"
    }
  },
  common: {
    cancel: "\u30AD\u30E3\u30F3\u30BB\u30EB",
    back: "\u623B\u308B",
    confirm: "\u78BA\u8A8D",
    close: "\u9589\u3058\u308B"
  },
  joinVote: {
    title: "\u53C2\u52A0\u30EA\u30AF\u30A8\u30B9\u30C8",
    wantsToJoin: "\u304C\u30B2\u30FC\u30E0\u306B\u53C2\u52A0\u3057\u305F\u3044\u3067\u3059",
    willReplaceBot: "\u30DC\u30C3\u30C8\u3092\u7F6E\u304D\u63DB\u3048\u307E\u3059",
    keepPieces: "\u30DC\u30C3\u30C8\u306E\u30B3\u30DE\u3092\u7DAD\u6301",
    newPieces: "\u65B0\u3057\u3044\u30B3\u30DE\u3067\u958B\u59CB",
    votes: "\u6295\u7968",
    approve: "\u8CDB\u6210",
    reject: "\u53CD\u5BFE",
    total: "\u5408\u8A08",
    approveButton: "\u627F\u8A8D",
    rejectButton: "\u62D2\u5426",
    waiting: "\u4ED6\u306E\u30D7\u30EC\u30A4\u30E4\u30FC\u3092\u5F85\u3063\u3066\u3044\u307E\u3059..."
  },
  joinStarted: {
    title: "\u9032\u884C\u4E2D\u306E\u30B2\u30FC\u30E0\u306B\u53C2\u52A0",
    gameInProgress: "\u3053\u306E\u30B2\u30FC\u30E0\u306F\u3059\u3067\u306B\u9032\u884C\u4E2D\u3067\u3059\u3002",
    chooseOption: "\u53C2\u52A0\u65B9\u6CD5\u3092\u9078\u3093\u3067\u304F\u3060\u3055\u3044\uFF1A",
    replaceBot: "\u30DC\u30C3\u30C8\u3092\u7F6E\u304D\u63DB\u3048\u308B",
    replaceBotHint: "\u30DC\u30C3\u30C8\u306E\u4F4D\u7F6E\u3092\u5F15\u304D\u7D99\u3050",
    newPlayer: "\u65B0\u3057\u3044\u30D7\u30EC\u30A4\u30E4\u30FC\u3068\u3057\u3066\u53C2\u52A0",
    newPlayerHint: "\u65B0\u3057\u3044\u30B3\u30DE\u3067\u958B\u59CB",
    noOptions: "\u53C2\u52A0\u3067\u304D\u307E\u305B\u3093\uFF1A\u7F6E\u304D\u63DB\u3048\u308B\u30DC\u30C3\u30C8\u3082\u7A7A\u304D\u67A0\u3082\u3042\u308A\u307E\u305B\u3093\u3002",
    note: "\u6CE8\u610F",
    voteRequired: "\u53C2\u52A0\u306B\u306F\u5168\u30D7\u30EC\u30A4\u30E4\u30FC\u306E\u627F\u8A8D\u304C\u5FC5\u8981\u3067\u3059\u3002",
    replaceBotTitle: "\u30DC\u30C3\u30C8\u3092\u7F6E\u304D\u63DB\u3048\u308B",
    selectBot: "\u7F6E\u304D\u63DB\u3048\u308B\u30DC\u30C3\u30C8\u3092\u9078\u629E\uFF1A",
    selectBotPlaceholder: "-- \u30DC\u30C3\u30C8\u3092\u9078\u629E --",
    keepPieces: "\u30DC\u30C3\u30C8\u306E\u30B3\u30DE\u3068\u73FE\u5728\u4F4D\u7F6E\u3092\u5F15\u304D\u7D99\u3050",
    keepPiecesHint: "\u30DC\u30C3\u30C8\u306E\u73FE\u5728\u306E\u30B3\u30DE\u3068\u4F4D\u7F6E\u3092\u5F15\u304D\u7D99\u304E\u307E\u3059",
    resetPiecesHint: "\u30DC\u30C3\u30C8\u306E\u30B3\u30DE\u306F\u958B\u59CB\u4F4D\u7F6E\u306B\u623B\u3055\u308C\u307E\u3059",
    yourName: "\u3042\u306A\u305F\u306E\u540D\u524D",
    sendRequest: "\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u9001\u4FE1",
    newPlayerTitle: "\u65B0\u3057\u3044\u30D7\u30EC\u30A4\u30E4\u30FC\u3068\u3057\u3066\u53C2\u52A0",
    newPlayerInfo: "\u7A7A\u3044\u3066\u3044\u308B\u89D2\u3067\u65B0\u3057\u3044\u30B3\u30DE\u3092\u4F7F\u3063\u3066\u53C2\u52A0\u3057\u307E\u3059\u3002",
    currentPlayers: "\u73FE\u5728\u306E\u30D7\u30EC\u30A4\u30E4\u30FC",
    lateJoinWarning: "\u9014\u4E2D\u53C2\u52A0\u306E\u305F\u3081\u3001\u4ED6\u306E\u30D7\u30EC\u30A4\u30E4\u30FC\u304C\u5148\u884C\u3057\u3066\u3044\u307E\u3059\uFF01",
    waitingApproval: "\u627F\u8A8D\u5F85\u3061",
    waitingApprovalText: "\u30D7\u30EC\u30A4\u30E4\u30FC\u304C\u3042\u306A\u305F\u306E\u53C2\u52A0\u30EA\u30AF\u30A8\u30B9\u30C8\u306B\u6295\u7968\u3057\u3066\u3044\u307E\u3059\u3002"
  },
  userAgreement: {
    title: "\u5229\u7528\u898F\u7D04",
    close: "\u9589\u3058\u308B",
    acceptance: {
      title: "1. \u898F\u7D04\u306E\u627F\u8AFE",
      description: "SheshDash\u30B2\u30FC\u30E0\u3092\u4F7F\u7528\u3059\u308B\u3053\u3068\u306B\u3088\u308A\u3001\u672C\u5229\u7528\u898F\u7D04\u306E\u6761\u4EF6\u306B\u540C\u610F\u3057\u305F\u3082\u306E\u3068\u307F\u306A\u3055\u308C\u307E\u3059\u3002\u540C\u610F\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u30B2\u30FC\u30E0\u3092\u4F7F\u7528\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
    },
    gameRules: {
      title: "2. \u30B2\u30FC\u30E0\u30EB\u30FC\u30EB",
      description: "\u30D7\u30EC\u30A4\u30E4\u30FC\u306FSheshDash\u306E\u30EB\u30FC\u30EB\u306B\u5F93\u3046\u3053\u3068\u306B\u540C\u610F\u3057\u307E\u3059\u3002\u30DC\u30C3\u30C8\u306E\u4F7F\u7528\u306F\u3001\u30B2\u30FC\u30E0\u304C\u63D0\u4F9B\u3059\u308B\u6A5F\u80FD\u306E\u7BC4\u56F2\u5185\u3067\u306E\u307F\u8A31\u53EF\u3055\u308C\u307E\u3059\u3002\u4E0D\u6B63\u884C\u70BA\u3001\u30CF\u30C3\u30AF\u306E\u4F7F\u7528\u3001\u8106\u5F31\u6027\u306E\u60AA\u7528\u306F\u7981\u6B62\u3055\u308C\u3066\u3044\u307E\u3059\u3002"
    },
    intellectualProperty: {
      title: "3. \u77E5\u7684\u8CA1\u7523",
      description: "\u30B2\u30FC\u30E0SheshDash\u306E\u30B3\u30FC\u30C9\u3001\u30C7\u30B6\u30A4\u30F3\u3001\u30B0\u30E9\u30D5\u30A3\u30C3\u30AF\u3001\u30B5\u30FC\u30D0\u30FC\u30ED\u30B8\u30C3\u30AF\u3001\u30B2\u30FC\u30E0\u30E1\u30AB\u30CB\u30AF\u30B9\u3001\u30EB\u30FC\u30EB\u3092\u542B\u3080\u3059\u3079\u3066\u306E\u6A29\u5229\u306F\u4F5C\u8005Vadim Maltsev\u306B\u5E30\u5C5E\u3057\u307E\u3059\u3002\u30B2\u30FC\u30E0\u540D\u300CSheshDash\u300D\u306F\u6A29\u5229\u8005\u306B\u3088\u308A\u4FDD\u8B77\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306F\u30AA\u30FC\u30D7\u30F3\u30BD\u30FC\u30B9\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u4F5C\u8005\u306E\u66F8\u9762\u306B\u3088\u308B\u8A31\u53EF\u306A\u304F\u8907\u88FD\u3001\u914D\u5E03\u3001\u6539\u5909\u3059\u308B\u3053\u3068\u306F\u7981\u6B62\u3055\u308C\u3066\u3044\u307E\u3059\u3002"
    },
    userConduct: {
      title: "4. \u30E6\u30FC\u30B6\u30FC\u884C\u52D5",
      items: [
        "\u4ED6\u306E\u30D7\u30EC\u30A4\u30E4\u30FC\u3092\u5C0A\u91CD\u3057\u3001\u653B\u6483\u7684\u306A\u8A00\u8449\u3092\u4F7F\u7528\u3057\u306A\u3044",
        "\u30B2\u30FC\u30E0\u3092\u30CF\u30C3\u30AF\u3057\u305F\u308A\u59A8\u5BB3\u3057\u3088\u3046\u3068\u3057\u306A\u3044",
        "\u4E0D\u516C\u5E73\u306A\u5229\u76CA\u3092\u5F97\u308B\u305F\u3081\u306B\u8907\u6570\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u6210\u3057\u306A\u3044",
        "\u30D0\u30B0\u3084\u8106\u5F31\u6027\u3092\u8457\u8005\u306B\u5831\u544A\u3059\u308B"
      ]
    },
    disclaimer: {
      title: "5. \u514D\u8CAC\u4E8B\u9805",
      description: "\u30B2\u30FC\u30E0\u306F\u300C\u73FE\u72B6\u306E\u307E\u307E\u300D\u4FDD\u8A3C\u306A\u3057\u3067\u63D0\u4F9B\u3055\u308C\u307E\u3059\u3002\u8457\u8005\u306F\u3001\u30B2\u30FC\u30E0\u306E\u4F7F\u7528\u304B\u3089\u751F\u3058\u308B\u3044\u304B\u306A\u308B\u640D\u5931\u307E\u305F\u306F\u640D\u5BB3\u306B\u3064\u3044\u3066\u3082\u8CAC\u4EFB\u3092\u8CA0\u3044\u307E\u305B\u3093\u3002"
    },
    changes: {
      title: "6. \u898F\u7D04\u306E\u5909\u66F4",
      description: "\u8457\u8005\u306F\u3001\u3044\u3064\u3067\u3082\u672C\u898F\u7D04\u306E\u6761\u4EF6\u3092\u5909\u66F4\u3059\u308B\u6A29\u5229\u3092\u7559\u4FDD\u3057\u307E\u3059\u3002\u5909\u66F4\u5F8C\u306E\u7D99\u7D9A\u4F7F\u7528\u306F\u3001\u65B0\u3057\u3044\u6761\u4EF6\u3078\u306E\u540C\u610F\u3092\u610F\u5473\u3057\u307E\u3059\u3002"
    },
    copyright: "\xA9 2026 SheshDash. \u7121\u65AD\u8907\u88FD\u7981\u6B62\u3002",
    author: "\u958B\u767A\u8005\uFF1AVadim Maltsev",
    prohibited: {
      title: "\u7981\u6B62\u4E8B\u9805",
      items: [
        "\u30B2\u30FC\u30E0\u3092\u8907\u88FD\u30FB\u518D\u73FE\u30FB\u914D\u5E03\u3059\u308B\u3053\u3068",
        "\u30AF\u30ED\u30FC\u30F3\u3001\u6539\u5909\u3001\u6D3E\u751F\u7269\u3092\u4F5C\u6210\u3059\u308B\u3053\u3068",
        "\u30B2\u30FC\u30E0\u306E\u30B3\u30FC\u30C9\u3001\u30C7\u30B6\u30A4\u30F3\u3001\u30E1\u30AB\u30CB\u30AF\u30B9\u3001\u30EB\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3053\u3068",
        "\u30B2\u30FC\u30E0\u307E\u305F\u306F\u305D\u306E\u4E00\u90E8\u3092\u81EA\u5206\u306E\u540D\u524D\u3067\u904B\u55B6\u3059\u308B\u3053\u3068"
      ]
    },
    exclusiveRights: {
      title: "\u72EC\u5360\u7684\u6A29\u5229",
      description: "\u30B2\u30FC\u30E0\u306B\u95A2\u3059\u308B\u4E00\u5207\u306E\u72EC\u5360\u7684\u6A29\u5229\u306F\u6A29\u5229\u8005\u306B\u5E30\u5C5E\u3057\u307E\u3059\u3002"
    },
    legalInfo: {
      title: "\u6CD5\u7684\u60C5\u5831",
      description: "SheshDash \u306F\u30D7\u30ED\u30D7\u30E9\u30A4\u30A8\u30BF\u30EA\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3067\u3059\u3002\u6A29\u5229\u8005\u306E\u66F8\u9762\u306B\u3088\u308B\u540C\u610F\u306A\u3057\u306B\u8907\u88FD\u3001\u914D\u5E03\u3001\u6539\u5909\u3059\u308B\u3053\u3068\u306F\u7981\u6B62\u3055\u308C\u3066\u3044\u307E\u3059\u3002"
    }
  },
  navigation: {
    backToHome: "\u30DB\u30FC\u30E0\u306B\u623B\u308B"
  },
  donate: {
    title: "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u652F\u63F4\u3059\u308B",
    thankYou: "\u3054\u652F\u63F4\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01",
    description: "SheshDash \u306F\u30A4\u30F3\u30C7\u30A3\u30FC\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3067\u3059\u3002\u652F\u63F4\u306F\u30B5\u30FC\u30D0\u30FC\u7DAD\u6301\u3068\u65B0\u6A5F\u80FD\u958B\u767A\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002",
    waysToSupport: "\u4ED6\u306E\u652F\u63F4\u65B9\u6CD5",
    spreadWord: "\u5E83\u3081\u308B",
    spreadWordDesc: "SheshDash \u3092\u53CB\u4EBA\u3084\u5BB6\u65CF\u306B\u7D39\u4ECB\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    reportBugs: "\u30D0\u30B0\u5831\u544A",
    reportBugsDesc: "\u4E0D\u5177\u5408\u3092\u5831\u544A\u3057\u3066\u6539\u5584\u306B\u5354\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    suggestFeatures: "\u6A5F\u80FD\u63D0\u6848",
    suggestFeaturesDesc: "\u30A2\u30A4\u30C7\u30A2\u304C\u3042\u308A\u307E\u3059\u304B\uFF1F\u305C\u3072\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002",
    chooseCountry: "\u304A\u4F4F\u307E\u3044\u306E\u5730\u57DF",
    countryHelp: "\u5730\u57DF\u3054\u3068\u306E\u5408\u6CD5\u7684\u306A\u65B9\u6CD5\u3092\u8868\u793A\u3057\u307E\u3059\u3002\u5229\u7528\u4E0D\u53EF\u306E\u5834\u5408\u306F\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u304C\u6848\u5185\u3057\u307E\u3059\u3002",
    countryRussia: "\u30ED\u30B7\u30A2",
    countryInternational: "\u305D\u306E\u4ED6\u306E\u56FD",
    optionsTitle: "Boosty \u3067\u5BC4\u4ED8",
    platformBoostyTitle: "Boosty",
    platformBoostyDesc: "\u30E1\u30F3\u30D0\u30FC\u30B7\u30C3\u30D7\u3068\u5358\u767A\u652F\u63F4\u3002\u30ED\u30B7\u30A2\u306E\u30AB\u30FC\u30C9\u3078\u6255\u3044\u51FA\u3057\u3002",
    platformCloudtipsTitle: "CloudTips",
    platformCloudtipsDesc: "\u30AF\u30EA\u30A8\u30A4\u30BF\u30FC\u5411\u3051\u5BC4\u4ED8\u3068\u30B5\u30D6\u30B9\u30AF\u3002\u30ED\u30B7\u30A2\u306E\u30AB\u30FC\u30C9\u3078\u6255\u3044\u51FA\u3057\u3002",
    platformDonationAlertsTitle: "DonationAlerts",
    platformDonationAlertsDesc: "\u914D\u4FE1\u5411\u3051\u306E\u5BC4\u4ED8\u3002\u914D\u4FE1\u3059\u308B\u5834\u5408\u306B\u3002",
    platformPatreonTitle: "Patreon",
    platformPatreonDesc: "\u30E1\u30F3\u30D0\u30FC\u30B7\u30C3\u30D7\u3002\u56FD\u306B\u3088\u3063\u3066\u306F\u53D7\u53D6\u4E0D\u53EF\uFF08\u30ED\u30B7\u30A2\u542B\u3080\uFF09\u3002",
    platformBmacTitle: "Buy Me a Coffee",
    platformBmacDesc: "Stripe\u7D4C\u7531\u306E\u5358\u767A/\u5B9A\u671F\u652F\u63F4\u3002\u56FD\u306B\u3088\u308A\u5229\u7528\u53EF\u5426\u3042\u308A\u3002",
    platformKofiTitle: "Ko-fi",
    platformKofiDesc: "Stripe/PayPal \u7D4C\u7531\u3002\u56FD\u306B\u3088\u308A\u5229\u7528\u53EF\u5426\u3042\u308A\u3002",
    platformGithubTitle: "GitHub Sponsors",
    platformGithubDesc: "\u30AA\u30FC\u30D7\u30F3\u30BD\u30FC\u30B9\u3067\u3001\u5BFE\u5FDC\u5730\u57DF\u306E\u5834\u5408\u3002",
    statusSetup: "\u6E96\u5099\u4E2D",
    statusCheckCountry: "\u5229\u7528\u53EF\u5426\u3092\u78BA\u8A8D",
    statusStreaming: "\u914D\u4FE1\u8005\u5411\u3051",
    availabilityNote: "\u56FD\u3067\u5229\u7528\u3067\u304D\u306A\u3044\u5834\u5408\u3001\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306F\u5BC4\u4ED8\u3092\u53D7\u3051\u4ED8\u3051\u307E\u305B\u3093\u3002",
    boostyTitle: "Boosty",
    boostyDesc: "\u5358\u767A\u307E\u305F\u306F\u5B9A\u671F\u306E\u652F\u63F4\u3002\u6C7A\u6E08\u306F Boosty \u304C\u51E6\u7406\u3057\u307E\u3059\u3002",
    boostyButton: "Boosty \u3092\u958B\u304F",
    boostyQrAlt: "Boosty \u5BC4\u4ED8\u7528 QR \u30B3\u30FC\u30C9",
    boostyQrHint: "QR \u3092\u8AAD\u307F\u53D6\u3063\u3066 Boosty \u3092\u958B\u3044\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  account: {
    title: "\u30A2\u30AB\u30A6\u30F3\u30C8",
    loginTitle: "\u30ED\u30B0\u30A4\u30F3",
    loginDesc: "\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u7D71\u8A08\u60C5\u5831\u3084\u30B2\u30FC\u30E0\u5C65\u6B74\u3092\u78BA\u8A8D\u3057\u307E\u3057\u3087\u3046\u3002",
    loginGoogle: "Google \u3067\u30ED\u30B0\u30A4\u30F3",
    loginTelegram: "Telegram \u3067\u30ED\u30B0\u30A4\u30F3",
    playAsGuest: "\u30B2\u30B9\u30C8\u3068\u3057\u3066\u30D7\u30EC\u30A4",
    settings: "\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A",
    displayName: "\u8868\u793A\u540D",
    save: "\u4FDD\u5B58",
    saved: "\u4FDD\u5B58\u3057\u307E\u3057\u305F\uFF01",
    logout: "\u30ED\u30B0\u30A2\u30A6\u30C8",
    logoutConfirm: "\u672C\u5F53\u306B\u30ED\u30B0\u30A2\u30A6\u30C8\u3057\u307E\u3059\u304B\uFF1F",
    linkedAccounts: "\u9023\u643A\u6E08\u307F\u30A2\u30AB\u30A6\u30F3\u30C8",
    memberSince: "\u767B\u9332\u65E5",
    dangerZone: "\u5371\u967A\u30BE\u30FC\u30F3",
    deleteAccount: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664",
    preferredColor: "\u5E0C\u671B\u306E\u8272"
  },
  profile: {
    title: "\u30D7\u30EC\u30A4\u30E4\u30FC\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB",
    player: "\u30D7\u30EC\u30A4\u30E4\u30FC",
    gamesPlayed: "\u30D7\u30EC\u30A4\u3057\u305F\u30B2\u30FC\u30E0",
    wins: "\u52DD\u5229",
    winRate: "\u52DD\u7387",
    secondPlace: "2\u4F4D",
    thirdPlace: "3\u4F4D",
    fourthPlace: "4\u4F4D",
    matchHistory: "\u5BFE\u6226\u5C65\u6B74",
    noMatches: "\u307E\u3060\u5BFE\u6226\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    placement: "\u9806\u4F4D",
    date: "\u65E5\u4ED8",
    players: "\u30D7\u30EC\u30A4\u30E4\u30FC",
    loadMore: "\u3055\u3089\u306B\u8AAD\u307F\u8FBC\u3080"
  },
  leaderboard: {
    title: "\u30C8\u30C3\u30D7\u30D7\u30EC\u30A4\u30E4\u30FC",
    rank: "#",
    player: "\u30D7\u30EC\u30A4\u30E4\u30FC",
    wins: "\u52DD\u5229",
    games: "\u8A66\u5408",
    winRate: "\u52DD\u7387",
    noData: "\u307E\u3060\u8A66\u5408\u304C\u884C\u308F\u308C\u3066\u3044\u307E\u305B\u3093\u3002"
  },
  lobby: {
    onlinePlayers: "\u30AA\u30F3\u30E9\u30A4\u30F3\u30D7\u30EC\u30A4\u30E4\u30FC",
    waitingGames: "\u516C\u958B\u30B2\u30FC\u30E0",
    findMatch: "\u30AA\u30F3\u30E9\u30A4\u30F3\u5BFE\u6226\u3092\u63A2\u3059",
    cancelMatch: "\u691C\u7D22\u3092\u30AD\u30E3\u30F3\u30BB\u30EB",
    searching: "\u30D7\u30EC\u30A4\u30E4\u30FC\u3092\u691C\u7D22\u4E2D...",
    queueCount: "\u30AD\u30E5\u30FC\u5185\u30D7\u30EC\u30A4\u30E4\u30FC: {{count}} / 4",
    onlineCount: "\u30AA\u30F3\u30E9\u30A4\u30F3\u30D7\u30EC\u30A4\u30E4\u30FC: {{count}}",
    join: "\u53C2\u52A0",
    creator: "\u4F5C\u6210\u8005",
    noGames: "\u53C2\u52A0\u53EF\u80FD\u306A\u516C\u958B\u30B2\u30FC\u30E0\u304C\u3042\u308A\u307E\u305B\u3093",
    botsOfferTitle: "\u4ECA\u3059\u3050\u30DC\u30C3\u30C8\u3068\u958B\u59CB\u3057\u307E\u3059\u304B\uFF1F",
    botsOfferText: "{{count}}\u4EBA\u8DB3\u308A\u307E\u305B\u3093\u3002\u4ECA\u3059\u3050\u958B\u59CB\u3057\u3001\u6B8B\u308A\u3092\u30DC\u30C3\u30C8\u3067\u57CB\u3081\u307E\u3059\u3002",
    startWithBots: "\u30DC\u30C3\u30C8\u3067\u958B\u59CB",
    keepWaiting: "\u5F85\u6A5F\u3092\u7D9A\u3051\u308B"
  },
  skin: {
    human: "\u4EBA\u9593",
    guest: "\u30B2\u30B9\u30C8",
    gameStatus: "\u30B2\u30FC\u30E0\u72B6\u614B",
    gameInProgress: "\u30B2\u30FC\u30E0\u9032\u884C\u4E2D...",
    gameLog: "\u30B2\u30FC\u30E0\u30ED\u30B0",
    noEvents: "\u307E\u3060\u30A4\u30D9\u30F3\u30C8\u306F\u3042\u308A\u307E\u305B\u3093",
    waitingForEvents: "\u30B2\u30FC\u30E0\u30A4\u30D9\u30F3\u30C8\u3092\u5F85\u3063\u3066\u3044\u307E\u3059...",
    gamePaused: "\u30B2\u30FC\u30E0\u4E00\u6642\u505C\u6B62\u4E2D..."
  },
  admin: {
    title: "\u7BA1\u7406\u30D1\u30CD\u30EB",
    accessDenied: "\u7BA1\u7406\u8005\u306E\u307F\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002",
    goToAccount: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3078",
    loadError: "\u7BA1\u7406\u30C7\u30FC\u30BF\u306E\u8AAD\u307F\u8FBC\u307F\u306B\u5931\u6557\u3057\u307E\u3057\u305F",
    announcement: {
      title: "\u30B7\u30B9\u30C6\u30E0\u30E1\u30C3\u30BB\u30FC\u30B8",
      placeholder: '\u4F8B: "5\u5206\u5F8C\u306B\u30B2\u30FC\u30E0\u3092\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3057\u307E\u3059"',
      preview: "\u30D7\u30EC\u30D3\u30E5\u30FC",
      publishNow: "\u4ECA\u3059\u3050\u516C\u958B",
      startTime: "\u958B\u59CB\u6642\u523B",
      endTime: "\u7D42\u4E86\u6642\u523B\uFF08\u4EFB\u610F\uFF09",
      publish: "\u516C\u958B",
      publishing: "\u516C\u958B\u4E2D...",
      deactivate: "\u7121\u52B9\u5316",
      deactivateConfirm: "\u73FE\u5728\u306E\u304A\u77E5\u3089\u305B\u3092\u7121\u52B9\u306B\u3057\u307E\u3059\u304B\uFF1F",
      message: "\u30E1\u30C3\u30BB\u30FC\u30B8",
      status: "\u30B9\u30C6\u30FC\u30BF\u30B9",
      timeWindow: "\u671F\u9593",
      noEndTime: "\u7D42\u4E86\u306A\u3057",
      active: "\u6709\u52B9",
      inactive: "\u7121\u52B9"
    },
    users: {
      title: "\u30D7\u30EC\u30A4\u30E4\u30FC",
      player: "\u30D7\u30EC\u30A4\u30E4\u30FC",
      email: "\u30E1\u30FC\u30EB",
      role: "\u5F79\u5272",
      ban: "BAN",
      banned: "BAN\u6E08\u307F",
      active: "\u6709\u52B9"
    },
    markdown: {
      bold: "\u592A\u5B57",
      italic: "\u659C\u4F53",
      code: "\u30B3\u30FC\u30C9",
      link: "\u30EA\u30F3\u30AF",
      listItem: "\u9805\u76EE"
    },
    news: {
      title: "\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8\u306E\u304A\u77E5\u3089\u305B",
      versionLabel: "\u30D0\u30FC\u30B8\u30E7\u30F3",
      versionPlaceholder: "\u4F8B: 0.0.26",
      contentLabel: "\u5B9F\u88C5\u5185\u5BB9",
      contentPlaceholder: "\u3053\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u3067\u5B9F\u88C5\u3057\u305F\u5185\u5BB9\u3092\u8A18\u8FF0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      publishLabel: "\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8\u306B\u8868\u793A",
      preview: "\u30D7\u30EC\u30D3\u30E5\u30FC",
      create: "\u30CB\u30E5\u30FC\u30B9\u3092\u4F5C\u6210",
      update: "\u5909\u66F4\u3092\u4FDD\u5B58",
      saving: "\u4FDD\u5B58\u4E2D...",
      cancelEdit: "\u30AD\u30E3\u30F3\u30BB\u30EB",
      edit: "\u7DE8\u96C6",
      delete: "\u524A\u9664",
      deleteConfirm: "\u3053\u306E\u30CB\u30E5\u30FC\u30B9\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F",
      published: "\u516C\u958B",
      draft: "\u4E0B\u66F8\u304D",
      empty: "\u307E\u3060\u30CB\u30E5\u30FC\u30B9\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
      hideBlockLabel: "\u30CB\u30E5\u30FC\u30B9\u30D6\u30ED\u30C3\u30AF\u5168\u4F53\u3092\u975E\u8868\u793A",
      hideItemLabel: "\u3053\u306E\u30CB\u30E5\u30FC\u30B9\u3092\u975E\u8868\u793A",
      hidden: "\u975E\u8868\u793A",
      subtitle: "\u30CB\u30E5\u30FC\u30B9\u672C\u6587\u306F\u73FE\u5728\u3001\u30EA\u30DD\u30B8\u30C8\u30EA\u5185\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u7BA1\u7406\u3055\u308C\u305F\u30D5\u30A1\u30A4\u30EB\u304B\u3089\u8AAD\u307F\u8FBC\u307E\u308C\u307E\u3059\u3002",
      fileBasedHint: "\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8\u306E\u30CB\u30E5\u30FC\u30B9\u6587\u8A00\u3092\u5909\u66F4\u3059\u308B\u5834\u5408\u306F\u3001\u30EA\u30DD\u30B8\u30C8\u30EA\u5185\u306E\u5404\u8A00\u8A9E\u7528\u30CB\u30E5\u30FC\u30B9\u30D5\u30A1\u30A4\u30EB\u3092\u76F4\u63A5\u7DE8\u96C6\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    }
  },
  news: {
    title: "\u30B2\u30FC\u30E0\u30CB\u30E5\u30FC\u30B9",
    subtitle: "\u5404\u30D0\u30FC\u30B8\u30E7\u30F3\u3067\u5B9F\u88C5\u3055\u308C\u305F\u5185\u5BB9\u3067\u3059\u3002",
    empty: "\u307E\u3060\u30CB\u30E5\u30FC\u30B9\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
  },
  settings: {
    soundOn: "\u30B5\u30A6\u30F3\u30C9\u30AA\u30F3",
    soundOff: "\u30B5\u30A6\u30F3\u30C9\u30AA\u30D5"
  }
};

// src/i18n/locales/fr.json
var fr_default = {
  meta: {
    title: "SheshDash - Jeu de Plateau Multijoueur",
    description: "Un jeu de plateau multijoueur pour 4 joueurs. D\xE9placez vos pions sur le plateau et soyez le premier \xE0 atteindre le centre !",
    fullDescription: "SheshDash - Un jeu de plateau pour 2-4 joueurs. Lancez les d\xE9s, d\xE9placez vos pions sur le plateau et soyez le premier au centre pour gagner !"
  },
  landing: {
    playNow: "Jouer maintenant",
    learnRules: "Apprendre les r\xE8gles",
    termsOfService: "Conditions d'utilisation",
    supportProject: "Soutenir le projet",
    myAccount: "Mon compte",
    copyright: "\xA9 2026 SheshDash. D\xE9veloppeur : Vadim Maltsev"
  },
  versionBanner: {
    updateAvailable: "Une nouvelle version est disponible",
    updateHint: "Actuelle : {{current}}. Nouvelle : {{latest}}. Actualisez la page quand cela vous convient.",
    incompatibleTitle: "Cet onglet est obsol\xE8te",
    incompatibleHint: "Actuelle : {{current}}. Version minimale prise en charge : {{minimum}}. Actualisez la page pour continuer en toute s\xE9curit\xE9.",
    refreshNow: "Actualiser",
    later: "Plus tard",
    inGameWarning: "Vous \xEAtes dans une partie active. La mise \xE0 jour vous d\xE9connectera temporairement \u2014 vous devriez vous reconnecter automatiquement.",
    inGameProceed: "Mettre \xE0 jour quand m\xEAme",
    inGameCancel: "Rester dans la partie"
  },
  game: {
    title: "Jeu SheshDash",
    gameId: "ID du Jeu",
    copyId: "Copier l'ID",
    idCopied: "ID du jeu copi\xE9 dans le presse-papiers !",
    createGame: "Cr\xE9er une Nouvelle Partie",
    privateGame: "Partie priv\xE9e (masquer de la liste en ligne)",
    joinGame: "Rejoindre une Partie",
    joinGameButton: "Rejoindre",
    startGame: "D\xE9marrer la Partie",
    back: "Retour",
    yourName: "Votre nom",
    gameIdPlaceholder: "ID du Jeu",
    connected: "Connect\xE9",
    connecting: "Connexion...",
    waitingForPlayers: "En Attente de Joueurs...",
    players: "joueurs",
    shareGameId: "Partagez l'ID avec vos amis !",
    canStartWithPlayers: "Vous pouvez commencer avec 2-4 joueurs. Cliquez sur 'D\xE9marrer' quand vous \xEAtes pr\xEAt !",
    needMorePlayers: "Au moins 2 joueurs requis.",
    botSuggestion: "Suggestion de bot dans",
    currentPlayers: "Joueurs Actuels :",
    yourTurn: "Votre Tour !",
    waiting: "En attente...",
    rolled: "D\xE9 lanc\xE9",
    gameOver: "Partie Termin\xE9e !",
    winner: "Gagnant",
    exitGame: "Quitter le jeu",
    turnTimer: "Temps restant",
    results: "Classement final",
    place: "Classement",
    preferredColor: "Couleur pr\xE9f\xE9r\xE9e",
    autoAssignColor: "Attribution automatique",
    colorRed: "Rouge",
    colorBlue: "Bleu",
    colorGreen: "Vert",
    colorOrange: "Orangee",
    pause: "Mettre en pause",
    resume: "Reprendre",
    paused: "En pause",
    pausedHint: "La partie est en pause. Appuie sur \xAB Reprendre \xBB pour continuer.",
    onlyCreatorCanStart: "Seul le cr\xE9ateur peut d\xE9marrer la partie."
  },
  kickVote: {
    confirm: "Retirer {{name}} de la partie ?",
    title: "Retirer le joueur ?",
    requestsToKick: "veut retirer",
    targetBot: "Cible : bot",
    targetHuman: "Cible : joueur",
    votes: "Voix",
    approve: "Approuver",
    reject: "Refuser",
    waiting: "En attente des autres votes",
    readOnly: "Vote en cours",
    kickedTitle: "Vous avez \xE9t\xE9 retir\xE9 de la partie",
    kickedNotice: "Vos pions sont maintenant transparents et ne bloquent plus la partie.",
    returnToLobby: "Retour au lobby",
    observeGame: "Observer la partie"
  },
  actions: {
    yourActions: "Vos Actions",
    rollDice: "Lancez le d\xE9 pour commencer votre tour !",
    needSix: "Vous devez obtenir un 6 pour placer votre premier pion !",
    rolledSix: "Vous avez obtenu un 6 ! Lancer bonus garanti !",
    rolledSixOptions: [
      "Placer un nouveau pion (si disponible)",
      "OU d\xE9placer un pion existant de 6 cases"
    ],
    rolledSixNote: "Les deux choix vous donnent un autre lancer !",
    selectPiece: "S\xE9lectionnez un pion pour le d\xE9placer de {{steps}} cases.",
    selectedPiece: "Pion S\xE9lectionn\xE9 : {{state}}",
    placePiece: "Placer le Pion",
    moveSteps: "D\xE9placer de {{steps}} cases",
    deselect: "D\xE9s\xE9lectionner"
  },
  instructions: {
    title: "Comment Jouer :",
    rules: [
      "Les pions commencent hors du plateau ; faites un 6 pour en placer un sur la case de d\xE9part (coin).",
      "D\xE9placez les pions dans le sens horaire",
      "Apr\xE8s un tour complet, d\xE9placez en diagonale vers le centre",
      "Le premier joueur \xE0 placer tous ses 4 pions au centre gagne !"
    ]
  },
  gameMode: {
    title: "Comment veux-tu jouer ?",
    quickStart: "D\xE9marrage rapide",
    quickStartDesc: "contre 3 bots, d\xE9marre imm\xE9diatement",
    withFriends: "Avec des amis",
    withFriendsDesc: "partager un code, attendre des amis",
    findPlayers: "Trouver des joueurs",
    findPlayersDesc: "lobby public, tout le monde peut rejoindre"
  },
  bots: {
    addTitle: "Ajouter des Bots ?",
    addDescription: "Personne d'autre n'a rejoint. Voulez-vous ajouter des bots pour commencer ?",
    needMore: "Vous avez besoin de {{count}} joueur(s) de plus.",
    addButton: "Ajouter {{count}} Bot",
    addButtonPlural: "Ajouter {{count}} Bots",
    waitForPlayers: "Attendre les Joueurs"
  },
  turn: {
    currentTurn: "Tour Actuel",
    you: "Le tien",
    skipped: "Tour pass\xE9",
    completed: "Tour termin\xE9"
  },
  errors: {
    error: "Erreur",
    pathBlocked: "Chemin bloqu\xE9 - impossible de sauter par-dessus les pions",
    cannotLandOnOwnPiece: "Impossible d'atterrir sur votre propre pion",
    pieceInCorner: "Le pion est en r\xE9serve, vous devez faire un 6 pour le placer",
    pieceAlreadyInCenter: "Pion d\xE9j\xE0 au centre",
    needToRoll6: "Obtenez un 6 pour placer le pion",
    pieceNotInCorner: "Le pion n\u2019est pas en r\xE9serve",
    pieceNotFound: "Pion non trouv\xE9",
    notYourTurn: "Pas votre tour",
    gameNotInProgress: "Partie non en cours",
    stepsMustMatchDice: "Les cases doivent correspondre au d\xE9",
    needExactRollForCenter: "Lancer exact requis pour entrer au centre",
    onlyCreatorCanStart: "Seul le cr\xE9ateur de la partie peut la d\xE9marrer",
    playerNameTaken: "Ce nom de joueur est d\xE9j\xE0 utilis\xE9 dans cette partie"
  },
  pieceStates: {
    in_corner: "En r\xE9serve",
    on_perimeter: "Sur le Plateau",
    on_diagonal: "Sur la Diagonale",
    in_center: "Au Centre"
  },
  playerInfo: {
    title: "Joueurs",
    you: "(Vous)",
    turn: "Tour",
    corner: "En r\xE9serve :",
    onBoard: "Sur le Plateau :",
    inCenter: "Au Centre :",
    waitingFor: "En attente de {{count}} joueur(s)...",
    statusRolled6: "Bonus !",
    statusCaptured: "Captur\xE9 ! Bonus !",
    statusPlacedPiece: "Plac\xE9, Bonus !",
    statusMovedOn6: "D\xE9plac\xE9 6, Bonus !",
    statusTurnSkipped: "Saut\xE9",
    statusTurnComplete: "Tour termin\xE9"
  },
  dice: {
    rollDice: "Lancer le D\xE9",
    rolled6Message: "Vous avez obtenu un 6 ! Vous pouvez placer un nouveau pion OU d\xE9placer un pion existant de 6 cases.",
    rolledBy: "Lanc\xE9 par",
    round: "Manche",
    rolls: "Lancers",
    captureBonus: "Bonus de capture"
  },
  board: {
    currentPlayer: "Joueur Actuel",
    historyStart: "Premier",
    historyPrev: "Pr\xE9c\xE9dent",
    historyNext: "Suivant",
    historyEnd: "Dernier",
    historyViewingPast: "Mode historique : les actions sont d\xE9sactiv\xE9es"
  },
  rules: {
    title: "R\xE8gles du Jeu",
    close: "Fermer",
    showRules: "R\xE8gles",
    objective: {
      title: "Objectif",
      description: "Soyez le premier \xE0 d\xE9placer vos 4 pions depuis la case de d\xE9part (coin), autour du p\xE9rim\xE8tre, sur la diagonale et jusqu\u2019au centre."
    },
    setup: {
      title: "Configuration",
      items: [
        "Chaque joueur commence avec 4 pions hors du plateau (en r\xE9serve)",
        "Les joueurs jouent dans le sens horaire",
        "Tous les pions commencent hors du plateau jusqu'\xE0 obtenir un 6"
      ]
    },
    gameplay: {
      title: "D\xE9roulement",
      items: [
        "Lancez le d\xE9 pour d\xE9terminer le nombre de cases",
        "Pour placer votre premier pion, vous devez obtenir un 6",
        "Les pions se d\xE9placent dans le sens horaire (28 positions)",
        "Apr\xE8s un tour complet, entrez en diagonale vers le centre (4 cases)",
        "Vous ne pouvez pas d\xE9placer les pions en r\xE9serve tant que vous n\u2019avez pas fait un 6"
      ]
    },
    rolling6: {
      title: "Obtenir un 6",
      description: "Quand vous obtenez un 6, vous avez deux options :",
      options: [
        "Placer un nouveau pion sur la case de d\xE9part (coin)",
        "D\xE9placer un pion existant de 6 cases en avant"
      ],
      note: "Les deux choix donnent un lancer bonus ! Vous pouvez continuer tant que vous obtenez des 6."
    },
    capturing: {
      title: "Capture",
      items: [
        "Si votre pion atterrit EXACTEMENT sur un pion adverse, vous le capturez",
        "Le pion captur\xE9 est retir\xE9 du plateau et retourne dans la r\xE9serve de l\u2019adversaire",
        "Vous ne pouvez pas capturer en sautant - vous devez atterrir exactement sur la position",
        "Capturer donne un lancer bonus (tour suppl\xE9mentaire)"
      ]
    },
    blocking: {
      title: "Blocage",
      description: "Vous NE POUVEZ PAS sauter par-dessus d'autres pions ! Si un pion (le v\xF4tre ou celui d'un adversaire) bloque votre chemin, vous ne pouvez pas passer. Tout le chemin doit \xEAtre libre."
    },
    winning: {
      title: "Victoire",
      description: "Le premier joueur \xE0 d\xE9placer tous ses 4 pions au centre gagne la partie !"
    },
    bonusRolls: {
      title: "Lancers Bonus",
      items: [
        "Lancer bonus en obtenant un 6 (que vous placiez ou d\xE9placiez)",
        "Lancer bonus en capturant un pion adverse",
        "Les lancers bonus s'accumulent - si vous obtenez un autre 6 ou capturez \xE0 nouveau, continuez !"
      ]
    },
    timer: {
      title: "Minuteur de tour",
      items: [
        "Chaque joueur a un temps limit\xE9 pour compl\xE9ter son tour",
        "Si le temps est \xE9coul\xE9, le tour est automatiquement pass\xE9"
      ]
    }
  },
  hint: {
    button: "Indice",
    title: "Mouvement Sugg\xE9r\xE9",
    noPieces: "Aucun pion disponible",
    canPlace: "Vous avez fait un 6 ! Placez un pion sur la case de d\xE9part (coin)",
    canMove: "D\xE9placez le pion de {{position}} de {{steps}} cases",
    close: "Fermer"
  },
  theme: {
    sheshdash: "SheshDash",
    toggle: "Changer de th\xE8me",
    system: "Syst\xE8me",
    light: "Clair",
    dark: "Sombre"
  },
  tutorial: {
    button: "Tutoriel",
    skip: "Passer",
    prev: "Pr\xE9c\xE9dent",
    next: "Suivant",
    finish: "Terminer",
    welcome: {
      title: "Bienvenue dans SheshDash !",
      description: "Ce tutoriel rapide vous montrera comment jouer. Objectif : d\xE9placer vos 4 pions depuis la case de d\xE9part (coin) jusqu\u2019au centre."
    },
    createGame: {
      title: "Cr\xE9er une partie",
      description: "Cliquez sur ce bouton pour cr\xE9er une nouvelle partie. Vous obtiendrez un ID unique \xE0 partager avec vos amis."
    },
    addBots: {
      title: "Ajouter des bots",
      description: "Si vous n'avez pas assez de joueurs, vous pouvez ajouter des bots. Le jeu n\xE9cessite 2-4 joueurs pour commencer."
    },
    startGame: {
      title: "D\xE9marrer la partie",
      description: "Quand tous les joueurs sont pr\xEAts (minimum 2), cliquez sur ce bouton pour d\xE9marrer la partie !"
    },
    diceButton: {
      title: "\u{1F3B2} Lancer le D\xE9",
      description: "Cliquez sur ce bouton pour lancer le d\xE9. Vous devez obtenir un 6 pour placer votre premier pion !"
    },
    board: {
      title: "\u{1F3AE} Plateau de Jeu",
      description: "Voici le plateau 8\xD78. Les pions entrent par la case de d\xE9part (coin) puis avancent dans le sens horaire le long du p\xE9rim\xE8tre."
    },
    playerInfo: {
      title: "\u{1F4CA} Informations des Joueurs",
      description: "Ici vous pouvez voir tous les joueurs, leurs pions et le tour actuel. Regardez qui joue !"
    },
    selectPiece: {
      title: "\u{1F3AF} \xC9tape 1 : S\xE9lectionner un Pion",
      description: "ICI se trouve la case de d\xE9part (coin) ! Quand vous faites un 6, cliquez sur un pion pour le mettre sur le plateau."
    },
    placeButton: {
      title: "\u2705 \xC9tape 2 : Bouton Placer",
      description: 'ICI appara\xEEtra un bouton "Placer le Pion" apr\xE8s s\xE9lection. Cliquez dessus et le pion sera plac\xE9 sur la position de d\xE9part ! Vous obtiendrez un lancer bonus !'
    },
    moveInstruction: {
      title: "\u{1F463} Comment D\xE9placer un Pion",
      description: `Apr\xE8s avoir lanc\xE9 : \u2460 Cliquez sur votre pion sur le plateau \u2461 Appuyez sur le bouton "D\xE9placer de X cases" \xE0 droite. Rappelez-vous : vous ne pouvez pas sauter par-dessus d'autres pions !`
    },
    goal: {
      title: "\u{1F3C6} Objectif du Jeu - CENTRE !",
      description: "LES VOIL\xC0 - les cases dor\xE9es (a8\u2192b7\u2192c6\u2192d5) ! Soyez le premier \xE0 d\xE9placer tous vos 4 pions ici en diagonale et GAGNEZ ! Chemin : p\xE9rim\xE8tre (28 cases) \u2192 diagonale vers le centre (4 cases)."
    }
  },
  common: {
    cancel: "Annuler",
    back: "Retour",
    confirm: "Confirmer",
    close: "Fermer"
  },
  joinVote: {
    title: "Demande d'adh\xE9sion",
    wantsToJoin: "veut rejoindre la partie",
    willReplaceBot: "Remplacera un bot",
    keepPieces: "Gardera les pions du bot",
    newPieces: "Commencera avec de nouveaux pions",
    votes: "Votes",
    approve: "pour",
    reject: "contre",
    total: "total",
    approveButton: "Approuver",
    rejectButton: "Rejeter",
    waiting: "En attente des autres joueurs..."
  },
  joinStarted: {
    title: "Rejoindre une partie en cours",
    gameInProgress: "Cette partie est d\xE9j\xE0 en cours.",
    chooseOption: "Choisissez comment rejoindre :",
    replaceBot: "Remplacer un bot",
    replaceBotHint: "Prendre la position d\u2019un bot",
    newPlayer: "Rejoindre comme nouveau joueur",
    newPlayerHint: "Commencer avec de nouveaux pions",
    noOptions: "Impossible de rejoindre : aucun bot \xE0 remplacer et aucune place libre.",
    note: "Note",
    voteRequired: "Tous les joueurs doivent approuver votre demande.",
    replaceBotTitle: "Remplacer un bot",
    selectBot: "S\xE9lectionnez le bot \xE0 remplacer :",
    selectBotPlaceholder: "-- S\xE9lectionnez un bot --",
    keepPieces: "Garder les pions du bot et sa position",
    keepPiecesHint: "Vous reprendrez les pions et la position actuels du bot",
    resetPiecesHint: "Les pions du bot seront remis dans le coin de d\xE9part",
    yourName: "Votre nom",
    sendRequest: "Envoyer la demande",
    newPlayerTitle: "Rejoindre comme nouveau joueur",
    newPlayerInfo: "Vous rejoindrez avec de nouveaux pions dans un coin disponible.",
    currentPlayers: "Joueurs actuels",
    lateJoinWarning: "Vous rejoignez tard ; les autres joueurs ont d\xE9j\xE0 de l\u2019avance !",
    waitingApproval: "En attente d\u2019approbation",
    waitingApprovalText: "Les joueurs votent sur votre demande de rejoindre."
  },
  userAgreement: {
    title: "Accord d'Utilisation",
    close: "Fermer",
    acceptance: {
      title: "1. Acceptation des Conditions",
      description: "En utilisant le jeu SheshDash, vous acceptez les conditions de cet Accord d'Utilisation. Si vous n'\xEAtes pas d'accord, veuillez ne pas utiliser le jeu."
    },
    gameRules: {
      title: "2. R\xE8gles du Jeu",
      description: "Les joueurs acceptent de suivre les r\xE8gles de SheshDash. L'utilisation de bots n'est autoris\xE9e que dans le cadre de la fonctionnalit\xE9 fournie par le jeu. Toute tentative de triche, utilisation de hacks ou exploitation de vuln\xE9rabilit\xE9s est interdite."
    },
    intellectualProperty: {
      title: "3. Propri\xE9t\xE9 Intellectuelle",
      description: "Tous les droits sur le jeu SheshDash, y compris le code, le design, les graphismes, la logique serveur, la m\xE9canique et les r\xE8gles du jeu, appartiennent \xE0 l\u2019auteur Vadim Maltsev. Le nom du jeu \xAB SheshDash \xBB est r\xE9serv\xE9 au titulaire des droits. Le projet n\u2019est pas open source. Toute copie, distribution ou modification sans l\u2019autorisation \xE9crite de l\u2019auteur est interdite."
    },
    userConduct: {
      title: "4. Conduite de l'Utilisateur",
      items: [
        "Respectez les autres joueurs et n'utilisez pas de langage offensant",
        "Ne tentez pas de pirater ou perturber le jeu",
        "Ne cr\xE9ez pas plusieurs comptes pour obtenir des avantages injustes",
        "Signalez les bugs et vuln\xE9rabilit\xE9s \xE0 l'auteur"
      ]
    },
    disclaimer: {
      title: "5. Clause de Non-Responsabilit\xE9",
      description: `Le jeu est fourni "tel quel" sans garanties. L'auteur n'est pas responsable des pertes ou dommages r\xE9sultant de l'utilisation du jeu.`
    },
    changes: {
      title: "6. Modifications de l'Accord",
      description: "L'auteur se r\xE9serve le droit de modifier les conditions de cet accord \xE0 tout moment. L'utilisation continue apr\xE8s les modifications constitue votre acceptation des nouvelles conditions."
    },
    copyright: "\xA9 2026 SheshDash. Tous droits r\xE9serv\xE9s.",
    author: "D\xE9veloppeur : Vadim Maltsev",
    prohibited: {
      title: "Actions interdites",
      items: [
        "copier, reproduire ou diffuser le jeu",
        "cr\xE9er des clones, des modifications ou des produits d\xE9riv\xE9s",
        "utiliser le code, le design, la m\xE9canique ou les r\xE8gles du jeu",
        "exploiter le jeu ou une partie du jeu sous votre propre nom"
      ]
    },
    exclusiveRights: {
      title: "Droits exclusifs",
      description: "Tous les droits exclusifs sur le jeu appartiennent au titulaire des droits."
    },
    legalInfo: {
      title: "Informations juridiques",
      description: "SheshDash est un logiciel propri\xE9taire. Toute copie, diffusion ou modification est interdite sans l\u2019accord \xE9crit du titulaire des droits."
    }
  },
  navigation: {
    backToHome: "Retour \xE0 l'accueil"
  },
  donate: {
    title: "Soutenir le projet",
    thankYou: "Merci pour votre soutien !",
    description: "SheshDash est un projet ind\xE9pendant. Votre soutien aide \xE0 payer les serveurs et \xE0 d\xE9velopper de nouvelles fonctionnalit\xE9s.",
    waysToSupport: "Autres fa\xE7ons d\u2019aider",
    spreadWord: "En parler",
    spreadWordDesc: "Partagez SheshDash avec vos amis et votre famille.",
    reportBugs: "Signaler des bugs",
    reportBugsDesc: "Aidez \xE0 am\xE9liorer le jeu en signalant les probl\xE8mes.",
    suggestFeatures: "Sugg\xE9rer des id\xE9es",
    suggestFeaturesDesc: "Une id\xE9e ? Dites-nous ce que vous aimeriez voir.",
    chooseCountry: "O\xF9 \xEAtes-vous ?",
    countryHelp: "Nous affichons des options l\xE9gales par r\xE9gion. Si quelque chose n\u2019est pas disponible dans votre pays, la plateforme vous le dira.",
    countryRussia: "Russie",
    countryInternational: "Autres pays",
    optionsTitle: "Donner via Boosty",
    platformBoostyTitle: "Boosty",
    platformBoostyDesc: "Abonnements et dons ponctuels ; versements sur cartes en Russie.",
    platformCloudtipsTitle: "CloudTips",
    platformCloudtipsDesc: "Dons et abonnements pour cr\xE9ateurs ; versements sur cartes en Russie.",
    platformDonationAlertsTitle: "DonationAlerts",
    platformDonationAlertsDesc: "Dons pour les streams ; utilisez si vous streamez.",
    platformPatreonTitle: "Patreon",
    platformPatreonDesc: "Abonnements pour cr\xE9ateurs. Versements indisponibles dans certains pays (dont la Russie).",
    platformBmacTitle: "Buy Me a Coffee",
    platformBmacDesc: "Soutien ponctuel et r\xE9current via Stripe ; disponibilit\xE9 selon pays.",
    platformKofiTitle: "Ko-fi",
    platformKofiDesc: "Soutien via Stripe/PayPal ; disponibilit\xE9 selon pays.",
    platformGithubTitle: "GitHub Sponsors",
    platformGithubDesc: "Si le projet est open source et que vous \xEAtes dans une r\xE9gion prise en charge.",
    statusSetup: "En pr\xE9paration",
    statusCheckCountry: "V\xE9rifier la disponibilit\xE9",
    statusStreaming: "Uniquement pour les streams",
    availabilityNote: "Si une plateforme n\u2019est pas disponible dans votre pays, elle ne permettra pas les dons.",
    boostyTitle: "Boosty",
    boostyDesc: "Soutien ponctuel ou r\xE9current. Les paiements sont trait\xE9s par Boosty.",
    boostyButton: "Ouvrir Boosty",
    boostyQrAlt: "QR code de don Boosty",
    boostyQrHint: "Scannez le QR pour ouvrir Boosty."
  },
  account: {
    title: "Compte",
    loginTitle: "Connexion",
    loginDesc: "Connectez-vous pour suivre vos statistiques et votre historique de parties.",
    loginGoogle: "Se connecter avec Google",
    loginTelegram: "Se connecter avec Telegram",
    playAsGuest: "Jouer en tant qu'invit\xE9",
    settings: "Param\xE8tres du compte",
    displayName: "Nom d'affichage",
    save: "Enregistrer",
    saved: "Enregistr\xE9 !",
    logout: "Se d\xE9connecter",
    logoutConfirm: "\xCAtes-vous s\xFBr de vouloir vous d\xE9connecter ?",
    linkedAccounts: "Comptes li\xE9s",
    memberSince: "Membre depuis",
    dangerZone: "Zone de danger",
    deleteAccount: "Supprimer le compte",
    preferredColor: "Couleur pr\xE9f\xE9r\xE9e"
  },
  profile: {
    title: "Profil du joueur",
    player: "Joueur",
    gamesPlayed: "Parties jou\xE9es",
    wins: "Victoires",
    winRate: "Taux de victoire",
    secondPlace: "2e place",
    thirdPlace: "3e place",
    fourthPlace: "4e place",
    matchHistory: "Historique des matchs",
    noMatches: "Aucun match pour le moment.",
    placement: "Place",
    date: "Date",
    players: "Joueurs",
    loadMore: "Charger plus"
  },
  leaderboard: {
    title: "Meilleurs joueurs",
    rank: "#",
    player: "Joueur",
    wins: "Victoires",
    games: "Parties",
    winRate: "% victoires",
    noData: "Aucune partie jou\xE9e pour le moment."
  },
  lobby: {
    onlinePlayers: "Joueurs en ligne",
    waitingGames: "Parties publiques",
    findMatch: "Trouver une partie en ligne",
    cancelMatch: "Annuler la recherche",
    searching: "Recherche de joueurs...",
    queueCount: "Joueurs en file: {{count}} / 4",
    onlineCount: "Joueurs en ligne: {{count}}",
    join: "Rejoindre",
    creator: "Cr\xE9ateur",
    noGames: "Aucune partie publique disponible",
    botsOfferTitle: "Commencer maintenant avec des bots ?",
    botsOfferText: "Il manque {{count}} joueur(s). Commencez imm\xE9diatement et compl\xE9tez avec des bots.",
    startWithBots: "Commencer avec des bots",
    keepWaiting: "Continuer \xE0 attendre"
  },
  skin: {
    human: "Humain",
    guest: "Invit\xE9",
    gameStatus: "Statut du jeu",
    gameInProgress: "Partie en cours...",
    gameLog: "Journal de jeu",
    noEvents: "Pas encore d'\xE9v\xE9nements",
    waitingForEvents: "En attente d'\xE9v\xE9nements de jeu...",
    gamePaused: "Partie en pause..."
  },
  admin: {
    title: "Panneau d'administration",
    accessDenied: "Acc\xE8s r\xE9serv\xE9 aux administrateurs.",
    goToAccount: "Aller au compte",
    loadError: "Impossible de charger les donn\xE9es d'administration",
    announcement: {
      title: "Annonce syst\xE8me",
      placeholder: 'ex. : "Mise \xE0 jour du jeu dans 5 minutes"',
      preview: "Aper\xE7u",
      publishNow: "Publier maintenant",
      startTime: "Heure de d\xE9but",
      endTime: "Heure de fin (facultatif)",
      publish: "Publier",
      publishing: "Publication...",
      deactivate: "D\xE9sactiver",
      deactivateConfirm: "D\xE9sactiver l'annonce actuelle ?",
      message: "Contenu",
      status: "Statut",
      timeWindow: "Fen\xEAtre",
      noEndTime: "sans fin",
      active: "actif",
      inactive: "inactif"
    },
    users: {
      title: "Joueurs",
      player: "Joueur",
      email: "E-mail",
      role: "R\xF4le",
      ban: "Bannissement",
      banned: "Banni",
      active: "Actif"
    },
    markdown: {
      bold: "texte en gras",
      italic: "italique",
      code: "bloc de code",
      link: "lien",
      listItem: "\xE9l\xE9ment"
    },
    news: {
      title: "Actualit\xE9s de la page d'accueil",
      versionLabel: "Version du jeu",
      versionPlaceholder: "Par exemple : 0.0.26",
      contentLabel: "Ce qui a \xE9t\xE9 livr\xE9",
      contentPlaceholder: "D\xE9cris ce qui est inclus dans cette version.",
      publishLabel: "Afficher sur la page d'accueil",
      preview: "Aper\xE7u",
      create: "Cr\xE9er une actualit\xE9",
      update: "Enregistrer les modifications",
      saving: "Enregistrement...",
      cancelEdit: "Annuler",
      edit: "Modifier",
      delete: "Supprimer",
      deleteConfirm: "Supprimer cette actualit\xE9 ?",
      published: "publi\xE9",
      draft: "brouillon",
      empty: "Aucune nouveaut\xE9 pour le moment.",
      hideBlockLabel: "Masquer tout le bloc d'actualit\xE9s",
      hideItemLabel: "Masquer cette actualit\xE9",
      hidden: "masqu\xE9",
      subtitle: "Le contenu des actualit\xE9s provient d\xE9sormais de fichiers versionn\xE9s dans le d\xE9p\xF4t.",
      fileBasedHint: "Pour modifier les textes d'actualit\xE9 de la page d'accueil, \xE9ditez directement dans le d\xE9p\xF4t les fichiers de news propres \xE0 chaque langue."
    }
  },
  news: {
    title: "Nouveaut\xE9s du jeu",
    subtitle: "Versions et ce qui a \xE9t\xE9 livr\xE9 dans chacune.",
    empty: "Aucune nouveaut\xE9 pour le moment."
  },
  settings: {
    soundOn: "Son activ\xE9",
    soundOff: "Son d\xE9sactiv\xE9"
  }
};

// src/i18n/locales/ko.json
var ko_default = {
  meta: {
    title: "SheshDash - \uBA40\uD2F0\uD50C\uB808\uC774\uC5B4 \uBCF4\uB4DC \uAC8C\uC784",
    description: "4\uC778\uC6A9 \uBA40\uD2F0\uD50C\uB808\uC774\uC5B4 \uBCF4\uB4DC \uAC8C\uC784. \uBCF4\uB4DC\uC5D0\uC11C \uB9D0\uC744 \uC6C0\uC9C1\uC5EC \uAC00\uC7A5 \uBA3C\uC800 \uC911\uC559\uC5D0 \uB3C4\uB2EC\uD558\uC138\uC694!",
    fullDescription: "SheshDash - 2-4\uC778\uC6A9 \uBCF4\uB4DC \uAC8C\uC784. \uC8FC\uC0AC\uC704\uB97C \uAD74\uB9AC\uACE0 \uB9D0\uC744 \uC6C0\uC9C1\uC5EC \uAC00\uC7A5 \uBA3C\uC800 \uC911\uC559\uC5D0 \uB3C4\uB2EC\uD558\uBA74 \uC2B9\uB9AC!"
  },
  landing: {
    playNow: "\uC9C0\uAE08 \uD50C\uB808\uC774",
    learnRules: "\uADDC\uCE59 \uBC30\uC6B0\uAE30",
    termsOfService: "\uC774\uC6A9\uC57D\uAD00",
    supportProject: "\uD504\uB85C\uC81D\uD2B8 \uC9C0\uC6D0",
    myAccount: "\uB0B4 \uACC4\uC815",
    copyright: "\xA9 2026 SheshDash. \uAC1C\uBC1C\uC790: Vadim Maltsev"
  },
  versionBanner: {
    updateAvailable: "\uC0C8 \uBC84\uC804\uC744 \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    updateHint: "\uD604\uC7AC: {{current}}. \uCD5C\uC2E0: {{latest}}. \uD3B8\uD560 \uB54C \uD398\uC774\uC9C0\uB97C \uC0C8\uB85C\uACE0\uCE68\uD558\uC138\uC694.",
    incompatibleTitle: "\uC774 \uD0ED\uC740 \uC624\uB798\uB41C \uBC84\uC804\uC785\uB2C8\uB2E4",
    incompatibleHint: "\uD604\uC7AC: {{current}}. \uCD5C\uC18C \uC9C0\uC6D0 \uBC84\uC804: {{minimum}}. \uC548\uC804\uD558\uAC8C \uACC4\uC18D\uD558\uB824\uBA74 \uD398\uC774\uC9C0\uB97C \uC0C8\uB85C\uACE0\uCE68\uD558\uC138\uC694.",
    refreshNow: "\uC9C0\uAE08 \uC0C8\uB85C\uACE0\uCE68",
    later: "\uB098\uC911\uC5D0",
    inGameWarning: "\uAC8C\uC784 \uC9C4\uD589 \uC911\uC785\uB2C8\uB2E4. \uC5C5\uB370\uC774\uD2B8\uD558\uBA74 \uC77C\uC2DC\uC801\uC73C\uB85C \uC5F0\uACB0\uC774 \uB04A\uAE30\uC9C0\uB9CC \uC790\uB3D9\uC73C\uB85C \uC7AC\uC5F0\uACB0\uB429\uB2C8\uB2E4.",
    inGameProceed: "\uADF8\uB798\uB3C4 \uC5C5\uB370\uC774\uD2B8",
    inGameCancel: "\uAC8C\uC784 \uC720\uC9C0"
  },
  game: {
    title: "SheshDash \uAC8C\uC784",
    gameId: "\uAC8C\uC784 ID",
    copyId: "ID \uBCF5\uC0AC",
    idCopied: "\uAC8C\uC784 ID\uAC00 \uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4!",
    createGame: "\uC0C8 \uAC8C\uC784 \uB9CC\uB4E4\uAE30",
    privateGame: "\uBE44\uACF5\uAC1C \uAC8C\uC784(\uC628\uB77C\uC778 \uBAA9\uB85D\uC5D0\uC11C \uC228\uAE30\uAE30)",
    joinGame: "\uAC8C\uC784 \uCC38\uAC00",
    joinGameButton: "\uCC38\uAC00",
    startGame: "\uAC8C\uC784 \uC2DC\uC791",
    back: "\uB4A4\uB85C",
    yourName: "\uC774\uB984",
    gameIdPlaceholder: "\uAC8C\uC784 ID",
    connected: "\uC5F0\uACB0\uB428",
    connecting: "\uC5F0\uACB0 \uC911...",
    waitingForPlayers: "\uD50C\uB808\uC774\uC5B4 \uB300\uAE30 \uC911...",
    players: "\uD50C\uB808\uC774\uC5B4",
    shareGameId: "\uCE5C\uAD6C\uB4E4\uACFC \uAC8C\uC784 ID\uB97C \uACF5\uC720\uD558\uC138\uC694!",
    canStartWithPlayers: "2-4\uBA85\uC758 \uD50C\uB808\uC774\uC5B4\uB85C \uC2DC\uC791\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC900\uBE44\uB418\uBA74 '\uAC8C\uC784 \uC2DC\uC791'\uC744 \uD074\uB9AD\uD558\uC138\uC694!",
    needMorePlayers: "\uCD5C\uC18C 2\uBA85\uC758 \uD50C\uB808\uC774\uC5B4\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4.",
    botSuggestion: "\uBD07 \uC81C\uC548",
    currentPlayers: "\uD604\uC7AC \uD50C\uB808\uC774\uC5B4:",
    yourTurn: "\uB2F9\uC2E0\uC758 \uCC28\uB840!",
    waiting: "\uB300\uAE30 \uC911...",
    rolled: "\uC8FC\uC0AC\uC704",
    gameOver: "\uAC8C\uC784 \uC885\uB8CC!",
    exitGame: "\uAC8C\uC784 \uB098\uAC00\uAE30",
    winner: "\uC2B9\uC790",
    turnTimer: "\uB0A8\uC740 \uC2DC\uAC04",
    results: "\uCD5C\uC885 \uC21C\uC704",
    place: "\uC21C\uC704",
    preferredColor: "\uC120\uD638 \uC0C9\uC0C1",
    autoAssignColor: "\uC790\uB3D9 \uC120\uD0DD",
    colorRed: "\uBE68\uAC15",
    colorBlue: "\uD30C\uB791",
    colorGreen: "\uCD08\uB85D",
    colorOrange: "\uC8FC\uD669",
    pause: "\uC77C\uC2DC\uC815\uC9C0",
    resume: "\uACC4\uC18D",
    paused: "\uC77C\uC2DC\uC815\uC9C0\uB428",
    pausedHint: "\uAC8C\uC784\uC774 \uC77C\uC2DC\uC815\uC9C0\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uACC4\uC18D\uD558\uB824\uBA74 '\uACC4\uC18D'\uC744 \uB204\uB974\uC138\uC694.",
    onlyCreatorCanStart: "\uAC8C\uC784\uC744 \uC2DC\uC791\uD560 \uC218 \uC788\uB294 \uC0AC\uB78C\uC740 \uC0DD\uC131\uC790\uBFD0\uC785\uB2C8\uB2E4."
  },
  kickVote: {
    confirm: "{{name}} \uB2D8\uC744 \uAC8C\uC784\uC5D0\uC11C \uB0B4\uBCF4\uB0BC\uAE4C\uC694?",
    title: "\uD50C\uB808\uC774\uC5B4\uB97C \uB0B4\uBCF4\uB0BC\uAE4C\uC694?",
    requestsToKick: "\uB2D8\uC744 \uB0B4\uBCF4\uB0B4\uB824\uACE0 \uD569\uB2C8\uB2E4",
    targetBot: "\uB300\uC0C1: \uBD07",
    targetHuman: "\uB300\uC0C1: \uD50C\uB808\uC774\uC5B4",
    votes: "\uD22C\uD45C",
    approve: "\uCC2C\uC131",
    reject: "\uBC18\uB300",
    waiting: "\uB2E4\uB978 \uD22C\uD45C\uB97C \uAE30\uB2E4\uB9AC\uB294 \uC911",
    readOnly: "\uD22C\uD45C \uC9C4\uD589 \uC911",
    kickedTitle: "\uAC8C\uC784\uC5D0\uC11C \uC81C\uC678\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
    kickedNotice: "\uC774\uC81C \uB2F9\uC2E0\uC758 \uB9D0\uC740 \uBC18\uD22C\uBA85\uD558\uBA70 \uAC8C\uC784 \uC9C4\uD589\uC744 \uB9C9\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
    returnToLobby: "\uB85C\uBE44\uB85C \uB3CC\uC544\uAC00\uAE30",
    observeGame: "\uAC8C\uC784 \uAD00\uC804"
  },
  actions: {
    yourActions: "\uB2F9\uC2E0\uC758 \uD589\uB3D9",
    rollDice: "\uC8FC\uC0AC\uC704\uB97C \uAD74\uB824 \uCC28\uB840\uB97C \uC2DC\uC791\uD558\uC138\uC694!",
    needSix: "\uCCAB \uB9D0\uC744 \uB193\uC73C\uB824\uBA74 6\uC774 \uB098\uC640\uC57C \uD569\uB2C8\uB2E4!",
    rolledSix: "6\uC774 \uB098\uC654\uC2B5\uB2C8\uB2E4! \uBCF4\uB108\uC2A4 \uAD74\uB9BC \uBCF4\uC7A5!",
    rolledSixOptions: [
      "\uC0C8 \uB9D0 \uB193\uAE30 (\uAC00\uB2A5\uD55C \uACBD\uC6B0)",
      "\uB610\uB294 \uAE30\uC874 \uB9D0\uC744 6\uCE78 \uC774\uB3D9"
    ],
    rolledSixNote: "\uB450 \uC120\uD0DD \uBAA8\uB450 \uCD94\uAC00 \uAD74\uB9BC\uC744 \uC81C\uACF5\uD569\uB2C8\uB2E4!",
    selectPiece: "{{steps}}\uCE78 \uC774\uB3D9\uD560 \uB9D0\uC744 \uC120\uD0DD\uD558\uC138\uC694.",
    selectedPiece: "\uC120\uD0DD\uB41C \uB9D0: {{state}}",
    placePiece: "\uB9D0 \uB193\uAE30",
    moveSteps: "{{steps}}\uCE78 \uC774\uB3D9",
    deselect: "\uC120\uD0DD \uD574\uC81C"
  },
  instructions: {
    title: "\uAC8C\uC784 \uBC29\uBC95:",
    rules: [
      "\uB9D0\uC740 \uCC98\uC74C\uC5D0 \uBCF4\uB4DC \uBC16\uC5D0 \uC788\uC73C\uBA70, 6\uC774 \uB098\uC624\uBA74 \uC2DC\uC791 \uCF54\uB108 \uCE78\uC5D0 \uB193\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
      "\uC2DC\uACC4 \uBC29\uD5A5\uC73C\uB85C \uB9D0\uC744 \uC774\uB3D9\uD558\uC138\uC694",
      "\uD55C \uBC14\uD034 \uD6C4 \uB300\uAC01\uC120\uC73C\uB85C \uC911\uC559\uC73C\uB85C \uC774\uB3D9",
      "\uBAA8\uB4E0 4\uAC1C\uC758 \uB9D0\uC744 \uC911\uC559\uC5D0 \uBA3C\uC800 \uB193\uC740 \uD50C\uB808\uC774\uC5B4\uAC00 \uC2B9\uB9AC!"
    ]
  },
  gameMode: {
    title: "\uC5B4\uB5BB\uAC8C \uD50C\uB808\uC774\uD558\uC2DC\uACA0\uC5B4\uC694?",
    quickStart: "\uBE60\uB978 \uC2DC\uC791",
    quickStartDesc: "\uBD07 3\uBA85\uACFC \uB300\uACB0, \uC989\uC2DC \uC2DC\uC791",
    withFriends: "\uCE5C\uAD6C\uC640 \uD568\uAED8",
    withFriendsDesc: "\uCF54\uB4DC\uB97C \uACF5\uC720\uD558\uACE0 \uCE5C\uAD6C\uB97C \uAE30\uB2E4\uB9AC\uAE30",
    findPlayers: "\uD50C\uB808\uC774\uC5B4 \uCC3E\uAE30",
    findPlayersDesc: "\uACF5\uAC1C \uB85C\uBE44, \uB204\uAD6C\uB098 \uCC38\uAC00 \uAC00\uB2A5"
  },
  bots: {
    addTitle: "\uBD07 \uCD94\uAC00?",
    addDescription: "\uC544\uC9C1 \uC544\uBB34\uB3C4 \uCC38\uAC00\uD558\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4. \uBD07\uC744 \uCD94\uAC00\uD558\uC5EC \uC2DC\uC791\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
    needMore: "{{count}}\uBA85\uC758 \uD50C\uB808\uC774\uC5B4\uAC00 \uB354 \uD544\uC694\uD569\uB2C8\uB2E4.",
    addButton: "\uBD07 {{count}}\uAC1C \uCD94\uAC00",
    addButtonPlural: "\uBD07 {{count}}\uAC1C \uCD94\uAC00",
    waitForPlayers: "\uD50C\uB808\uC774\uC5B4 \uB300\uAE30"
  },
  turn: {
    currentTurn: "\uD604\uC7AC \uCC28\uB840",
    you: "\uB2F9\uC2E0",
    skipped: "\uCC28\uB840 \uAC74\uB108\uB700",
    completed: "\uCC28\uB840 \uC644\uB8CC"
  },
  errors: {
    error: "\uC624\uB958",
    pathBlocked: "\uACBD\uB85C\uAC00 \uB9C9\uD614\uC2B5\uB2C8\uB2E4 - \uB9D0\uC744 \uB6F0\uC5B4\uB118\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    cannotLandOnOwnPiece: "\uC790\uC2E0\uC758 \uB9D0 \uC704\uC5D0 \uB193\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    pieceInCorner: "\uB9D0\uC774 \uC608\uBE44\uC5D0 \uC788\uC2B5\uB2C8\uB2E4. \uB193\uC73C\uB824\uBA74 6\uC774 \uD544\uC694\uD569\uB2C8\uB2E4",
    pieceAlreadyInCenter: "\uB9D0\uC774 \uC774\uBBF8 \uC911\uC559\uC5D0 \uC788\uC2B5\uB2C8\uB2E4",
    needToRoll6: "\uB9D0\uC744 \uB193\uC73C\uB824\uBA74 6\uC744 \uAD74\uB824\uC57C \uD569\uB2C8\uB2E4",
    pieceNotInCorner: "\uB9D0\uC774 \uC608\uBE44\uC5D0 \uC5C6\uC2B5\uB2C8\uB2E4",
    pieceNotFound: "\uB9D0\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    notYourTurn: "\uB2F9\uC2E0\uC758 \uCC28\uB840\uAC00 \uC544\uB2D9\uB2C8\uB2E4",
    gameNotInProgress: "\uAC8C\uC784\uC774 \uC9C4\uD589 \uC911\uC774 \uC544\uB2D9\uB2C8\uB2E4",
    stepsMustMatchDice: "\uCE78 \uC218\uAC00 \uC8FC\uC0AC\uC704\uC640 \uC77C\uCE58\uD574\uC57C \uD569\uB2C8\uB2E4",
    needExactRollForCenter: "\uC911\uC559\uC5D0 \uB4E4\uC5B4\uAC00\uB824\uBA74 \uC815\uD655\uD55C \uC22B\uC790\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4",
    onlyCreatorCanStart: "\uAC8C\uC784\uC744 \uC2DC\uC791\uD560 \uC218 \uC788\uB294 \uC0AC\uB78C\uC740 \uAC8C\uC784 \uC0DD\uC131\uC790\uBFD0\uC785\uB2C8\uB2E4",
    playerNameTaken: "\uC774 \uAC8C\uC784\uC5D0\uC11C\uB294 \uADF8 \uD50C\uB808\uC774\uC5B4 \uC774\uB984\uC744 \uC774\uBBF8 \uC0AC\uC6A9 \uC911\uC785\uB2C8\uB2E4"
  },
  pieceStates: {
    in_corner: "\uC608\uBE44",
    on_perimeter: "\uBCF4\uB4DC \uC704",
    on_diagonal: "\uB300\uAC01\uC120",
    in_center: "\uC911\uC559"
  },
  playerInfo: {
    title: "\uD50C\uB808\uC774\uC5B4",
    you: "(\uB2F9\uC2E0)",
    turn: "\uCC28\uB840",
    corner: "\uC608\uBE44:",
    onBoard: "\uBCF4\uB4DC \uC704:",
    inCenter: "\uC911\uC559:",
    waitingFor: "{{count}}\uBA85\uC758 \uD50C\uB808\uC774\uC5B4 \uB300\uAE30 \uC911...",
    statusRolled6: "\uBCF4\uB108\uC2A4!",
    statusCaptured: "\uD3EC\uD68D! \uBCF4\uB108\uC2A4!",
    statusPlacedPiece: "\uBC30\uCE58\uB428, \uBCF4\uB108\uC2A4!",
    statusMovedOn6: "6\uCE78 \uC774\uB3D9, \uBCF4\uB108\uC2A4!",
    statusTurnSkipped: "\uAC74\uB108\uB700",
    statusTurnComplete: "\uCC28\uB840 \uC885\uB8CC"
  },
  dice: {
    rollDice: "\uC8FC\uC0AC\uC704 \uAD74\uB9AC\uAE30",
    rolled6Message: "6\uC774 \uB098\uC654\uC2B5\uB2C8\uB2E4! \uC0C8 \uB9D0\uC744 \uB193\uAC70\uB098 \uAE30\uC874 \uB9D0\uC744 6\uCE78 \uC774\uB3D9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    rolledBy: "\uAD74\uB9B0 \uC0AC\uB78C",
    round: "\uB77C\uC6B4\uB4DC",
    rolls: "\uAD74\uB9BC",
    captureBonus: "\uCEA1\uCC98 \uBCF4\uB108\uC2A4"
  },
  board: {
    currentPlayer: "\uD604\uC7AC \uD50C\uB808\uC774\uC5B4",
    historyStart: "\uCC98\uC74C",
    historyPrev: "\uC774\uC804",
    historyNext: "\uB2E4\uC74C",
    historyEnd: "\uB9C8\uC9C0\uB9C9",
    historyViewingPast: "\uD788\uC2A4\uD1A0\uB9AC \uBAA8\uB4DC: \uB3D9\uC791\uC774 \uBE44\uD65C\uC131\uD654\uB429\uB2C8\uB2E4"
  },
  rules: {
    title: "\uAC8C\uC784 \uADDC\uCE59",
    close: "\uB2EB\uAE30",
    showRules: "\uADDC\uCE59",
    objective: {
      title: "\uBAA9\uD45C",
      description: "\uC2DC\uC791 \uCE78(\uCF54\uB108)\uC5D0\uC11C \uCD9C\uBC1C\uD574 \uB458\uB808\uC640 \uB300\uAC01\uC120\uC744 \uB530\uB77C \uC911\uC2EC\uC73C\uB85C 4\uAC1C\uC758 \uB9D0\uC744 \uBAA8\uB450 \uBA3C\uC800 \uC774\uB3D9\uC2DC\uD0A4\uB294 \uD50C\uB808\uC774\uC5B4\uAC00 \uC2B9\uB9AC\uD569\uB2C8\uB2E4."
    },
    setup: {
      title: "\uC124\uC815",
      items: [
        "\uAC01 \uD50C\uB808\uC774\uC5B4\uB294 \uBCF4\uB4DC \uBC16(\uC608\uBE44)\uC5D0 \uB9D0 4\uAC1C\uB85C \uC2DC\uC791\uD569\uB2C8\uB2E4",
        "\uD50C\uB808\uC774\uC5B4\uB294 \uC2DC\uACC4 \uBC29\uD5A5\uC73C\uB85C \uCC28\uB840\uB97C \uAC00\uC9D1\uB2C8\uB2E4",
        "\uBAA8\uB4E0 \uB9D0\uC740 6\uC774 \uB098\uC62C \uB54C\uAE4C\uC9C0 \uBCF4\uB4DC \uBC16\uC5D0 \uC788\uC2B5\uB2C8\uB2E4"
      ]
    },
    gameplay: {
      title: "\uAC8C\uC784\uD50C\uB808\uC774",
      items: [
        "\uC8FC\uC0AC\uC704\uB97C \uAD74\uB824 \uC774\uB3D9\uD560 \uCE78 \uC218\uB97C \uACB0\uC815\uD569\uB2C8\uB2E4",
        "\uCCAB \uB9D0\uC744 \uB193\uC73C\uB824\uBA74 6\uC744 \uAD74\uB824\uC57C \uD569\uB2C8\uB2E4",
        "\uB9D0\uC740 \uC678\uACFD \uB458\uB808\uB97C \uC2DC\uACC4 \uBC29\uD5A5\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4 (28\uCE78)",
        "\uD55C \uBC14\uD034\uB97C \uC644\uB8CC\uD55C \uD6C4 \uB300\uAC01\uC120\uC73C\uB85C \uC911\uC559\uC73C\uB85C \uB4E4\uC5B4\uAC11\uB2C8\uB2E4 (4\uCE78)",
        "\uC608\uBE44 \uB9D0\uC740 6\uC774 \uB098\uC624\uAE30 \uC804\uC5D0\uB294 \uC6C0\uC9C1\uC77C \uC218 \uC5C6\uC2B5\uB2C8\uB2E4"
      ]
    },
    rolling6: {
      title: "6 \uAD74\uB9AC\uAE30",
      description: "6\uC744 \uAD74\uB9AC\uBA74 \uB450 \uAC00\uC9C0 \uC120\uD0DD\uC774 \uC788\uC2B5\uB2C8\uB2E4:",
      options: [
        "\uC0C8 \uB9D0\uC744 \uC2DC\uC791 \uCE78(\uCF54\uB108)\uC5D0 \uB193\uAE30",
        "\uAE30\uC874 \uB9D0\uC744 6\uCE78 \uC55E\uC73C\uB85C \uC774\uB3D9"
      ],
      note: "\uB450 \uC120\uD0DD \uBAA8\uB450 \uBCF4\uB108\uC2A4 \uAD74\uB9BC\uC744 \uC81C\uACF5\uD569\uB2C8\uB2E4! 6\uC774 \uACC4\uC18D \uB098\uC624\uB294 \uB3D9\uC548 \uACC4\uC18D \uAD74\uB9B4 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
    },
    capturing: {
      title: "\uD3EC\uD68D",
      items: [
        "\uB2F9\uC2E0\uC758 \uB9D0\uC774 \uC0C1\uB300 \uB9D0 \uC704\uC5D0 \uC815\uD655\uD788 \uCC29\uC9C0\uD558\uBA74 \uD3EC\uD68D\uD569\uB2C8\uB2E4",
        "\uC7A1\uD78C \uB9D0\uC740 \uBCF4\uB4DC\uC5D0\uC11C \uC81C\uAC70\uB418\uC5B4 \uC0C1\uB300\uC758 \uC608\uBE44\uB85C \uB3CC\uC544\uAC11\uB2C8\uB2E4",
        "\uB6F0\uC5B4\uB118\uC5B4 \uD3EC\uD68D\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4 - \uC815\uD655\uD788 \uADF8 \uC704\uCE58\uC5D0 \uCC29\uC9C0\uD574\uC57C \uD569\uB2C8\uB2E4",
        "\uD3EC\uD68D\uD558\uBA74 \uBCF4\uB108\uC2A4 \uAD74\uB9BC\uC744 \uBC1B\uC2B5\uB2C8\uB2E4 (\uCD94\uAC00 \uCC28\uB840)"
      ]
    },
    blocking: {
      title: "\uB9C9\uAE30",
      description: "\uB2E4\uB978 \uB9D0\uC744 \uB6F0\uC5B4\uB118\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4! \uC5B4\uB5A4 \uB9D0(\uB2F9\uC2E0 \uAC83\uC774\uB4E0 \uC0C1\uB300 \uAC83\uC774\uB4E0)\uC774 \uACBD\uB85C\uB97C \uB9C9\uC73C\uBA74 \uC9C0\uB098\uAC08 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC804\uCCB4 \uACBD\uB85C\uAC00 \uBE44\uC5B4 \uC788\uC5B4\uC57C \uD569\uB2C8\uB2E4."
    },
    winning: {
      title: "\uC2B9\uB9AC",
      description: "\uBAA8\uB4E0 4\uAC1C\uC758 \uB9D0\uC744 \uC911\uC559 \uC601\uC5ED\uC73C\uB85C \uBA3C\uC800 \uC774\uB3D9\uC2DC\uD0A8 \uD50C\uB808\uC774\uC5B4\uAC00 \uAC8C\uC784\uC5D0\uC11C \uC2B9\uB9AC\uD569\uB2C8\uB2E4!"
    },
    bonusRolls: {
      title: "\uBCF4\uB108\uC2A4 \uAD74\uB9BC",
      items: [
        "6\uC744 \uAD74\uB9AC\uBA74 \uBCF4\uB108\uC2A4 \uAD74\uB9BC\uC744 \uBC1B\uC2B5\uB2C8\uB2E4 (\uBC30\uCE58\uD558\uB4E0 \uC774\uB3D9\uD558\uB4E0)",
        "\uC0C1\uB300 \uB9D0\uC744 \uD3EC\uD68D\uD558\uBA74 \uBCF4\uB108\uC2A4 \uAD74\uB9BC\uC744 \uBC1B\uC2B5\uB2C8\uB2E4",
        "\uBCF4\uB108\uC2A4 \uAD74\uB9BC\uC740 \uB204\uC801\uB429\uB2C8\uB2E4 - \uB2E4\uC2DC 6\uC744 \uAD74\uB9AC\uAC70\uB098 \uB2E4\uC2DC \uD3EC\uD68D\uD558\uBA74 \uACC4\uC18D\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4!"
      ]
    },
    timer: {
      title: "\uD134 \uD0C0\uC774\uBA38",
      items: [
        "\uAC01 \uD50C\uB808\uC774\uC5B4\uB294 \uD134\uC744 \uC644\uB8CC\uD560 \uC81C\uD55C \uC2DC\uAC04\uC774 \uC788\uC2B5\uB2C8\uB2E4",
        "\uC2DC\uAC04\uC774 \uB2E4 \uB418\uBA74 \uD134\uC774 \uC790\uB3D9\uC73C\uB85C \uAC74\uB108\uB701\uB2C8\uB2E4"
      ]
    }
  },
  hint: {
    button: "\uD78C\uD2B8",
    title: "\uC81C\uC548\uB41C \uC774\uB3D9",
    noPieces: "\uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uB9D0\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
    canPlace: "6\uC774 \uB098\uC654\uC2B5\uB2C8\uB2E4! \uC2DC\uC791 \uCE78(\uCF54\uB108)\uC5D0 \uB9D0\uC744 \uB193\uC73C\uC138\uC694",
    canMove: "{{position}}\uC758 \uB9D0\uC744 {{steps}}\uCE78 \uC774\uB3D9",
    close: "\uB2EB\uAE30"
  },
  theme: {
    sheshdash: "\uC170\uC2DC\uB300\uC2DC",
    toggle: "\uD14C\uB9C8 \uC804\uD658",
    system: "\uC2DC\uC2A4\uD15C",
    light: "\uB77C\uC774\uD2B8",
    dark: "\uB2E4\uD06C"
  },
  tutorial: {
    button: "\uD29C\uD1A0\uB9AC\uC5BC",
    skip: "\uAC74\uB108\uB6F0\uAE30",
    prev: "\uC774\uC804",
    next: "\uB2E4\uC74C",
    finish: "\uC644\uB8CC",
    welcome: {
      title: "SheshDash\uC5D0 \uC624\uC2E0 \uAC83\uC744 \uD658\uC601\uD569\uB2C8\uB2E4!",
      description: "\uC774 \uBE60\uB978 \uD29C\uD1A0\uB9AC\uC5BC\uC740 \uAC8C\uC784 \uBC29\uBC95\uC744 \uBCF4\uC5EC\uC90D\uB2C8\uB2E4. \uBAA9\uD45C: \uC2DC\uC791 \uCE78(\uCF54\uB108)\uC5D0\uC11C \uC911\uC559\uAE4C\uC9C0 \uB9D0 4\uAC1C\uB97C \uBA3C\uC800 \uC62E\uAE30\uAE30!"
    },
    createGame: {
      title: "\uAC8C\uC784 \uB9CC\uB4E4\uAE30",
      description: "\uC774 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC5EC \uC0C8 \uAC8C\uC784\uC744 \uB9CC\uB4DC\uC138\uC694. \uCE5C\uAD6C\uB4E4\uACFC \uACF5\uC720\uD560 \uC218 \uC788\uB294 \uACE0\uC720 ID\uB97C \uBC1B\uAC8C \uB429\uB2C8\uB2E4."
    },
    addBots: {
      title: "\uBD07 \uCD94\uAC00",
      description: "\uD50C\uB808\uC774\uC5B4\uAC00 \uBD80\uC871\uD558\uBA74 \uBD07\uC744 \uCD94\uAC00\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uAC8C\uC784\uC744 \uC2DC\uC791\uD558\uB824\uBA74 2-4\uBA85\uC758 \uD50C\uB808\uC774\uC5B4\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4."
    },
    startGame: {
      title: "\uAC8C\uC784 \uC2DC\uC791",
      description: "\uBAA8\uB4E0 \uD50C\uB808\uC774\uC5B4\uAC00 \uC900\uBE44\uB418\uBA74 (\uCD5C\uC18C 2\uBA85), \uC774 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC5EC \uAC8C\uC784\uC744 \uC2DC\uC791\uD558\uC138\uC694!"
    },
    diceButton: {
      title: "\u{1F3B2} \uC8FC\uC0AC\uC704 \uAD74\uB9AC\uAE30",
      description: "\uC774 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC5EC \uC8FC\uC0AC\uC704\uB97C \uAD74\uB9AC\uC138\uC694. \uCCAB \uB9D0\uC744 \uB193\uC73C\uB824\uBA74 6\uC774 \uB098\uC640\uC57C \uD569\uB2C8\uB2E4!"
    },
    board: {
      title: "\u{1F3AE} \uAC8C\uC784 \uBCF4\uB4DC",
      description: "\uC774\uAC83\uC740 8\xD78 \uBCF4\uB4DC\uC785\uB2C8\uB2E4. \uB9D0\uC740 \uC2DC\uC791 \uCE78(\uCF54\uB108)\uC5D0\uC11C \uB4E4\uC5B4\uC640 \uC2DC\uACC4 \uBC29\uD5A5\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4."
    },
    playerInfo: {
      title: "\u{1F4CA} \uD50C\uB808\uC774\uC5B4 \uC815\uBCF4",
      description: "\uC5EC\uAE30\uC11C \uBAA8\uB4E0 \uD50C\uB808\uC774\uC5B4, \uADF8\uB4E4\uC758 \uB9D0, \uD604\uC7AC \uCC28\uB840\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uB204\uAC00 \uD50C\uB808\uC774\uD558\uB294\uC9C0 \uBCF4\uC138\uC694!"
    },
    selectPiece: {
      title: "\u{1F3AF} 1\uB2E8\uACC4: \uB9D0 \uC120\uD0DD",
      description: "\uC5EC\uAE30\uAC00 \uC2DC\uC791 \uCE78(\uCF54\uB108)\uC785\uB2C8\uB2E4! 6\uC774 \uB098\uC624\uBA74 \uB9D0\uC744 \uD074\uB9AD\uD574 \uBCF4\uB4DC\uC5D0 \uC62C\uB9AC\uC138\uC694."
    },
    placeButton: {
      title: "\u2705 2\uB2E8\uACC4: \uB193\uAE30 \uBC84\uD2BC",
      description: '\uC5EC\uAE30\uC5D0 \uC120\uD0DD \uD6C4 "\uB9D0 \uB193\uAE30" \uBC84\uD2BC\uC774 \uB098\uD0C0\uB0A9\uB2C8\uB2E4. \uD074\uB9AD\uD558\uBA74 \uB9D0\uC774 \uC2DC\uC791 \uC704\uCE58\uC5D0 \uB193\uC785\uB2C8\uB2E4! \uBCF4\uB108\uC2A4 \uAD74\uB9BC\uC744 \uBC1B\uC2B5\uB2C8\uB2E4!'
    },
    moveInstruction: {
      title: "\u{1F463} \uB9D0\uC744 \uC774\uB3D9\uD558\uB294 \uBC29\uBC95",
      description: '\uAD74\uB9B0 \uD6C4: \u2460 \uBCF4\uB4DC \uC704\uC758 \uB2F9\uC2E0\uC758 \uB9D0\uC744 \uD074\uB9AD \u2461 \uC624\uB978\uCABD\uC758 "X\uCE78 \uC774\uB3D9" \uBC84\uD2BC\uC744 \uB204\uB974\uC138\uC694. \uAE30\uC5B5\uD558\uC138\uC694: \uB2E4\uB978 \uB9D0\uC744 \uB6F0\uC5B4\uB118\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4!'
    },
    goal: {
      title: "\u{1F3C6} \uAC8C\uC784 \uBAA9\uD45C - \uC911\uC559!",
      description: "\uC5EC\uAE30 \uC788\uC2B5\uB2C8\uB2E4 - \uD669\uAE08 \uCE78 (a8\u2192b7\u2192c6\u2192d5)! \uBAA8\uB4E0 4\uAC1C\uC758 \uB9D0\uC744 \uB300\uAC01\uC120\uC73C\uB85C \uC5EC\uAE30\uB85C \uBA3C\uC800 \uC774\uB3D9\uC2DC\uCF1C \uC2B9\uB9AC\uD558\uC138\uC694! \uACBD\uB85C: \uB458\uB808 (28\uCE78) \u2192 \uB300\uAC01\uC120\uC73C\uB85C \uC911\uC559 (4\uCE78)."
    }
  },
  common: {
    cancel: "\uCDE8\uC18C",
    back: "\uB4A4\uB85C",
    confirm: "\uD655\uC778",
    close: "\uB2EB\uAE30"
  },
  joinVote: {
    title: "\uCC38\uAC00 \uC694\uCCAD",
    wantsToJoin: "\uB2D8\uC774 \uAC8C\uC784\uC5D0 \uCC38\uAC00\uD558\uB824\uACE0 \uD569\uB2C8\uB2E4",
    willReplaceBot: "\uBD07\uC744 \uB300\uCCB4\uD569\uB2C8\uB2E4",
    keepPieces: "\uBD07\uC758 \uB9D0 \uC720\uC9C0",
    newPieces: "\uC0C8 \uB9D0\uB85C \uC2DC\uC791",
    votes: "\uD22C\uD45C",
    approve: "\uCC2C\uC131",
    reject: "\uBC18\uB300",
    total: "\uD569\uACC4",
    approveButton: "\uC2B9\uC778",
    rejectButton: "\uAC70\uBD80",
    waiting: "\uB2E4\uB978 \uD50C\uB808\uC774\uC5B4\uB97C \uAE30\uB2E4\uB9AC\uB294 \uC911..."
  },
  joinStarted: {
    title: "\uC9C4\uD589 \uC911\uC778 \uAC8C\uC784 \uCC38\uAC00",
    gameInProgress: "\uC774 \uAC8C\uC784\uC740 \uC774\uBBF8 \uC9C4\uD589 \uC911\uC785\uB2C8\uB2E4.",
    chooseOption: "\uCC38\uAC00 \uBC29\uBC95\uC744 \uC120\uD0DD\uD558\uC138\uC694:",
    replaceBot: "\uBD07 \uAD50\uCCB4",
    replaceBotHint: "\uBD07\uC758 \uC704\uCE58\uB97C \uC774\uC5B4\uBC1B\uAE30",
    newPlayer: "\uC0C8 \uD50C\uB808\uC774\uC5B4\uB85C \uCC38\uAC00",
    newPlayerHint: "\uC0C8 \uB9D0\uB85C \uC2DC\uC791\uD558\uAE30",
    noOptions: "\uCC38\uAC00\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4: \uAD50\uCCB4\uD560 \uBD07\uB3C4 \uBE48 \uC790\uB9AC\uB3C4 \uC5C6\uC2B5\uB2C8\uB2E4.",
    note: "\uCC38\uACE0",
    voteRequired: "\uBAA8\uB4E0 \uD50C\uB808\uC774\uC5B4\uAC00 \uCC38\uAC00 \uC694\uCCAD\uC744 \uC2B9\uC778\uD574\uC57C \uD569\uB2C8\uB2E4.",
    replaceBotTitle: "\uBD07 \uAD50\uCCB4",
    selectBot: "\uAD50\uCCB4\uD560 \uBD07 \uC120\uD0DD:",
    selectBotPlaceholder: "-- \uBD07 \uC120\uD0DD --",
    keepPieces: "\uBD07\uC758 \uB9D0\uACFC \uD604\uC7AC \uC704\uCE58 \uC720\uC9C0",
    keepPiecesHint: "\uBD07\uC758 \uD604\uC7AC \uB9D0\uACFC \uC704\uCE58\uB97C \uC774\uC5B4\uBC1B\uC2B5\uB2C8\uB2E4",
    resetPiecesHint: "\uBD07\uC758 \uB9D0\uC740 \uC2DC\uC791 \uBAA8\uC11C\uB9AC\uB85C \uCD08\uAE30\uD654\uB429\uB2C8\uB2E4",
    yourName: "\uC774\uB984",
    sendRequest: "\uC694\uCCAD \uBCF4\uB0B4\uAE30",
    newPlayerTitle: "\uC0C8 \uD50C\uB808\uC774\uC5B4\uB85C \uCC38\uAC00",
    newPlayerInfo: "\uBE48 \uBAA8\uC11C\uB9AC\uC5D0\uC11C \uC0C8 \uB9D0\uB85C \uAC8C\uC784\uC5D0 \uCC38\uAC00\uD569\uB2C8\uB2E4.",
    currentPlayers: "\uD604\uC7AC \uD50C\uB808\uC774\uC5B4",
    lateJoinWarning: "\uB2A6\uAC8C \uCC38\uAC00\uD558\uBBC0\uB85C \uB2E4\uB978 \uD50C\uB808\uC774\uC5B4\uAC00 \uC55E\uC11C \uC788\uC2B5\uB2C8\uB2E4!",
    waitingApproval: "\uC2B9\uC778 \uB300\uAE30 \uC911",
    waitingApprovalText: "\uD50C\uB808\uC774\uC5B4\uB4E4\uC774 \uB2F9\uC2E0\uC758 \uCC38\uAC00 \uC694\uCCAD\uC5D0 \uD22C\uD45C\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4."
  },
  userAgreement: {
    title: "\uC0AC\uC6A9\uC790 \uB3D9\uC758",
    close: "\uB2EB\uAE30",
    acceptance: {
      title: "1. \uC57D\uAD00 \uB3D9\uC758",
      description: "SheshDash \uAC8C\uC784\uC744 \uC0AC\uC6A9\uD568\uC73C\uB85C\uC368 \uBCF8 \uC0AC\uC6A9\uC790 \uB3D9\uC758\uC758 \uC870\uAC74\uC5D0 \uB3D9\uC758\uD558\uB294 \uAC83\uC785\uB2C8\uB2E4. \uB3D9\uC758\uD558\uC9C0 \uC54A\uB294 \uACBD\uC6B0 \uAC8C\uC784\uC744 \uC0AC\uC6A9\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624."
    },
    gameRules: {
      title: "2. \uAC8C\uC784 \uADDC\uCE59",
      description: "\uD50C\uB808\uC774\uC5B4\uB294 SheshDash\uC758 \uADDC\uCE59\uC744 \uB530\uB974\uB294 \uB370 \uB3D9\uC758\uD569\uB2C8\uB2E4. \uBD07 \uC0AC\uC6A9\uC740 \uAC8C\uC784\uC774 \uC81C\uACF5\uD558\uB294 \uAE30\uB2A5 \uBC94\uC704 \uB0B4\uC5D0\uC11C\uB9CC \uD5C8\uC6A9\uB429\uB2C8\uB2E4. \uBD80\uC815 \uD589\uC704, \uD575 \uC0AC\uC6A9 \uB610\uB294 \uCDE8\uC57D\uC810 \uC545\uC6A9 \uC2DC\uB3C4\uB294 \uAE08\uC9C0\uB429\uB2C8\uB2E4."
    },
    intellectualProperty: {
      title: "3. \uC9C0\uC801 \uC7AC\uC0B0\uAD8C",
      description: "SheshDash \uAC8C\uC784\uC758 \uCF54\uB4DC, \uB514\uC790\uC778, \uADF8\uB798\uD53D, \uC11C\uBC84 \uB85C\uC9C1, \uAC8C\uC784 \uBA54\uCEE4\uB2C8\uC998 \uBC0F \uADDC\uCE59\uC744 \uD3EC\uD568\uD55C \uBAA8\uB4E0 \uAD8C\uB9AC\uB294 \uC800\uC790 Vadim Maltsev\uC5D0\uAC8C \uC788\uC2B5\uB2C8\uB2E4. \uAC8C\uC784 \uC774\uB984 \u201CSheshDash\u201D\uB294 \uAD8C\uB9AC\uC790\uC5D0\uAC8C \uBCF4\uD638\uB429\uB2C8\uB2E4. \uC774 \uD504\uB85C\uC81D\uD2B8\uB294 \uC624\uD508 \uC18C\uC2A4\uAC00 \uC544\uB2D9\uB2C8\uB2E4. \uC800\uC790\uC758 \uC11C\uBA74 \uD5C8\uAC00 \uC5C6\uC774 \uBCF5\uC81C, \uBC30\uD3EC \uB610\uB294 \uC218\uC815\uD558\uB294 \uAC83\uC740 \uAE08\uC9C0\uB429\uB2C8\uB2E4."
    },
    userConduct: {
      title: "4. \uC0AC\uC6A9\uC790 \uD589\uB3D9",
      items: [
        "\uB2E4\uB978 \uD50C\uB808\uC774\uC5B4\uB97C \uC874\uC911\uD558\uACE0 \uACF5\uACA9\uC801\uC778 \uC5B8\uC5B4\uB97C \uC0AC\uC6A9\uD558\uC9C0 \uB9C8\uC138\uC694",
        "\uAC8C\uC784\uC744 \uD574\uD0B9\uD558\uAC70\uB098 \uBC29\uD574\uD558\uB824\uACE0 \uC2DC\uB3C4\uD558\uC9C0 \uB9C8\uC138\uC694",
        "\uBD88\uACF5\uC815\uD55C \uC774\uC810\uC744 \uC5BB\uAE30 \uC704\uD574 \uC5EC\uB7EC \uACC4\uC815\uC744 \uB9CC\uB4E4\uC9C0 \uB9C8\uC138\uC694",
        "\uBC84\uADF8\uC640 \uCDE8\uC57D\uC810\uC744 \uC800\uC790\uC5D0\uAC8C \uBCF4\uACE0\uD558\uC138\uC694"
      ]
    },
    disclaimer: {
      title: "5. \uBA74\uCC45 \uC870\uD56D",
      description: '\uAC8C\uC784\uC740 \uBCF4\uC99D \uC5C6\uC774 "\uC788\uB294 \uADF8\uB300\uB85C" \uC81C\uACF5\uB429\uB2C8\uB2E4. \uC800\uC790\uB294 \uAC8C\uC784 \uC0AC\uC6A9\uC73C\uB85C \uC778\uD55C \uC190\uC2E4\uC774\uB098 \uC190\uD574\uC5D0 \uB300\uD574 \uCC45\uC784\uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.'
    },
    changes: {
      title: "6. \uB3D9\uC758 \uBCC0\uACBD",
      description: "\uC800\uC790\uB294 \uC5B8\uC81C\uB4E0\uC9C0 \uBCF8 \uB3D9\uC758 \uC870\uAC74\uC744 \uC218\uC815\uD560 \uAD8C\uB9AC\uB97C \uBCF4\uC720\uD569\uB2C8\uB2E4. \uBCC0\uACBD \uD6C4 \uACC4\uC18D \uC0AC\uC6A9\uD558\uB294 \uAC83\uC740 \uC0C8\uB85C\uC6B4 \uC870\uAC74\uC5D0 \uB300\uD55C \uADC0\uD558\uC758 \uB3D9\uC758\uB97C \uC758\uBBF8\uD569\uB2C8\uB2E4."
    },
    copyright: "\xA9 2026 SheshDash. \uBAA8\uB4E0 \uAD8C\uB9AC \uBCF4\uC720.",
    author: "\uAC1C\uBC1C\uC790: Vadim Maltsev",
    prohibited: {
      title: "\uAE08\uC9C0 \uD589\uC704",
      items: [
        "\uAC8C\uC784\uC744 \uBCF5\uC81C, \uC7AC\uD604 \uB610\uB294 \uBC30\uD3EC\uD558\uB294 \uD589\uC704",
        "\uD074\uB860, \uC218\uC815 \uB610\uB294 2\uCC28 \uC800\uC791\uBB3C\uC744 \uB9CC\uB4DC\uB294 \uD589\uC704",
        "\uAC8C\uC784\uC758 \uCF54\uB4DC, \uB514\uC790\uC778, \uBA54\uCEE4\uB2C8\uC998 \uB610\uB294 \uADDC\uCE59\uC744 \uC0AC\uC6A9\uD558\uB294 \uD589\uC704",
        "\uAC8C\uC784 \uB610\uB294 \uC77C\uBD80\uB97C \uC790\uC2E0\uC758 \uC774\uB984\uC73C\uB85C \uC6B4\uC601\uD558\uB294 \uD589\uC704"
      ]
    },
    exclusiveRights: {
      title: "\uB3C5\uC810\uC801 \uAD8C\uB9AC",
      description: "\uAC8C\uC784\uC5D0 \uB300\uD55C \uBAA8\uB4E0 \uB3C5\uC810\uC801 \uAD8C\uB9AC\uB294 \uAD8C\uB9AC\uC790\uC5D0\uAC8C \uADC0\uC18D\uB429\uB2C8\uB2E4."
    },
    legalInfo: {
      title: "\uBC95\uC801 \uC815\uBCF4",
      description: "SheshDash\uB294 \uB3C5\uC810(\uD504\uB85C\uD504\uB77C\uC774\uC5B4\uD130\uB9AC) \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC785\uB2C8\uB2E4. \uAD8C\uB9AC\uC790\uC758 \uC11C\uBA74 \uB3D9\uC758 \uC5C6\uC774 \uBCF5\uC81C, \uBC30\uD3EC \uB610\uB294 \uC218\uC815\uD558\uB294 \uAC83\uC740 \uAE08\uC9C0\uB429\uB2C8\uB2E4."
    }
  },
  navigation: {
    backToHome: "\uD648\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30"
  },
  donate: {
    title: "\uD504\uB85C\uC81D\uD2B8 \uD6C4\uC6D0",
    thankYou: "\uD6C4\uC6D0\uD574 \uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4!",
    description: "SheshDash\uB294 \uC778\uB514 \uD504\uB85C\uC81D\uD2B8\uC785\uB2C8\uB2E4. \uD6C4\uC6D0\uC740 \uC11C\uBC84 \uC720\uC9C0\uC640 \uC2E0\uADDC \uAE30\uB2A5 \uAC1C\uBC1C\uC5D0 \uB3C4\uC6C0\uC774 \uB429\uB2C8\uB2E4.",
    waysToSupport: "\uB2E4\uB978 \uBC29\uBC95\uC73C\uB85C \uB3D5\uAE30",
    spreadWord: "\uC54C\uB824 \uC8FC\uC138\uC694",
    spreadWordDesc: "SheshDash\uB97C \uCE5C\uAD6C\uC640 \uAC00\uC871\uC5D0\uAC8C \uC18C\uAC1C\uD574 \uC8FC\uC138\uC694.",
    reportBugs: "\uBC84\uADF8 \uC2E0\uACE0",
    reportBugsDesc: "\uBC1C\uACAC\uD55C \uBB38\uC81C\uB97C \uC54C\uB824 \uC8FC\uC2DC\uBA74 \uAC1C\uC120\uC5D0 \uB3C4\uC6C0\uC774 \uB429\uB2C8\uB2E4.",
    suggestFeatures: "\uAE30\uB2A5 \uC81C\uC548",
    suggestFeaturesDesc: "\uC544\uC774\uB514\uC5B4\uAC00 \uC788\uB098\uC694? \uBCF4\uACE0 \uC2F6\uC740 \uAE30\uB2A5\uC744 \uC54C\uB824 \uC8FC\uC138\uC694.",
    chooseCountry: "\uAC70\uC8FC \uC9C0\uC5ED",
    countryHelp: "\uC9C0\uC5ED\uBCC4 \uD569\uBC95\uC801\uC778 \uC635\uC158\uC744 \uBCF4\uC5EC \uC90D\uB2C8\uB2E4. \uC0AC\uC6A9 \uBD88\uAC00\uD55C \uACBD\uC6B0 \uD50C\uB7AB\uD3FC\uC774 \uC548\uB0B4\uD569\uB2C8\uB2E4.",
    countryRussia: "\uB7EC\uC2DC\uC544",
    countryInternational: "\uAE30\uD0C0 \uAD6D\uAC00",
    optionsTitle: "Boosty\uB85C \uD6C4\uC6D0\uD558\uAE30",
    platformBoostyTitle: "Boosty",
    platformBoostyDesc: "\uBA64\uBC84\uC2ED/\uC77C\uD68C\uC131 \uD6C4\uC6D0; \uB7EC\uC2DC\uC544 \uCE74\uB4DC\uB85C \uC815\uC0B0.",
    platformCloudtipsTitle: "CloudTips",
    platformCloudtipsDesc: "\uD06C\uB9AC\uC5D0\uC774\uD130 \uD6C4\uC6D0/\uAD6C\uB3C5; \uB7EC\uC2DC\uC544 \uCE74\uB4DC\uB85C \uC815\uC0B0.",
    platformDonationAlertsTitle: "DonationAlerts",
    platformDonationAlertsDesc: "\uC2A4\uD2B8\uB9AC\uBC0D \uD6C4\uC6D0\uC6A9; \uBC29\uC1A1\uD558\uB294 \uACBD\uC6B0\uC5D0 \uC801\uD569.",
    platformPatreonTitle: "Patreon",
    platformPatreonDesc: "\uBA64\uBC84\uC2ED \uD6C4\uC6D0. \uC77C\uBD80 \uAD6D\uAC00(\uB7EC\uC2DC\uC544 \uD3EC\uD568)\uC5D0\uC11C\uB294 \uC815\uC0B0 \uBD88\uAC00.",
    platformBmacTitle: "Buy Me a Coffee",
    platformBmacDesc: "Stripe\uB97C \uD1B5\uD55C \uC77C\uD68C/\uC815\uAE30 \uD6C4\uC6D0; \uAD6D\uAC00\uBCC4\uB85C \uC0C1\uC774.",
    platformKofiTitle: "Ko-fi",
    platformKofiDesc: "Stripe/PayPal \uAE30\uBC18; \uAD6D\uAC00\uBCC4\uB85C \uC0C1\uC774.",
    platformGithubTitle: "GitHub Sponsors",
    platformGithubDesc: "\uC624\uD508\uC18C\uC2A4 \uD504\uB85C\uC81D\uD2B8\uC774\uBA70 \uC9C0\uC6D0 \uC9C0\uC5ED\uC77C \uACBD\uC6B0.",
    statusSetup: "\uC124\uC815 \uC911",
    statusCheckCountry: "\uC0AC\uC6A9 \uAC00\uB2A5 \uC5EC\uBD80 \uD655\uC778",
    statusStreaming: "\uC2A4\uD2B8\uB9AC\uBC0D \uC804\uC6A9",
    availabilityNote: "\uAD6D\uAC00\uC5D0\uC11C \uC9C0\uC6D0\uB418\uC9C0 \uC54A\uC73C\uBA74 \uD50C\uB7AB\uD3FC\uC774 \uD6C4\uC6D0\uC744 \uB9C9\uC2B5\uB2C8\uB2E4.",
    boostyTitle: "Boosty",
    boostyDesc: "\uC77C\uD68C\uC131 \uB610\uB294 \uC815\uAE30 \uD6C4\uC6D0. \uACB0\uC81C\uB294 Boosty\uC5D0\uC11C \uCC98\uB9AC\uB429\uB2C8\uB2E4.",
    boostyButton: "Boosty \uC5F4\uAE30",
    boostyQrAlt: "Boosty \uD6C4\uC6D0 QR \uCF54\uB4DC",
    boostyQrHint: "QR\uC744 \uC2A4\uCE94\uD558\uC5EC Boosty\uB97C \uC5EC\uC138\uC694."
  },
  account: {
    title: "\uACC4\uC815",
    loginTitle: "\uB85C\uADF8\uC778",
    loginDesc: "\uB85C\uADF8\uC778\uD558\uC5EC \uD1B5\uACC4\uC640 \uAC8C\uC784 \uAE30\uB85D\uC744 \uD655\uC778\uD558\uC138\uC694.",
    loginGoogle: "Google\uB85C \uB85C\uADF8\uC778",
    loginTelegram: "Telegram\uC73C\uB85C \uB85C\uADF8\uC778",
    playAsGuest: "\uAC8C\uC2A4\uD2B8\uB85C \uD50C\uB808\uC774",
    settings: "\uACC4\uC815 \uC124\uC815",
    displayName: "\uD45C\uC2DC \uC774\uB984",
    save: "\uC800\uC7A5",
    saved: "\uC800\uC7A5\uB428!",
    logout: "\uB85C\uADF8\uC544\uC6C3",
    logoutConfirm: "\uC815\uB9D0 \uB85C\uADF8\uC544\uC6C3\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
    linkedAccounts: "\uC5F0\uACB0\uB41C \uACC4\uC815",
    memberSince: "\uAC00\uC785\uC77C",
    dangerZone: "\uC704\uD5D8 \uAD6C\uC5ED",
    deleteAccount: "\uACC4\uC815 \uC0AD\uC81C",
    preferredColor: "\uC120\uD638 \uC0C9\uC0C1"
  },
  profile: {
    title: "\uD50C\uB808\uC774\uC5B4 \uD504\uB85C\uD544",
    player: "\uD50C\uB808\uC774\uC5B4",
    gamesPlayed: "\uD50C\uB808\uC774\uD55C \uAC8C\uC784",
    wins: "\uC2B9\uB9AC",
    winRate: "\uC2B9\uB960",
    secondPlace: "2\uC704",
    thirdPlace: "3\uC704",
    fourthPlace: "4\uC704",
    matchHistory: "\uB9E4\uCE58 \uAE30\uB85D",
    noMatches: "\uC544\uC9C1 \uB9E4\uCE58\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
    placement: "\uC21C\uC704",
    date: "\uB0A0\uC9DC",
    players: "\uD50C\uB808\uC774\uC5B4",
    loadMore: "\uB354 \uBCF4\uAE30"
  },
  leaderboard: {
    title: "\uCD5C\uACE0\uC758 \uD50C\uB808\uC774\uC5B4",
    rank: "#",
    player: "\uD50C\uB808\uC774\uC5B4",
    wins: "\uC2B9\uB9AC",
    games: "\uAC8C\uC784",
    winRate: "\uC2B9\uB960",
    noData: "\uC544\uC9C1 \uAC8C\uC784\uC774 \uC9C4\uD589\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4."
  },
  lobby: {
    onlinePlayers: "\uC628\uB77C\uC778 \uD50C\uB808\uC774\uC5B4",
    waitingGames: "\uACF5\uAC1C \uAC8C\uC784",
    findMatch: "\uC628\uB77C\uC778 \uAC8C\uC784 \uCC3E\uAE30",
    cancelMatch: "\uAC80\uC0C9 \uCDE8\uC18C",
    searching: "\uD50C\uB808\uC774\uC5B4\uB97C \uCC3E\uB294 \uC911...",
    queueCount: "\uB300\uAE30\uC5F4 \uD50C\uB808\uC774\uC5B4: {{count}} / 4",
    onlineCount: "\uC628\uB77C\uC778 \uD50C\uB808\uC774\uC5B4: {{count}}",
    join: "\uCC38\uAC00",
    creator: "\uC0DD\uC131\uC790",
    noGames: "\uCC38\uAC00 \uAC00\uB2A5\uD55C \uACF5\uAC1C \uAC8C\uC784\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
    botsOfferTitle: "\uC9C0\uAE08 \uBD07\uACFC \uC2DC\uC791\uD560\uAE4C\uC694?",
    botsOfferText: "{{count}}\uBA85\uC758 \uD50C\uB808\uC774\uC5B4\uAC00 \uBD80\uC871\uD569\uB2C8\uB2E4. \uC9C0\uAE08 \uC2DC\uC791\uD558\uACE0 \uB098\uBA38\uC9C0\uB294 \uBD07\uC73C\uB85C \uCC44\uC6C1\uB2C8\uB2E4.",
    startWithBots: "\uBD07\uACFC \uC2DC\uC791",
    keepWaiting: "\uACC4\uC18D \uB300\uAE30"
  },
  skin: {
    human: "\uC0AC\uB78C",
    guest: "\uAC8C\uC2A4\uD2B8",
    gameStatus: "\uAC8C\uC784 \uC0C1\uD0DC",
    gameInProgress: "\uAC8C\uC784 \uC9C4\uD589 \uC911...",
    gameLog: "\uAC8C\uC784 \uB85C\uADF8",
    noEvents: "\uC544\uC9C1 \uC774\uBCA4\uD2B8 \uC5C6\uC74C",
    waitingForEvents: "\uAC8C\uC784 \uC774\uBCA4\uD2B8 \uB300\uAE30 \uC911...",
    gamePaused: "\uAC8C\uC784 \uC77C\uC2DC\uC815\uC9C0..."
  },
  admin: {
    title: "\uAD00\uB9AC\uC790 \uD328\uB110",
    accessDenied: "\uAD00\uB9AC\uC790\uB9CC \uC811\uADFC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    goToAccount: "\uACC4\uC815\uC73C\uB85C",
    loadError: "\uAD00\uB9AC \uB370\uC774\uD130\uB97C \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4",
    announcement: {
      title: "\uC2DC\uC2A4\uD15C \uACF5\uC9C0",
      placeholder: '\uC608: "5\uBD84 \uD6C4 \uAC8C\uC784 \uC5C5\uB370\uC774\uD2B8"',
      preview: "\uBBF8\uB9AC\uBCF4\uAE30",
      publishNow: "\uC9C0\uAE08 \uAC8C\uC2DC",
      startTime: "\uC2DC\uC791 \uC2DC\uAC04",
      endTime: "\uC885\uB8CC \uC2DC\uAC04 (\uC120\uD0DD)",
      publish: "\uAC8C\uC2DC",
      publishing: "\uAC8C\uC2DC \uC911...",
      deactivate: "\uBE44\uD65C\uC131\uD654",
      deactivateConfirm: "\uD604\uC7AC \uACF5\uC9C0\uB97C \uBE44\uD65C\uC131\uD654\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
      message: "\uBA54\uC2DC\uC9C0",
      status: "\uC0C1\uD0DC",
      timeWindow: "\uAE30\uAC04",
      noEndTime: "\uC885\uB8CC \uC5C6\uC74C",
      active: "\uD65C\uC131",
      inactive: "\uBE44\uD65C\uC131"
    },
    users: {
      title: "\uD50C\uB808\uC774\uC5B4",
      player: "\uD50C\uB808\uC774\uC5B4",
      email: "\uC774\uBA54\uC77C",
      role: "\uC5ED\uD560",
      ban: "\uCC28\uB2E8",
      banned: "\uCC28\uB2E8\uB428",
      active: "\uD65C\uC131"
    },
    markdown: {
      bold: "\uAD75\uC740 \uD14D\uC2A4\uD2B8",
      italic: "\uAE30\uC6B8\uC784",
      code: "\uCF54\uB4DC",
      link: "\uB9C1\uD06C",
      listItem: "\uD56D\uBAA9"
    },
    news: {
      title: "\uBA54\uC778 \uD398\uC774\uC9C0 \uC18C\uC2DD",
      versionLabel: "\uBC84\uC804",
      versionPlaceholder: "\uC608: 0.0.26",
      contentLabel: "\uAD6C\uD604\uB41C \uB0B4\uC6A9",
      contentPlaceholder: "\uC774 \uBC84\uC804\uC5D0 \uD3EC\uD568\uB41C \uB0B4\uC6A9\uC744 \uC124\uBA85\uD558\uC138\uC694.",
      publishLabel: "\uBA54\uC778 \uD398\uC774\uC9C0\uC5D0 \uD45C\uC2DC",
      preview: "\uBBF8\uB9AC\uBCF4\uAE30",
      create: "\uC18C\uC2DD \uB9CC\uB4E4\uAE30",
      update: "\uBCC0\uACBD \uC0AC\uD56D \uC800\uC7A5",
      saving: "\uC800\uC7A5 \uC911...",
      cancelEdit: "\uCDE8\uC18C",
      edit: "\uD3B8\uC9D1",
      delete: "\uC0AD\uC81C",
      deleteConfirm: "\uC774 \uC18C\uC2DD\uC744 \uC0AD\uC81C\uD560\uAE4C\uC694?",
      published: "\uAC8C\uC2DC\uB428",
      draft: "\uCD08\uC548",
      empty: "\uC544\uC9C1 \uC18C\uC2DD\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
      hideBlockLabel: "\uC804\uCCB4 \uB274\uC2A4 \uBE14\uB85D \uC228\uAE30\uAE30",
      hideItemLabel: "\uC774 \uB274\uC2A4 \uC228\uAE30\uAE30",
      hidden: "\uC228\uAE40",
      subtitle: "\uB274\uC2A4 \uBCF8\uBB38\uC740 \uC774\uC81C \uC800\uC7A5\uC18C \uC548\uC758 \uBC84\uC804 \uAD00\uB9AC \uD30C\uC77C\uC5D0\uC11C \uAC00\uC838\uC635\uB2C8\uB2E4.",
      fileBasedHint: "\uBA54\uC778 \uD398\uC774\uC9C0 \uB274\uC2A4 \uBB38\uAD6C\uB97C \uBC14\uAFB8\uB824\uBA74 \uC800\uC7A5\uC18C \uC548\uC758 \uC5B8\uC5B4\uBCC4 \uB274\uC2A4 \uD30C\uC77C\uC744 \uC9C1\uC811 \uC218\uC815\uD558\uC138\uC694."
    }
  },
  news: {
    title: "\uAC8C\uC784 \uC18C\uC2DD",
    subtitle: "\uAC01 \uBC84\uC804\uC5D0 \uC5B4\uB5A4 \uAE30\uB2A5\uC774 \uAD6C\uD604\uB418\uC5C8\uB294\uC9C0 \uBCF4\uC5EC\uC90D\uB2C8\uB2E4.",
    empty: "\uC544\uC9C1 \uC18C\uC2DD\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
  },
  settings: {
    soundOn: "\uC0AC\uC6B4\uB4DC \uCF1C\uC9D0",
    soundOff: "\uC0AC\uC6B4\uB4DC \uAEBC\uC9D0"
  }
};

// src/i18n/index.ts
var locales = {
  en: en_default,
  ru: ru_default,
  de: de_default,
  es: es_default,
  it: it_default,
  zh: zh_default,
  ja: ja_default,
  fr: fr_default,
  ko: ko_default
};
var supportedLanguages = ["en", "ru", "de", "es", "it", "zh", "ja", "fr", "ko"];
var LANGUAGE_STORAGE_KEY = "language";
var LANGUAGE_COOKIE_KEY = "language";
var getSavedLanguage = () => {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(LANGUAGE_STORAGE_KEY);
};
var saveLanguage = (lang) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  document.cookie = `${LANGUAGE_COOKIE_KEY}=${encodeURIComponent(lang)}; Path=/; Max-Age=31536000; SameSite=Lax`;
};
var getBrowserLanguage = () => {
  if (typeof window === "undefined") return "en";
  return navigator.language.split("-")[0];
};
var getDefaultLanguage = () => {
  const saved = getSavedLanguage();
  if (saved && supportedLanguages.includes(saved)) {
    return saved;
  }
  const browser = getBrowserLanguage();
  if (supportedLanguages.includes(browser)) {
    return browser;
  }
  return "en";
};
var i18nResources = {
  en: { translation: en_default },
  ru: { translation: ru_default },
  de: { translation: de_default },
  es: { translation: es_default },
  it: { translation: it_default },
  zh: { translation: zh_default },
  ja: { translation: ja_default },
  fr: { translation: fr_default },
  ko: { translation: ko_default }
};
export {
  LANGUAGE_COOKIE_KEY,
  LANGUAGE_STORAGE_KEY,
  THEME_STORAGE_KEY,
  de_default as de,
  en_default as en,
  es_default as es,
  fr_default as fr,
  getBrowserLanguage,
  getDefaultLanguage,
  getSavedLanguage,
  getSavedThemeId,
  getThemeById,
  i18nResources,
  it_default as it,
  ja_default as ja,
  ko_default as ko,
  locales,
  ru_default as ru,
  saveLanguage,
  saveThemeId,
  supportedLanguages,
  themes,
  zh_default as zh
};
//# sourceMappingURL=index.mjs.map